webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _tools = __webpack_require__(7);

var _tools2 = _interopRequireDefault(_tools);

var _data = __webpack_require__(2);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = __webpack_require__(5);

exports.default = {
    getAll: function getAll(context, callback) {
        context.$root.$emit('loading', true);
        context.$http.get(config.api_url + "quizzes").then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    getAllMyQuizzes: function getAllMyQuizzes(context, callback) {
        context.$root.$emit('loading', true);
        context.$http.get(config.api_url + "users/" + _data2.default.data.session.userId + "/quizzes").then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    getBySlug: function getBySlug(context, slug, callback) {
        context.$root.$emit('loading', true);
        context.$http.get(config.api_url + "quizzes/" + slug).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    getQuestions: function getQuestions(context, slug, callback) {
        context.$root.$emit('loading', true);
        context.$http.get(config.api_url + "quizzes/" + slug + "/questions").then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    getAnalysis: function getAnalysis(context, slug, callback) {
        context.$root.$emit('loading', true);
        context.$http.get(config.api_url + "quizzes/" + slug + "/analysis").then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    getResponses: function getResponses(context, slug, callback) {
        context.$root.$emit('loading', true);
        context.$http.get(config.api_url + "quizzes/" + slug + "/responses").then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    getPreconizations: function getPreconizations(context, slug, callback) {
        context.$root.$emit('loading', true);
        context.$http.get(config.api_url + "quizzes/" + slug + "/preconizations").then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    getPreconizationById: function getPreconizationById(context, slug, id, callback) {
        context.$root.$emit('loading', true);
        context.$http.get(config.api_url + "quizzes/" + slug + "/preconizations/" + id).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    create: function create(context, quiz, callback) {
        context.$root.$emit('loading', true);
        var groups = quiz.groups;
        context.$http.post(config.api_url + "quizzes", quiz).then(function (response) {
            context.$root.$emit('loading', false);
            callback(response.data, null);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    updateBySlug: function updateBySlug(context, slug, quiz, callback) {
        context.$root.$emit('loading', true);
        context.$http.patch(config.api_url + "quizzes/" + slug, quiz).then(function (response) {
            context.$root.$emit('loading', false);
            callback(response.data, null);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    createQuestions: function createQuestions(context, slug, questions, callback) {
        context.$root.$emit('loading', true);
        context.$http.post(config.api_url + "quizzes/" + slug + "/questions", questions).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    removeQuestionById: function removeQuestionById(context, slugQuiz, idQuestion, callback) {
        context.$root.$emit('loading', true);
        context.$http.delete(config.api_url + "quizzes/" + slugQuiz + "/questions/" + idQuestion).then(function (response) {
            callback(null); // response.data = null;
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(_tools2.default.translate(response.data));
        });
    },
    removeBySlug: function removeBySlug(context, slug, callback) {
        context.$root.$emit('loading', true);
        context.$http.delete(config.api_url + "quizzes/" + slug).then(function (response) {
            // console.log("REMOVE QUIZZ BY SLUG",response.data);
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            console.log("REMOVE QUIZZ BY SLUG ERR", response.data);
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    createResponses: function createResponses(context, slug, responses, callback) {
        context.$root.$emit('loading', true);
        context.$http.post(config.api_url + "quizzes/" + slug + "/responses", responses).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    updateAnalysis: function updateAnalysis(context, slug, analysis, callback) {
        context.$root.$emit('loading', true);
        context.$http.put(config.api_url + "quizzes/" + slug + "/analysis", analysis).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    createAnalysis: function createAnalysis(context, slug, analysis, callback) {
        context.$root.$emit('loading', true);
        context.$http.post(config.api_url + "quizzes/" + slug + "/analysis", analysis).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    updatePreconizationById: function updatePreconizationById(context, slug, id, preconization, callback) {
        context.$root.$emit('loading', true);
        context.$http.put(config.api_url + "quizzes/" + slug + "/preconizations/" + id, preconization).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    createPreconization: function createPreconization(context, slug, preconization, callback) {
        context.$root.$emit('loading', true);
        context.$http.post(config.api_url + "quizzes/" + slug + "/preconizations", preconization).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    removePreconizationById: function removePreconizationById(context, slugQuiz, idPreconization, callback) {
        context.$root.$emit('loading', true);
        context.$http.delete(config.api_url + "quizzes/" + slugQuiz + "/preconizations/" + idPreconization).then(function (response) {
            callback(null); // response.data = null;
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(_tools2.default.translate(response.data));
        });
    },
    duplicateBySlug: function duplicateBySlug(context, slugQuiz, newTitle, callback) {
        context.$root.$emit('loading', true);
        context.$http.post(config.api_url + "quizzes/" + slugQuiz + "/duplicate/" + newTitle).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    exportPDF: function exportPDF(context, slugQuiz, html, callback) {
        context.$root.$emit('loading', true);
        context.$http.post(config.api_url + "quizzes/" + slugQuiz + "/exportPDF", { html: html }).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(8);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var users = __webpack_require__(4).default;
var config = __webpack_require__(5);

var date_now = new Date();
var data = {
  user: {},
  session: {
    userId: null,
    id: null,
    authenticated: false,
    ttl: null
  },
  timeout: null,
  lastUpdate: date_now
};

if (localStorage.getItem('data')) {
  data = JSON.parse(localStorage.getItem('data'));
  if (!data.lastUpdate) data.lastUpdate = new Date();

  // Remettre un timeout pour la déco automatique. Calculer le temps restant du token.
  var created_at = new Date(data.session.created);
  var now = new Date();
  var msDiff = now - created_at;
  var ttl = data.session.ttl * 1000; // Pour mettre en ms.
  var timeout = ttl - msDiff;
  if (timeout > 0) {
    data.timeout = setTimeout(function () {
      _App2.default.methods.logout();
    }, timeout);
  }
}

exports.default = {
  data: data,
  refreshToken: function refreshToken(ctx) {
    // Ajouter 1h au timeout s'il n'a pas déjà était update il y a moins de 1h
    var now = new Date();

    // On update seulement si le TTL n'a pas déjà était mise à jour dans l'heure.
    var msDiffLastUpdate = now - new Date(this.data.lastUpdate);
    if (msDiffLastUpdate >= config.refreshToken * 1000) {
      //3600 sec = 1h min soit 3600000 ms.
      this.data.lastUpdate = now;
      var parent = this;
      var newTTL = 3 * config.refreshToken; // 3600sec = 1h ! *3 On remet la durée du token à 3h.
      console.log("UPDATE TOKEN");
      users.updateToken(ctx, newTTL, function (accessToken, err) {
        if (err) {
          console.log("ERR REFRESH TOKEN", err);
          _App2.default.methods.logout();
        } else {
          parent.data.session.ttl = accessToken.ttl;
          var ttl = parent.data.session.ttl * 1000; // Pour mettre en ms.
          // var created_at = new Date(parent.data.session.created);
          // var msDiff = now - created_at;
          // var timeout = ttl - msDiff;
          if (ttl > 0) {
            clearTimeout(parent.data.timeout);
            parent.data.timeout = setTimeout(function () {
              _App2.default.methods.logout();
            }, ttl);
          }
          localStorage.setItem('data', JSON.stringify(parent.data));
        }
      });
    }
  },
  login: function login(ctx, emailOrUsername, password, callback) {
    var parent = this;
    var credentials = {
      email: emailOrUsername,
      password: password
    };

    users.login(ctx, credentials, function (data, err) {
      if (data) {
        parent.data.session = data.session;
        parent.data.session["authenticated"] = true;
        parent.data.user = data.user;
        localStorage.setItem('data', JSON.stringify(parent.data));
        callback();
      } else if (err) {
        // Tenter la connexion avec email = username
        credentials = {
          username: emailOrUsername,
          password: password
        };
        users.login(ctx, credentials, function (data, err) {
          var msg_error = "Erreur inconnue.";
          if (data) {
            msg_error = null;
            parent.data.session = data.session;
            parent.data.session["authenticated"] = true;
            parent.data.user = data.user;
            localStorage.setItem('data', JSON.stringify(parent.data));
            // parent.data.session.ttl = (data.ttl * 1000)-600000; // 600000 = -10min
            parent.data.timeout = setTimeout(function () {
              _App2.default.methods.logout();
            }, data.session.ttl * 1000);
          } else if (err) {
            msg_error = err;
          }
          callback(msg_error);
        });
      } else {
        callback("Erreur inconnue.");
      }
    });
  },
  logout: function logout() {
    this.data.user = {};
    this.data.session = {
      userId: null,
      id: null,
      authenticated: false,
      ttl: null
    };
    clearTimeout(this.data.timeout);
    _vue2.default.http.headers.common['Authorization'] = "";
    localStorage.setItem('data', JSON.stringify(this.data));
  }
};

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _login$verifyPassword;

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _tools = __webpack_require__(7);

var _tools2 = _interopRequireDefault(_tools);

var _data = __webpack_require__(2);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var config = __webpack_require__(5);

exports.default = (_login$verifyPassword = {
    login: function login(context, credentials, callback) {
        context.$root.$emit('loading', true);
        context.$http.post(config.api_url + "users/login", credentials).then(function (response) {
            var rep = { session: response.data };
            _vue2.default.http.headers.common['Authorization'] = response.data.id;
            context.$http.get(config.api_url + "users/" + response.data.userId).then(function (resp) {
                rep["user"] = resp.data;
                context.$root.$emit('loading', false);
                callback(rep, null);
            }, function (resp) {
                context.$root.$emit('loading', false);
                callback(null, _tools2.default.translate(resp.data));
            });
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    verifyPassword: function verifyPassword(context, credentials, callback) {
        context.$root.$emit('loading', true);
        context.$http.post(config.api_url + "users/login", credentials).then(function (response) {
            context.$root.$emit('loading', false);
            callback(true);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(false);
        });
    },
    changePassword: function changePassword(context, credentials, callback) {
        // credentials = oldPassword & newPassword
        context.$root.$emit('loading', true);
        context.$http.post(config.api_url + "users/change-password", credentials).then(function (response) {
            context.$root.$emit('loading', false);
            callback(null);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(_tools2.default.translate(response.data));
        });
    },
    reset: function reset(context, email, callback) {
        context.$root.$emit('loading', true);
        var data = { email: email };
        context.$http.post(config.api_url + "users/reset", data).then(function (response) {
            context.$root.$emit('loading', false);
            callback(response.data);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(_tools2.default.translate(response.data));
        });
    },
    resetPassword: function resetPassword(context, newPassword, token, callback) {
        context.$root.$emit('loading', true);
        var data = { newPassword: newPassword };
        _vue2.default.http.headers.common['Authorization'] = token;
        context.$http.post(config.api_url + "users/reset-password", data).then(function (response) {
            context.$root.$emit('loading', false);
            callback(response.data);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(_tools2.default.translate(response.data));
        });
    },
    updateById: function updateById(context, id, data, callback) {
        context.$root.$emit('loading', true);
        context.$http.patch(config.api_url + "users/" + id, data).then(function (response) {
            context.$root.$emit('loading', false);
            callback(response.data, null);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, response.data);
        });
    },
    getAll: function getAll(context, callback) {
        context.$root.$emit('loading', true);
        context.$http.get(config.api_url + "users").then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    getById: function getById(context, id, callback) {
        context.$root.$emit('loading', true);
        context.$http.get(config.api_url + "users/" + id).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    },
    create: function create(context, user, callback) {
        context.$root.$emit('loading', true);
        context.$http.post(config.api_url + "users", user).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    }
}, _defineProperty(_login$verifyPassword, 'updateById', function updateById(context, id, user, callback) {
    context.$root.$emit('loading', true);
    context.$http.patch(config.api_url + "users/" + id, user).then(function (response) {
        callback(response.data, null);
        context.$root.$emit('loading', false);
    }, function (response) {
        context.$root.$emit('loading', false);
        callback(null, _tools2.default.translate(response.data));
    });
}), _defineProperty(_login$verifyPassword, 'getGroups', function getGroups(context, callback) {
    context.$root.$emit('loading', true);
    context.$http.get(config.api_url + "users/" + _data2.default.data.session.userId + "/groups").then(function (response) {
        callback(response.data, null);
        context.$root.$emit('loading', false);
    }, function (response) {
        context.$root.$emit('loading', false);
        callback(null, _tools2.default.translate(response.data));
    });
}), _defineProperty(_login$verifyPassword, 'updateToken', function updateToken(context, newTTL, callback) {
    var data = { ttl: newTTL };
    context.$http.put(config.api_url + "users/" + _data2.default.data.session.userId + "/accessTokens/" + _data2.default.data.session.id, data).then(function (response) {
        callback(response.data, null);
    }, function (response) {
        callback(null, _tools2.default.translate(response.data));
    });
}), _login$verifyPassword);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = {
	"api_url": "https://migration.transferhlediagrh.fr/api/",
	"front_url": "http://migration.transferhlediagrh.fr/",
	"refreshToken": 3600,
	"version": "1.1.3"
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(60)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(113),
  /* scopeId */
  "data-v-58ee1e80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tools = function () {
  function Tools() {
    _classCallCheck(this, Tools);
  }

  _createClass(Tools, null, [{
    key: "translate",
    value: function translate(data) {

      var translateMsg = function translateMsg(msg_error) {
        var msg = "";
        if (msg_error.indexOf("`password` can't be blank") > 0) {
          msg += "<br> - Mot de passe manquant.";
        }
        if (msg_error.indexOf("Email already exists") > 0) {
          msg += "<br> - Adresse email déjà utilisée.";
        }
        if (msg_error.indexOf("User already exists") > 0) {
          msg += "<br> - Username déjà utilisée.";
        }
        if (msg_error.indexOf("Ce titre est déjà utilisé") > 0) {
          msg += "<br> - Ce titre est déjà utilisé.";
        }
        if (msg_error.indexOf("Ce nom de groupe est déjà utilisé") > 0) {
          msg += "<br> - Ce nom de groupe est déjà utilisé.";
        }
        if (msg == "") {
          msg = msg_error;
        }
        return msg;
      };

      console.log("translate error", data);
      if (data.error) {

        var checkDetailsError = function checkDetailsError(data) {
          var msg = "";
          if (data.error.details) {
            if (Array.isArray(data.error.details)) {
              for (var d = 0; d < data.error.details.length; d++) {
                msg += msg != "" ? "<br>" : "";
                if (data.error.details[d].message) {
                  msg += translateMsg(data.error.details[d].message);
                }
                return msg;
              }
            } else {
              if (data.error.details.messages) {
                var keys = Object.keys(data.error.details.messages);
                for (var p = 0; p < keys.length; p++) {
                  if (Array.isArray(data.error.details.messages[keys[p]])) {
                    for (var a = 0; a < data.error.details.messages[keys[p]].length; a++) {
                      msg += msg != "" ? "<br>" : "";
                      msg += translateMsg(data.error.details.messages[keys[p]][a]);
                    }
                  } else {
                    msg += translateMsg(data.error.details.messages[keys[p]]);
                  }
                }
              }
            }
          }
          return msg;
        };

        switch (data.error.code) {
          case 'LOGIN_FAILED':
            return "Erreur identifiants incorrects.";
            break;
          case 'INVALID_PASSWORD':
            return "Mot de passe invalide.";
            break;
          default:
            switch (data.error.statusCode) {
              case 422:
                var msg = "Erreur dans la saisie des données.";
                var msg_detail = checkDetailsError(data);
                if (msg_detail != "") return msg_detail;
                if (data.error.message) {
                  translateMsg(data.error.message);
                }
                return msg;
                break;
              default:
                var msg_detail = checkDetailsError(data);
                if (msg_detail != "") return msg_detail;
                if (data.error.message) {
                  return data.error.message;
                }
                return "Erreur inconnue";
                break;
            }
            break;
        }
      }

      console.log("Translate ERROR - impossible : ", data);
      if (!data) {
        return "Le serveur est inaccessible. Veuillez réessayer plus tard, merci.";
      }
      return "Une erreur est survenue.";
    }
  }]);

  return Tools;
}();

exports.default = Tools;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(74)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(125),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quizzes = __webpack_require__(1);

var _quizzes2 = _interopRequireDefault(_quizzes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Quiz = function () {
  function Quiz(ctx, slugQuiz, number, callback) {
    _classCallCheck(this, Quiz);

    this.number = number;
    this.quiz = {};
    var parent = this;
    _quizzes2.default.getBySlug(ctx, slugQuiz, function (quiz, err) {
      if (quiz) {
        // Get les questions.
        _quizzes2.default.getQuestions(ctx, slugQuiz, function (questions, err_questions) {
          if (questions) {
            quiz["questions"] = questions;
            // Get les responses.
            _quizzes2.default.getResponses(ctx, slugQuiz, function (responses, err) {
              if (responses) {
                quiz["responses"] = responses;
                parent.quiz = quiz;
                parent.filters = quiz.groups;
                // console.log("GET QUIZ",quiz);
                callback(null, parent);
              } else {
                parent.quiz = quiz;
                console.log("err get responses", err);
                toastr.error("Impossible de récupérer les réponses.", "ERREUR");
                callback(true);
              }
            });
          } else {
            parent.quiz = quiz;
            console.log("err_questions", err_questions);
            toastr.error("Impossible de récupérer les questions du questionnaire.", "ERREUR");
            callback(true);
          }
        });
      } else {
        parent.quiz = null;
        console.log("err", err);
        toastr.error("Impossible de récupérer le questionnaire.", "ERREUR");
        callback(true);
      }
    });
  }

  _createClass(Quiz, [{
    key: "nbQuestionsOpenOutMultiple",
    value: function nbQuestionsOpenOutMultiple() {
      var nb = 0;
      if (this.quiz && this.quiz.questions) {
        for (var i = 0; i < this.quiz.questions.length; i++) {
          if (this.quiz.questions[i].type == "text") {
            nb++;
          }
        }
      }
      return nb;
    }
  }, {
    key: "nbQuestionsOpen",
    value: function nbQuestionsOpen() {
      var nb = 0;
      if (this.quiz && this.quiz.questions) {
        for (var i = 0; i < this.quiz.questions.length; i++) {
          if (this.quiz.questions[i].type == "text") {
            nb++;
          } else if ((this.quiz.questions[i].type == "checkbox_multiple" || this.quiz.questions[i].type == "radio_multiple") && this.quiz.questions[i].data) {
            for (var c = 0; c < this.quiz.questions[i].data.length; c++) {
              if (this.quiz.questions[i].data[c].question && this.quiz.questions[i].data[c].question.type == "text") {
                nb++;
              }
            }
          }
        }
      }
      return nb;
    }
  }, {
    key: "nbParticipants",
    value: function nbParticipants() {
      var nb = null;
      var infinity = false;
      if (this.quiz && this.quiz.groups) {
        nb = 0;
        for (var g = 0; g < this.quiz.groups.length; g++) {
          for (var f = 0; f < this.filters.length; f++) {
            if (this.filters[f].name == this.quiz.groups[g].name) {
              nb += this.quiz.groups[g].nb_participants;
              if (this.quiz.groups[g].nb_participants == 0) {
                infinity = true;
              }
            }
          }
        }
      }
      if (infinity) {
        if (nb != 0) {
          nb = "> " + nb;
        } else {
          nb = NaN;
        }
      }
      return nb;
    }
  }, {
    key: "nbResponses",
    value: function nbResponses() {
      // Retourner le nombre de réponse en fonction du filtre.

      var parent = this;
      var getGroup = function getGroup(groupId) {
        for (var g = 0; g < parent.quiz.groups.length; g++) {
          if (parent.quiz.groups[g].id.toString() == groupId.toString()) {
            return parent.quiz.groups[g].name;
          }
        }
      };

      var filterParticipants = function filterParticipants(groupId) {
        var groupName = getGroup(groupId);
        for (var f = 0; f < parent.filters.length; f++) {
          if (parent.filters[f].name == groupName) {
            return true;
          }
        }
        return false;
      };

      var count = 0;
      for (var r = 0; r < this.quiz.responses.length; r++) {
        if (filterParticipants(this.quiz.responses[r].groupId) === true) {
          count++;
        }
      }
      return count;
    }
  }, {
    key: "statsGroups",
    value: function statsGroups() {
      var dataProvider = [];
      for (var g = 0; g < this.quiz.groups.length; g++) {
        // On regarde le filtre !
        for (var f = 0; f < this.filters.length; f++) {
          if (this.filters[f].name == this.quiz.groups[g].name) {
            var nb_participants = 0;
            for (var g2 = 0; g2 < this.quiz.responses.length; g2++) {
              if (this.quiz.responses[g2].groupId && this.quiz.responses[g2].groupId.toString() == this.quiz.groups[g].id.toString()) {
                nb_participants++;
              }
            }
            dataProvider.push({ groupe: this.quiz.groups[g].name, participants: nb_participants });
          }
        }
      }
      return dataProvider;
    }
  }, {
    key: "majCategorie",
    value: function majCategorie(categories, nbResponseTotal, response, groupId) {
      var catName = response.noResponse ? "Ne se prononce pas" : response.value;
      for (var c = 0; c < categories.length; c++) {
        var isPresent = false;
        if (Array.isArray(catName)) {
          for (var a = 0; a < catName.length; a++) {
            if (categories[c].name == catName[a]) {
              isPresent = true;
            }
          }
        } else if (categories[c].name == catName) {
          isPresent = true;
        }
        if (isPresent) {
          var nb = nbResponseTotal * categories[c].y / 100; // On enlève le pourcentage.
          // console.log("nb",nb)
          nb += 1;
          for (var g = 0; g < categories[c].categories_groups.length; g++) {
            if (categories[c].categories_groups[g].id && groupId && categories[c].categories_groups[g].id.toString() == groupId.toString()) {
              categories[c].y2 = nb;
              categories[c].y = parseFloat(nb * 100 / nbResponseTotal); // On remet le pourcentage.
              categories[c].data_y2[g] = categories[c].data_y2[g] + 1;
            }
          }
        }
      }
      return categories;
    }
  }, {
    key: "statsResponses",
    value: function statsResponses(oneQuestion) {
      var parent = this;
      var calculsStats = function calculsStats(question, question_index, child_index, statsParent) {
        var categories = [];

        // Définir les categories pour chaque questions.
        var data_y = [];
        var data_y2 = []; // y2 = y mais sans pourcentage.
        for (var g = 0; g < parent.filters.length; g++) {
          data_y.push(0);
          data_y2.push(0);
        }

        var color_no_response = question.color_no_response ? question.color_no_response : "#00b0f0";
        categories.push({ name: "Ne se prononce pas", y: 0, y2: 0, data_y: data_y, data_y2: data_y2, categories_groups: parent.filters, color: color_no_response });
        if (question.type == "scale") {
          // Alors max et min.
          var min = question.min ? parseInt(question.min) : 0;
          var max = question.max ? parseInt(question.max) : 0;
          if (min > max) {
            var tmp = min;
            min = max;
            max = tmp;
          }
          var i = min;
          var c = 0;
          while (i <= max) {
            var data_y_copy = [];
            var data_y2_copy = [];
            data_y_copy = data_y_copy.concat(data_y);
            data_y2_copy = data_y2_copy.concat(data_y2);
            var color = question && question.colors && question.colors[c] ? question.colors[c] : null;
            categories.push({ name: i, y: 0, y2: 0, data_y: data_y_copy, data_y2: data_y2_copy, categories_groups: parent.filters, color: color });
            i++;
            c++;
          }
        } else {
          for (var d = 0; d < question.data.length; d++) {
            var data_y_copy = [];
            var data_y2_copy = [];
            data_y_copy = data_y_copy.concat(data_y);
            data_y2_copy = data_y2_copy.concat(data_y2);
            var color = question && question.data[d] && question.data[d].color ? question.data[d].color : null;
            categories.push({ name: question.data[d].name, y: 0, y2: 0, data_y: data_y_copy, data_y2: data_y2_copy, categories_groups: parent.filters, color: color });
          }
        }

        for (var r = 0; r < parent.quiz.responses.length; r++) {
          for (var qr = 0; qr < parent.quiz.responses[r].questions.length; qr++) {
            if (qr == question_index) {
              if (child_index != null && parent.quiz.responses[r].questions[qr].data) {
                for (var c = 0; c < parent.quiz.responses[r].questions[qr].data.length; c++) {
                  if (c == child_index) {
                    // On MAJ uniquement si la question a été remplie.
                    if (parent.quiz.responses[r].questions[qr].data[child_index].value !== "" || parent.quiz.responses[r].questions[qr].data[child_index].noResponse == true) {
                      // Envoyer le nombre de personne ayant répondu à la sous question. Correspondant au y réel des statsParent.
                      var y_real = statsParent[child_index] ? parent.quiz.responses.length * statsParent[child_index].y / 100 : 0; // On enlève le pourcentage.
                      parent.majCategorie(categories, y_real, parent.quiz.responses[r].questions[qr].data[child_index], parent.quiz.responses[r].groupId);
                    }
                  }
                }
              } else {
                parent.majCategorie(categories, parent.quiz.responses.length, parent.quiz.responses[r].questions[qr], parent.quiz.responses[r].groupId);
              }
            }
          }
        }

        // Calcul du % de chaque groupes par catégorie de réponse.
        for (var cat = 0; cat < categories.length; cat++) {
          // data_y2 = nb réel de personne ayant répondu. data_y2[0] = nb personne ayant répondu du groupe 0.
          for (var d = 0; d < categories[cat].data_y2.length; d++) {
            // var y_real = parent.quiz.responses.length*categories[cat].y/100; // On enlève le pourcentage de y. // comparaison par rapport au nb de réponse dans cette catégorie.
            // Il faut comparer par rapport à l'ensemble des réponses. Attention pour les questions enfants il faut comparer par rapport à l'ensemble des réponses de la catégorie de la question parente.
            var y_real = !child_index ? parent.quiz.responses.length : parent.quiz.responses.length * statsParent[child_index].y / 100;
            categories[cat].data_y[d] = y_real > 0 ? parseFloat(categories[cat].data_y2[d] * 100 / y_real) : 0;
          }
        }

        return categories;
      };

      var drawGraph = function drawGraph(question, stats, child_id) {

        var colors = ["#09b259", "#fa0909", "#fadb09", "#97d059", "#cc0909"]; // Couleurs clients.
        colors = colors.concat(Highcharts.getOptions().colors); // +10 couleurs par défaut.

        var categories = [];
        var data = [];
        var color_index = 0;
        var hasResponse = false;

        for (var cd = 0; cd < stats.length; cd++) {
          if (stats[cd].y > 0) {
            hasResponse = true;
          }
          categories.push(stats[cd].name);
          var group_name = [];
          for (var gn = 0; gn < stats[cd].categories_groups.length; gn++) {
            group_name.push(stats[cd].categories_groups[gn].name);
          }

          data.push({
            y: parseFloat(stats[cd].y2.toFixed(1)),
            color: stats[cd].color ? stats[cd].color : colors[color_index],
            drilldown: {
              name: 'Groupes',
              categories: group_name,
              data: stats[cd].data_y2,
              color: colors[color_index]
            }
          });
          color_index++;
          if (color_index > 15) {
            color_index = 0; // si + de 15 choix disponibles, alors certains auront la même couleur.
          }
        }

        // categories = ['Très satisfait', 'Satisfait', 'Neutre', 'Peu satisfait', 'Pas satisfait'],
        // data = [
        //   {
        //     y: 20,
        //     color: "#09b259",
        //     drilldown: {
        //         name: 'Groupes',
        //         categories: ['Directeurs', 'Cadres', 'Ouvriers'],
        //         data: [10, 5, 5],
        //         color: "#09b259"
        //     }
        //   },
        //   {
        //       y: 35,
        //       color: "#97d059",
        //       drilldown: {
        //           name: 'Groupes',
        //           categories: ['Directeurs', 'Cadres', 'Ouvriers'],
        //           data: [5, 15, 15],
        //           color: "#97d059"
        //       }
        //   },
        //   {
        //       y: 10,
        //       color: "#fadb09",
        //       drilldown: {
        //           name: 'Groupes',
        //           categories: ['Directeurs', 'Cadres', 'Ouvriers'],
        //           data: [3, 6, 1],
        //           color: "#fadb09"
        //       }
        //   }, {
        //       y: 25,
        //       color: "#fa0909",
        //       drilldown: {
        //           name: 'Groupes',
        //           categories: ['Directeurs', 'Cadres', 'Ouvriers'],
        //           data: [10, 8, 7],
        //           color: "#fa0909"
        //       }
        //   }, {
        //       y: 15,
        //       color: "#cc0909",
        //       drilldown: {
        //           name: 'Groupes',
        //           categories: ['Directeurs', 'Cadres', 'Ouvriers'],
        //           data: [5, 5, 5],
        //           color: "#cc0909"
        //       }
        //   }
        // ],

        var browserData = [],
            versionsData = [],
            i,
            j,
            dataLen = data.length,
            drillDataLen,
            brightness;

        // Build the data arrays
        for (i = 0; i < dataLen; i += 1) {
          // add browser data
          browserData.push({
            name: categories[i],
            y: data[i].y,
            color: data[i].color
          });

          // add version data
          drillDataLen = data[i].drilldown.data.length;
          for (j = 0; j < drillDataLen; j += 1) {
            brightness = 0.2 - j / drillDataLen / 5;
            versionsData.push({
              name: data[i].drilldown.categories[j],
              y: data[i].drilldown.data[j],
              color: Highcharts.Color(data[i].color).brighten(brightness).get()
            });
          }
        }

        var id_chart = !child_id ? 'container' + question.id + '-' + parent.number : 'container_child' + child_id + '-' + parent.number;
        if (hasResponse) {

          var graphDetail = {};

          if (!question.graphType || question.graphType == "détaillé") {
            graphDetail = {
              name: 'Votants',
              data: versionsData,
              size: '80%',
              innerSize: '60%',
              showInLegend: false,
              dataLabels: {
                formatter: function formatter() {
                  // display only if larger than 1
                  return this.percentage > 1 ? '<b>' + this.point.name + ':</b> ' + this.percentage.toFixed() + '% ' : null;
                }
              },
              id: 'versions'
            };
          }

          var legendeBelow = !question.legendeType || question.legendeType == "below" ? true : false;

          $("#" + id_chart).html("");
          Highcharts.setOptions({
            lang: {
              contextButtonTitle: "Chart context menu",
              decimalPoint: ",",
              downloadJPEG: "Télécharger au format JPEG image",
              downloadPDF: "Télécharger au format PDF document",
              downloadPNG: "Télécharger au format PNG image",
              downloadSVG: "Télécharger au format SVG vector image",
              drillUpText: "Retour à {series.name}",
              loading: "Chargement...",
              months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Decembre"],
              noData: "Aucune donnée à afficher",
              printChart: "Imprimer le graphique",
              resetZoom: "Réinitialiser le zoom",
              shortMonths: ["Jan", "Feb", "Mar", "Avr", "Mai", "Jun", "Jul", "Aou", "Sep", "Oct", "Nov", "Dec"],
              weekdays: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"]
            }
          });
          Highcharts.chart(id_chart, {
            credits: {
              enabled: false
            },
            chart: {
              type: 'pie'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            yAxis: {
              title: {
                text: 'Total percent market share'
              }
            },
            plotOptions: {
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                showInLegend: true
              }
            },
            legend: {
              labelFormatter: function labelFormatter() {
                return this.name + " (" + this.percentage.toFixed() + "%)";
              }
            },
            tooltip: {
              valueSuffix: '%',
              useHTML: true,
              formatter: function formatter() {
                return this.point.name + "<br><span style='font-size:20px;color:" + this.color + ";position:relative;top:3px;'>•</span> " + this.y + "/" + this.total + " (" + this.percentage.toFixed(2) + "%)";
              }
            },
            series: [{
              name: 'Votants',
              data: browserData,
              size: '60%',
              showInLegend: legendeBelow,
              dataLabels: {
                formatter: function formatter() {
                  if (question.graphType != "simple") return null;
                  return this.percentage > 5 ? this.point.name + " : " + this.percentage.toFixed() + "%" : this.y > 1 ? this.percentage.toFixed() + "%" : null;
                },
                color: '#000000'
              }
            }, graphDetail],
            responsive: {
              rules: [{
                condition: {
                  maxWidth: 400
                },
                chartOptions: {
                  series: [{
                    id: 'versions',
                    dataLabels: {
                      enabled: false
                    }
                  }]
                }
              }]
            }
          });
        } else {
          $("#" + id_chart).html("Aucune réponse.");
        }
      };

      // Pour chaque question on calcul les stats et on crée le graphique.
      var list_questions = parent.quiz.questions;
      for (var q = 0; q < list_questions.length; q++) {
        if (list_questions[q].type != "text") {
          if (oneQuestion && oneQuestion.id == list_questions[q].id || !oneQuestion) {
            var stats_data = calculsStats(list_questions[q], q);
            drawGraph(list_questions[q], stats_data);
            if (list_questions[q].data) {
              for (var d = 0; d < list_questions[q].data.length; d++) {
                if (list_questions[q].data[d].question && list_questions[q].data[d].question.type != "text") {
                  var stats_data_child = calculsStats(list_questions[q].data[d].question, q, d, stats_data);
                  drawGraph(list_questions[q].data[d].question, stats_data_child, list_questions[q].data[d].id);
                }
              }
            }
          }
        }
      }
    }
  }, {
    key: "formatForCsv",
    value: function formatForCsv(txt) {
      if (txt) {
        return txt.toString().replace(new RegExp(" ; ", 'g'), " , ");
      }
      return "";
    }
  }, {
    key: "prepareListParticipants",
    value: function prepareListParticipants() {
      var dataSetParticipants = [];
      var th = [];
      th.push("<span class='tr-green colspan-5'>" + this.formatForCsv(this.quiz.title) + "</span>");
      th.push("");
      th.push("");
      th.push("");
      th.push("");

      dataSetParticipants.push(th);
      for (var a = 0; a < this.quiz.responses.length; a++) {
        var tr = [];
        tr.push(new Date(this.quiz.responses[a].created).toLocaleDateString() + " à " + new Date(this.quiz.responses[a].created).toLocaleTimeString());
        tr.push(this.formatForCsv(this.quiz.responses[a].lastname));
        tr.push(this.formatForCsv(this.quiz.responses[a].firstname));
        tr.push(new Date(this.quiz.responses[a].birthday).toLocaleDateString());
        var groupName = "";
        for (var g = 0; g < this.quiz.groups.length; g++) {
          if (this.quiz.groups[g].id.toString() == this.quiz.responses[a].groupId.toString()) {
            groupName = this.formatForCsv(this.quiz.groups[g].name);
          }
        }
        tr.push(groupName);

        for (var f = 0; f < this.filters.length; f++) {
          if (this.filters[f].name == groupName) {
            dataSetParticipants.push(tr);
          }
        }
      }

      var columnsParticipants = [];
      columnsParticipants.push({ title: "Date de réponse" });
      columnsParticipants.push({ title: "Nom" });
      columnsParticipants.push({ title: "Prénom" });
      columnsParticipants.push({ title: "Date de naissance" });
      columnsParticipants.push({ title: "Groupe" });

      return {
        columnsParticipants: columnsParticipants,
        dataSetParticipants: dataSetParticipants
      };
    }
  }, {
    key: "prepareList",
    value: function prepareList() {
      var dataSet = [];
      for (var a = 0; a < this.quiz.questions.length; a++) {
        if (this.quiz.questions[a].type == "text") {
          var th = [];
          th.push(a + 1);
          th.push("<span class='tr-green colspan-2'>" + this.formatForCsv(this.quiz.questions[a].title) + "</span>");
          th.push("");
          dataSet.push(th);
          for (var r = 0; r < this.quiz.responses.length; r++) {
            var tr = [];
            tr.push(a + 1 + "." + (r + 1));
            var groupName = "";
            for (var g = 0; g < this.quiz.groups.length; g++) {
              if (this.quiz.groups[g].id.toString() == this.quiz.responses[r].groupId.toString()) {
                groupName = this.formatForCsv(this.quiz.groups[g].name);
              }
            }
            tr.push(groupName);
            tr.push(this.quiz.responses[r].questions[a] && this.quiz.responses[r].questions[a].noResponse ? "Ne se prononce pas" : this.formatForCsv(this.quiz.responses[r].questions[a].value));

            for (var f = 0; f < this.filters.length; f++) {
              if (this.filters[f].name == groupName) {
                dataSet.push(tr);
              }
            }
          }
        } else if (this.quiz.questions[a].type == "checkbox_multiple" || this.quiz.questions[a].type == "radio_multiple") {
          if (this.quiz.questions[a].data) {
            for (var d = 0; d < this.quiz.questions[a].data.length; d++) {
              if (this.quiz.questions[a].data[d].question && this.quiz.questions[a].data[d].question.type == "text") {
                var th = [];
                th.push(a + 1);
                th.push("<span class='tr-green colspan-2'>" + this.formatForCsv(this.quiz.questions[a].title) + "</span>");
                th.push("");
                dataSet.push(th);
                var th2 = [];
                th2.push(a + 1 + '.' + (d + 1));
                th2.push("<span class='tr-green-light colspan-2'>" + this.formatForCsv(this.quiz.questions[a].data[d].name) + " : " + this.formatForCsv(this.quiz.questions[a].data[d].question.title) + "</span>");
                th2.push("");
                dataSet.push(th2);
                for (var r = 0; r < this.quiz.responses.length; r++) {
                  var tr = [];
                  tr.push(a + 1 + "." + (d + 1) + "." + (r + 1));
                  var groupName = "";
                  for (var g = 0; g < this.quiz.groups.length; g++) {
                    if (this.quiz.groups[g].id.toString() == this.quiz.responses[r].groupId.toString()) {
                      groupName = this.formatForCsv(this.quiz.groups[g].name);
                    }
                  }
                  tr.push(groupName);
                  if (this.quiz.responses[r] && this.quiz.responses[r].questions[a] && this.quiz.responses[r].questions[a].data && this.quiz.responses[r].questions[a].data[d]) {
                    tr.push(this.quiz.responses[r].questions[a].data[d] && this.quiz.responses[r].questions[a].data[d].noResponse ? "Ne se prononce pas" : this.formatForCsv(this.quiz.responses[r].questions[a].data[d].value));
                    for (var f = 0; f < this.filters.length; f++) {
                      if (this.filters[f].name == groupName) {
                        if (this.quiz.responses[r].questions[a].data[d] && this.quiz.responses[r].questions[a].data[d].noResponse || this.quiz.responses[r].questions[a].data[d] && this.quiz.responses[r].questions[a].data[d].value != '') dataSet.push(tr);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      var columns = [];
      columns.push({ title: "N°" });
      columns.push({ title: "Groupe", orderable: false });
      columns.push({ title: "Réponse", orderable: false });

      return {
        columns: columns,
        dataSet: dataSet
      };
    }
  }, {
    key: "getPreconizations",
    value: function getPreconizations(ctx, slug, callback) {
      var parent = this;
      _quizzes2.default.getPreconizations(ctx, slug, function (preconizations, err) {
        if (preconizations) {
          parent.preconizations = preconizations;
        } else {
          toastr.error("Impossible de récupérer les préconisations du questionnaire.", "ERREUR");
        }
        callback(preconizations, err);
      });
    }
  }]);

  return Quiz;
}();

exports.default = Quiz;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_transferh_full.e3a5028.png";

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(76)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(127),
  /* scopeId */
  "data-v-df9cd0c8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)
__webpack_require__(46)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(103),
  /* scopeId */
  "data-v-15fa43ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(129);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _login = __webpack_require__(81);

var _login2 = _interopRequireDefault(_login);

var _home = __webpack_require__(80);

var _home2 = _interopRequireDefault(_home);

var _settings = __webpack_require__(97);

var _settings2 = _interopRequireDefault(_settings);

var _quizzes = __webpack_require__(94);

var _quizzes2 = _interopRequireDefault(_quizzes);

var _list = __webpack_require__(88);

var _list2 = _interopRequireDefault(_list);

var _show = __webpack_require__(96);

var _show2 = _interopRequireDefault(_show);

var _create = __webpack_require__(84);

var _create2 = _interopRequireDefault(_create);

var _responses = __webpack_require__(12);

var _responses2 = _interopRequireDefault(_responses);

var _preconizations = __webpack_require__(89);

var _preconizations2 = _interopRequireDefault(_preconizations);

var _new_action = __webpack_require__(92);

var _new_action2 = _interopRequireDefault(_new_action);

var _show_actions = __webpack_require__(93);

var _show_actions2 = _interopRequireDefault(_show_actions);

var _export_pdf = __webpack_require__(87);

var _export_pdf2 = _interopRequireDefault(_export_pdf);

var _users = __webpack_require__(101);

var _users2 = _interopRequireDefault(_users);

var _list3 = __webpack_require__(99);

var _list4 = _interopRequireDefault(_list3);

var _show3 = __webpack_require__(100);

var _show4 = _interopRequireDefault(_show3);

var _create3 = __webpack_require__(98);

var _create4 = _interopRequireDefault(_create3);

var _compare = __webpack_require__(79);

var _compare2 = _interopRequireDefault(_compare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default

// mode 'history' permet d'enlever le # dans les routes. Ex: #!/login
);exports.default = new _vueRouter2.default({
    mode: 'history',
    routes: [{
        path: '/login',
        name: 'login',
        component: _login2.default
    }, {
        path: '/accueil',
        name: 'home',
        component: _home2.default,
        meta: { requiresAuth: true }
    }, {
        path: '/parametres',
        name: 'settings',
        component: _settings2.default,
        meta: { requiresAuth: true }
    }, {
        path: '/compare',
        name: 'compare',
        component: _compare2.default,
        meta: { requiresAuth: true }
    }, {
        component: _quizzes2.default,
        name: 'quizzes',
        path: '/questionnaire',
        children: [{
            path: '',
            component: _list2.default,
            name: 'quizzes_list',
            breadcrumbs: 'Liste des questionnaires',
            meta: { requiresAuth: true }
        }, {
            path: 'nouveau',
            component: _create2.default,
            name: 'quizzes_create',
            breadcrumbs: 'Créer un questionnaire',
            meta: { requiresAuth: true }
        }, {
            path: ':slug/edition',
            component: _create2.default,
            name: 'quizzes_edit',
            breadcrumbs: 'Modifier un questionnaire',
            meta: { requiresAuth: true }
        }, {
            path: ':slug',
            component: _show2.default,
            name: 'quizzes_show',
            breadcrumbs: 'Fiche d\'un questionnaire'
        }, {
            path: ':slug/reponses',
            component: _responses2.default,
            name: 'quizzes_responses',
            breadcrumbs: 'Réponses au questionnaire',
            meta: { requiresAuth: true }
        }, {
            path: ':slug/preconisations',
            component: _preconizations2.default,
            name: 'quizzes_preconizations',
            breadcrumbs: 'Préconisations du questionnaire',
            meta: { requiresAuth: true }
        }, {
            path: ':slug/preconisations/nouvelle',
            component: _new_action2.default,
            name: 'quizzes_preconizations_create_action',
            breadcrumbs: 'Création d\'une nouvelle action de préconisation',
            meta: { requiresAuth: true }
        }, {
            path: ':slug/preconisations/:id',
            component: _new_action2.default,
            name: 'quizzes_preconizations_edit_action',
            breadcrumbs: 'Edition d\'une action de préconisation',
            meta: { requiresAuth: true }
        }, {
            path: ':slug/preconisations/actions/details',
            component: _show_actions2.default,
            name: 'quizzes_preconizations_show_actions',
            breadcrumbs: 'Liste des actions d\'une préconisation',
            meta: { requiresAuth: true }
        }, {
            path: ':slug/exportPDF',
            name: 'quizzes_export_pdf',
            component: _export_pdf2.default,
            breadcrumbs: "Export pdf du questionnaire",
            meta: { requiresAuth: true }
        }]
    }, {
        component: _users2.default,
        name: 'users',
        path: '/utilisateurs',
        children: [{
            path: '',
            component: _list4.default,
            name: 'users_list',
            breadcrumbs: 'Liste des utilisateurs',
            meta: { requiresAuth: true }
        }, {
            path: 'nouveau',
            component: _create4.default,
            name: 'users_create',
            breadcrumbs: 'Créer un utilisateur',
            meta: { requiresAuth: true }
        }, {
            path: ':id/edition',
            component: _create4.default,
            name: 'users_edit',
            breadcrumbs: 'Modifier un utilisateur',
            meta: { requiresAuth: true }
        }, {
            path: ':id',
            component: _show4.default,
            name: 'users_show',
            breadcrumbs: 'Fiche d\'un utilisateur',
            meta: { requiresAuth: true }
        }]
    }, {
        path: '*',
        redirect: '/login'
    }],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        // scroll to top or anchor #
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    }
});

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__storage_data_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


$.fn.dataTable.moment('DD/MM/YYYY');


var config = __webpack_require__(5);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      loadingText: "",
      loading: false,
      forceValue: false,
      progressBar: {
        enabled: false,
        min: 0,
        max: 100,
        value: 0,
        txt: "0%",
        pourcentage: 0
      },
      data: __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a.data,
      version: config.version
    };
  },

  watch: {
    'data.session.authenticated': function dataSessionAuthenticated() {
      if (this.data && this.data.session && this.data.session.authenticated !== true) {
        if (this.$route.meta && this.$route.meta.requiresAuth) {
          // toastr.clear();
          // toastr.error("Votre session a expirée.","ERREUR");
          this.$router.push({ name: 'login' });
        }
      }
    }
  },
  mounted: function mounted() {
    this.$on("loading", function (value, text, forceValue) {
      if (forceValue != null) this.forceValue = forceValue;
      if (this.forceValue) {
        this.loading = true;
      } else {
        this.loading = value;
      }
      if (text) {
        this.loadingText = text;
      } else {
        this.loadingText = "Chargement en cours...";
      }
    });

    this.$on("progressBar", function (enabled, min, max, val, text) {
      this.progressBar.enabled = enabled;
      if (enabled) {
        this.progressBar.min = min;
        this.progressBar.max = max;
        this.progressBar.value = val;
        this.progressBar.txt = text;
        this.progressBar.pourcentage = val * 100 / max;
      } else {
        this.progressBar.pourcentage = 0;
      }
    });

    if (__WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a && __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a.data && __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a.data.session && !__WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a.data.session.authenticated) {
      if (this.$route.meta && this.$route.meta.requiresAuth) {
        this.logout();
      }
    }
  },
  methods: {
    logout: function logout(voluntary) {
      if (__WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a) {
        __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a.logout();
      }
      if (!voluntary) {
        toastr.clear();
        toastr.error("Votre session a expirée.", "ERREUR");
        this.$router.push({ name: 'login' });
      }
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage_data_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage_data_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__storage_data_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quizzes_responses__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quizzes_responses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__quizzes_responses__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// var config = require('../../config/settings.json');


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'compare',
  components: {
    Responses: __WEBPACK_IMPORTED_MODULE_2__quizzes_responses___default.a
  },
  data: function data() {
    return {
      quizzes: [],
      quiz1: '',
      quiz2: ''
    };
  },

  computed: {
    quizzesPublished: function quizzesPublished() {
      // Renvoyer uniquement le nb de quiz publié.
      var countPublished = 0;
      this.quizzes.forEach(function (quiz) {
        if (quiz.state == "published") {
          countPublished++;
        }
      });
      return countPublished;
    }
  },
  mounted: function mounted() {
    var parent = this;
    if (__WEBPACK_IMPORTED_MODULE_1__storage_data_js___default.a.data.user.role == "dev") {
      __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getAll(this, function (quizzes, error) {
        if (quizzes) {
          parent.quizzes = quizzes;
        } else {
          toastr.error("ERREUR dans la récupération des questionnaires.");
        }
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getAllMyQuizzes(this, function (quizzes, error) {
        if (quizzes) {
          parent.quizzes = quizzes;
        } else {
          toastr.error("ERREUR dans la récupération des questionnaires.");
        }
      });
    }
  },
  methods: {}
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    this.$nextTick(function () {});
  },
  methods: {}
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__storage_data_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_forgetPassword__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_forgetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__login_forgetPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login_resetPassword__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login_resetPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__login_resetPassword__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  components: {
    ForgetPassword: __WEBPACK_IMPORTED_MODULE_1__login_forgetPassword___default.a,
    ResetPassword: __WEBPACK_IMPORTED_MODULE_2__login_resetPassword___default.a
  },
  data: function data() {
    return {
      emailOrUsername: "",
      password: "test",
      error: "",
      show: {
        login: true,
        forgetPassword: false,
        resetPassword: false
      }
    };
  },

  watch: {
    'show.login': function showLogin() {
      if (this.show.login) {
        this.show.forgetPassword = false;
        this.show.resetPassword = false;
      }
    },
    'show.forgetPassword': function showForgetPassword() {
      if (this.show.forgetPassword) {
        this.show.login = false;
        this.show.resetPassword = false;
      }
    },
    'show.resetPassword': function showResetPassword() {
      if (this.show.resetPassword) {
        this.show.login = false;
        this.show.forgetPassword = false;
      }
    }
  },
  mounted: function mounted() {
    if (this.$route.query && this.$route.query.resetPassword) {
      this.show.resetPassword = true;
    }
  },
  methods: {
    login: function login() {
      this.error = "";
      var parent = this;
      $('#formLogin').parsley().validate();
      if ($("#formLogin").parsley().isValid()) {

        __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a.login(this, this.emailOrUsername, this.password, function (err) {
          if (err) {
            toastr.options.closeButton = true;
            toastr.options.timeOut = 7000;
            // toastr.options.progressBar = true;
            //toastr.options.positionClass = "toast-top-center",
            toastr.error(err, "ERREUR");
          } else {
            if (parent.$route.query && parent.$route.query.redirect) {
              parent.$router.push(parent.$route.query.redirect);
            } else {
              parent.$router.push({ name: 'quizzes_list' });
            }
            // window.location.reload();
          }
        });
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called.

    // Vérifier si l'user n'est pas déjà connecté, sinon redirection home.
    if (__WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a && __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a.data && __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a.data.session && __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a.data.session.authenticated === true) {
      next({ name: "quizzes_list" });
    } else {
      next();
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_users_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_users_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_users_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},

  props: ["show"],
  data: function data() {
    return {
      email: ""
    };
  },

  mounted: function mounted() {},
  methods: {
    sendEmail: function sendEmail() {
      $('#formForgetPassword').parsley().validate();
      if ($("#formForgetPassword").parsley().isValid()) {
        var parent = this;
        __WEBPACK_IMPORTED_MODULE_0__requests_users_js___default.a.reset(this, this.email, function (err) {
          if (err) {
            toastr.error(err, "ERREUR");
          } else {
            toastr.success("Un email de réinitialisation de mot de passe vient de vous être envoyé.");
          }
        });
      }
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_users_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_users_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_users_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},

  props: ["show"],
  data: function data() {
    return {
      newPassword: ""
    };
  },

  mounted: function mounted() {},
  methods: {
    reValidateInput: function reValidateInput(id) {
      setTimeout(function () {
        $("#" + id).parsley().validate();
      }, 50);
    },
    resetPassword: function resetPassword() {
      $('#formResetPassword').parsley().validate();
      if ($("#formResetPassword").parsley().isValid()) {
        var parent = this;
        __WEBPACK_IMPORTED_MODULE_0__requests_users_js___default.a.resetPassword(this, this.newPassword, this.$route.query.Authorization, function (err) {
          if (err) {
            toastr.error(err, "ERREUR");
          } else {
            toastr.success("Votre mot de passe a été modifié. Vous pouvez maintenant essayer de vous connecter.");
            parent.show.login = true;
          }
        });
      }
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},

  props: ["dataSet", "columns", "order", "id"],
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    this.createDataTable();
  },
  watch: {
    'columns': function columns() {
      if (this.dataSet && this.dataSet.length > 0 && this.columns) {
        if (this.dataSet[0].length == this.columns.length) {
          this.createDataTable();
        }
      }
    }
  },
  computed: {
    getId: function getId() {
      if (!this.id) {
        return "table-parent";
      }
      return this.id;
    }
  },
  methods: {
    createDataTable: function createDataTable() {
      var parent = this;
      if (parent.dataSet.length > 0) {
        var id2 = "table-" + this.getId;
        $("#" + this.getId).html('<table id="' + id2 + '" class="table" style="width:100%"></table>');
        var order = this.order ? [this.order] : [];
        $('#' + id2).DataTable({
          data: parent.dataSet,
          columns: parent.columns,
          "order": order,
          "language": {
            "emptyTable": "Aucun résultat",
            "info": "Afficher de _START_ à _END_ sur _TOTAL_ résultats",
            "infoEmpty": "Aucun résultat",
            "infoFiltered": "(filtrés parmis _MAX_ résultats)",
            "infoPostFix": "",
            "thousands": ",",
            "lengthMenu": "Afficher _MENU_ résultats",
            "loadingRecords": "Chargement...",
            "processing": "Calcul...",
            "search": "Rechercher : ",
            "zeroRecords": "Aucun résultat trouvé.",
            "paginate": {
              "first": "Premier",
              "last": "Dernier",
              "next": "Suivant",
              "previous": "Précédent"
            },
            "aria": {
              "sortAscending": ": Trie ascendant",
              "sortDescending": ": Trie descendant"
            }
          },
          "createdRow": function createdRow(row, data, dataIndex) {

            for (var d = 0; d < data.length; d++) {
              if (data[d].toString().indexOf("tr-green") >= 0) {
                $(row).addClass('th-green');
              }
              if (data[d].toString().indexOf("tr-green-light") >= 0) {
                $(row).addClass('th-green-light');
              }
              if (data[d].toString().indexOf("colspan-") >= 0) {
                var childrens = $(row).children();
                var index = data[d].toString().indexOf("colspan-");
                var nb = parseInt(data[d].toString().substring(index + 8));
                if (Number.isInteger(nb)) {
                  $(childrens[d]).attr("colspan", nb);
                  for (var i = 1; i < nb; i++) {
                    $(childrens[d + i].remove());
                  }
                }
              }
            }
          }
        });

        $.fn.dataTable.ext.errMode = 'none';

        $('#' + id2).on('error.dt', function (e, settings, techNote, message) {
          console.error('An error has been reported by DataTables: ', message);
        });
      } else $("#" + this.getId).html('');
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

  props: ["preconizations"],
  data: function data() {
    return {};
  },

  mounted: function mounted() {},
  watch: {},
  computed: {},
  methods: {
    getDescription: function getDescription(description) {
      description = description.replace(new RegExp("\n", 'g'), "<br>");
      return description;
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_questions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_questions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__create_questions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_quiz__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_quiz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__create_quiz__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__share_quiz__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__share_quiz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__share_quiz__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quizzes_create',
  components: {
    CreateQuestions: __WEBPACK_IMPORTED_MODULE_1__create_questions___default.a,
    CreateQuiz: __WEBPACK_IMPORTED_MODULE_2__create_quiz___default.a,
    ShareQuiz: __WEBPACK_IMPORTED_MODULE_3__share_quiz___default.a
  },
  data: function data() {
    return {
      show: {
        quiz: true,
        questions: false,
        share: false
      },
      quiz: {}
    };
  },

  mounted: function mounted() {
    this.init();
  },
  watch: {
    'show.quiz': function showQuiz() {
      if (this.show.quiz) {
        this.show.questions = false;
        this.show.share = false;
      }
    },
    'show.questions': function showQuestions() {
      if (this.show.questions) {
        this.show.quiz = false;
        this.show.share = false;
      }
    },
    'show.share': function showShare() {
      if (this.show.share) {
        this.show.quiz = false;
        this.show.questions = false;
      }
    },
    '$route': function $route(to, from) {
      if (from.name == "quizzes_create" && to.name == "quizzes_edit") {
        this.init();
      }
    }
  },
  computed: {
    getState: function getState() {
      var state = "";
      switch (this.quiz.state) {
        case "draft":
          state = '<span class="label label-sm label-warning"> Brouillon </span>';
          break;
        case "published":
          state = '<span class="label label-sm label-success"> Publié </span>';
          break;
      }
      return state;
    }
  },
  methods: {
    init: function init() {
      this.reinit();
      var parent = this;
      this.$nextTick(function () {
        if (this.$route.params && this.$route.params.slug) {
          //Récupérer le questionnaire à éditer.
          __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getBySlug(this, this.$route.params.slug, function (quiz, err) {
            if (!quiz) {
              toastr.error("Impossible de récupérer le questionnaire.", "ERREUR");
              parent.quiz = null;
            } else {
              parent.quiz = quiz;
              parent.quiz["questions"] = [];
              if (quiz.date_deadline) {
                $("#date_deadline").datepicker("setDate", new Date(quiz.date_deadline));
              }

              // Récupérer les questions du questionnaire.
              __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getQuestions(parent, parent.$route.params.slug, function (questions, err) {
                if (questions) {
                  parent.quiz['questions'] = questions;
                  if (parent.quiz.state == 'published') {
                    parent.goStep('share');
                  }
                  if (parent.$route.query && parent.$route.query.show && parent.$route.query.show == "questions") {
                    parent.goStep('questions');
                  }
                  parent.$forceUpdate(); // permet l'update des classes des onglets en haut.
                } else {
                  toastr.error("Impossible de récupérer les questions du questionnaire.", "ERREUR");
                }
              });
            }
          });
        }
      });
    },
    forceUpdate: function forceUpdate() {
      this.$forceUpdate();
    },
    reinit: function reinit() {
      this.quiz = {
        title: "",
        date_deadline: "",
        instructions: "",
        conclusion: "",
        state: "draft",
        groups: [{
          name: "",
          nb_participants: 0
        }],
        company: {
          name: ""
        },
        questions: []
      };

      this.show.quiz = true;

      this.$forceUpdate();
    },
    goStep: function goStep(step_name) {
      switch (step_name) {
        case 'quiz':
          if (this.quiz.state != 'published') {
            this.show.quiz = true;
          }
          break;
        case 'questions':
          if (this.quiz.slug && this.quiz.state != 'published') {
            this.show.questions = true;
          }
          break;
        case 'share':
          if (this.quiz.slug && this.quiz.questions.length > 0) {
            this.show.share = true;
          }
          break;
      }
    },
    saveQuiz: function saveQuiz(exit, state) {
      if (this.quiz.slug) {
        // Alors UPDATE.
        if (this.show.quiz) {
          if (state) {
            this.quiz.state = state;
          }
          this.updateQuiz(exit);
        } else if (this.show.questions) {
          if (state) {
            // Si le status a été MAJ faut update le QUIZ;
            this.updateStateQuiz(state);
          }
          this.$refs.questions.saveQuestions(exit);
        } else if (this.show.share && state) {
          this.updateStateQuiz(state);
        }
      } else {
        if (state) {
          this.quiz.state = state;
        }
        // Create
        this.createQuiz(exit);
      }
    },
    createQuiz: function createQuiz(exit) {
      var parent = this;
      $('#form_quiz_create').parsley().validate();
      if ($("#form_quiz_create").parsley().isValid()) {
        this.quiz.date_deadline = $("#date_deadline").datepicker("getDate");
        __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.create(this, this.quiz, function (quiz, err) {
          if (quiz) {
            parent.quiz = quiz;
            parent.quiz["questions"] = [];

            if (quiz.date_deadline) {
              $("#date_deadline").datepicker("setDate", new Date(quiz.date_deadline));
            }
            toastr.closeButton = true;
            toastr.success("Le questionnaire a été enregistré.");
            if (exit) {
              parent.$router.push({ name: "quizzes_list" });
            } else {
              parent.$router.push({ name: "quizzes_edit", params: { slug: parent.quiz.slug }, query: { show: "questions" } });
            }

            parent.$forceUpdate();
          } else {
            toastr.error(err, "ERREUR");
          }
        });
      }
    },
    updateQuiz: function updateQuiz(exit) {
      var parent = this;
      $('#form_quiz_create').parsley().validate();
      if ($("#form_quiz_create").parsley().isValid()) {
        this.quiz.date_deadline = $("#date_deadline").datepicker("getDate");
        __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.updateBySlug(this, this.quiz.slug, this.quiz, function (quiz, err) {
          if (quiz) {
            toastr.success("Le questionnaire a été enregistré.");
            if (exit) {
              parent.$router.push({ name: "quizzes_list" });
            }
            if (parent.show.quiz) {
              parent.show.questions = true;
            }
          } else {
            toastr.error(err, "ERREUR");
          }
        });
      }
    },
    updateStateQuiz: function updateStateQuiz(state) {
      var parent = this;
      // Si changement de state.
      if (this.quiz.state != state) {
        this.quiz.state = state;
        __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.updateBySlug(this, this.quiz.slug, this.quiz, function (quiz, err) {
          if (quiz) {
            parent.quiz.groups = quiz.groups;
            toastr.options.closeButton = true;
            toastr.success("Le questionnaire a été enregistré.");
          } else {
            toastr.options.closeButton = true;
            toastr.error(err, "ERREUR");
          }
        });
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.

    // Réinit le quiz si on est sur la route quizzes_edit et qu'on click sur quizzes_create.
    this.reinit();
    next();
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests_questions_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests_questions_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__requests_questions_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["quiz", "show"],
  data: function data() {
    return {
      dataSwatches: "#c00000|#ff0000|#ff7c80|#ffc000|#ffff00|#ccff66|#92d050|#00cc66|#00b050|#548235|#00b0f0",
      questions: [],
      switchs: [false],
      questionsToDelete: []
    };
  },

  mounted: function mounted() {
    this.init();
  },
  watch: {
    "quiz.questions": function quizQuestions() {
      this.init();
    }
  },
  methods: {
    showColorPicker: function showColorPicker(index, index_color, index_data, index_data2, index2) {
      var parent = this;
      this.$nextTick(function () {
        $(".input-color").minicolors({
          swatches: $(".input-color").attr('data-swatches') ? $(".input-color").attr('data-swatches').split('|') : [],
          change: function change(value, opacity) {
            if (this.getAttribute("data-index-data") != null && this.getAttribute("data-index-color") != null) {
              parent.questions[this.getAttribute("data-index-question")].data[this.getAttribute("data-index-data")].question.colors[this.getAttribute("data-index-color")] = value;
            } else if (this.getAttribute("data-index-data") != null && this.getAttribute("data-index-data-two") != null) {
              parent.questions[this.getAttribute("data-index-question")].data[this.getAttribute("data-index-data")].question.data[this.getAttribute("data-index-data-two")].color = value;
            } else if (this.getAttribute("data-index-data") != null) {
              parent.questions[this.getAttribute("data-index-question")].data[this.getAttribute("data-index-data")].color = value;
            } else if (this.getAttribute("data-index-color") != null) {
              parent.questions[this.getAttribute("data-index-question")].colors[this.getAttribute("data-index-color")] = value;
            } else if (this.getAttribute("data-index-question") != null && this.getAttribute("data-index-question-two")) {
              parent.questions[this.getAttribute("data-index-question")].data[this.getAttribute("data-index-question-two")].question.color_no_response = value;
            } else if (this.getAttribute("data-index-question") != null) {
              parent.questions[this.getAttribute("data-index-question")].color_no_response = value;
            }
            parent.$forceUpdate();
          }
        });

        this.$nextTick(function () {
          if (index_color != null && index_data != null) {
            $($($("#colorPicker" + index + '-data-' + index_data + '-' + index_color)[0]).parent()[0].children[1]).mousedown();
          } else if (index_data != null && index_data2 != null) {
            $($($("#colorPicker" + index + '-data-' + index_data + '-data2-' + index_data2)[0]).parent()[0].children[1]).mousedown();
          } else if (index_color != null) {
            $($($("#colorPicker" + index + '-' + index_color)[0]).parent()[0].children[1]).mousedown();
          } else if (index_data != null) {
            if (!this.questions[index].data[index_data].color) {
              this.questions[index].data[index_data].color = "";
            }
            $($($("#colorPicker" + index + '-data-' + index_data)[0]).parent()[0].children[1]).mousedown();
          } else if (index != null && index2 != null) {
            if (this.questions[index].data[index2].question && !this.questions[index].data[index2].question.color_no_response) {
              this.questions[index].data[index2].question.color_no_response = "#00b0f0";
            }
            $($($("#colorPicker" + index + '-question-' + index2)[0]).parent()[0].children[1]).mousedown();
          } else if (index != null) {
            $($($("#colorPicker" + index)[0]).parent()[0].children[1]).mousedown();
          }
        });
      });
    },
    addColors: function addColors(question) {
      var nb = parseInt(question.max) - parseInt(question.min) + 1;
      if (nb > 0) {
        if (!question.colors) {
          question.colors = [];
        }
        for (var i = 0; i < nb; i++) {
          if (question.colors[i] == null) {
            question.colors.push("");
          }
        }
        if (question.colors.length > nb) {
          question.colors.splice(nb);
        }
      }
    },
    init: function init() {
      this.reinit();
      if (this.quiz.questions.length > 0) {
        this.questions = this.quiz.questions;
        for (var q = 0; q < this.questions.length; q++) {
          // if(this.questions[q].required_question_id){
          //   this.switchs[q] = true;
          // }
          // else{
          //   this.switchs[q] = false;
          // }
          if (!this.questions[q].data || this.questions[q].data.length <= 0) {
            if (!this.questions[q].data) {
              this.questions[q].data = [];
            }
            this.questions[q].data.push({ name: "", question: null, color: '' });
          }
        }
      }

      var parent = this;
      this.$nextTick(function () {
        $(".make-switch").bootstrapSwitch();
        this.listenerSwitch();
        $('[data-toggle="tooltip"]').tooltip();
      });
    },
    reinit: function reinit() {
      this.questions = [{
        title: "",
        description: "",
        type: "",
        data: [{
          name: "",
          question: null,
          color: ""
        }],
        min: null,
        max: null,
        colors: [],
        color_no_response: "#00b0f0"
      }];
      // this.switchs = [false];
      this.questionsToDelete = [];
    },
    addData: function addData(choice) {
      if (choice.question.type == 'checkbox' || choice.question.type == 'radio') {
        choice.question.data.push({ name: '', color: '' });
      }
      this.$forceUpdate();
      $('[data-toggle="tooltip"]').tooltip();
    },
    forceUpdate: function forceUpdate() {
      this.$forceUpdate();
    },
    listenerSwitch: function listenerSwitch() {
      // var parent = this;
      // $('.make-switch').on('switchChange.bootstrapSwitch', function(event, state){
      //   var index = this.getAttribute("data-index");
      //   parent.switchs[index] = state;
      //   if(!state){
      //     parent.questions[index].required_question_id = "";
      //     parent.questions[index].required_question_value = "";
      //   }
      //   parent.$forceUpdate();
      // });
    },
    saveQuestions: function saveQuestions(exit) {
      if (this.questions.length <= 0) {
        toastr.error("Vous devez ajouter des questions à votre questionnaire !", "ERREUR");
        return;
      }
      $('#form_questions_create').parsley().validate();
      if ($("#form_questions_create").parsley().isValid()) {

        var parent = this;
        // Si la question a un ID alors update sinon create.
        var questionsToCreate = [];
        var questionsToUpdate = [];
        for (var i = 0; i < this.questions.length; i++) {
          // for(var d=0;d<this.questions[i].data.length;d++){
          //   var val = this.questions[i].data[d].name.trim().toLowerCase();
          //   val = val.replace(/\s/g,'_'); // On remplace les espaces par _ ;
          //   this.questions[i].data[d]["value"] = val;
          // }

          // if(this.questions[i].required_question_value){
          //   var val = this.questions[i].required_question_value.trim().toLowerCase();
          //   val = val.replace(/\s/g,'_'); // On remplace les espaces par _ ;
          //   this.questions[i].required_question_value = val;
          // }

          this.questions[i]['order'] = i; // On rajoute son ordre dans la liste.
          if (this.questions[i].id) {
            // Update chaque question. (Pb: On sait pas si elle a été modif. flood de requête possiblement inutile).
            questionsToUpdate.push(this.questions[i]);
          } else {
            questionsToCreate.push(this.questions[i]);
          }
        }

        var maxStep = questionsToCreate.length > 0 ? 1 : 0;
        maxStep += questionsToUpdate.length;
        maxStep += this.questionsToDelete.length;

        var val = 0;
        var errorsToUpdate = [];
        var errorsToDelete = [];
        var errorToCreate = false;

        var end = function end() {
          val++;
          parent.$root.$emit('progressBar', true, 0, maxStep, val, "Etape " + val + " sur " + maxStep);
          if (val == maxStep) {

            var success = false;
            var msg = "";
            if (errorsToUpdate.length > 0) {
              toastr.options.closeButton = true;
              if (errorsToUpdate.length == 1) {
                toastr.error(errorsToUpdate.length + " question n'a pas pu être mise à jour.", "ERREUR");
              } else {
                toastr.error(errorsToUpdate.length + " questions n'ont pas pu être mises à jour.", "ERREUR");
              }
            } else {
              if (questionsToUpdate.length - errorsToUpdate.length > 0) {
                success = true;
                var questions_update = questionsToUpdate.length - errorsToUpdate.length;
                if (questions_update == 1) {
                  msg += "1 question a été mise à jour.";
                } else {
                  msg += questions_update + " questions ont été mises à jour.";
                }
              }
            }

            if (errorsToDelete.length > 0) {
              toastr.options.closeButton = true;
              if (errorsToDelete.length == 1) {
                toastr.error(errorsToDelete.length + " question n'a pas pu être supprimée.", "ERREUR");
              } else {
                toastr.error(errorsToDelete.length + " questions n'ont pas pu être supprimées.", "ERREUR");
              }
            } else {
              if (parent.questionsToDelete.length - errorsToDelete.length > 0) {
                success = true;
                var questions_delete = parent.questionsToDelete.length - errorsToDelete.length;
                msg += msg != "" ? "<br>" : "";
                if (questions_delete == 1) {
                  msg += "1 question a été supprimée.";
                } else {
                  msg += questions_delete + " questions ont été supprimées.";
                }
              }
            }

            if (questionsToCreate.length > 0) {
              if (errorToCreate) {
                toastr.options.closeButton = true;
                if (questionsToCreate.length == 1) {
                  toastr.error(questionsToCreate.length + " question n'a pas pu être créé.", "ERREUR");
                } else {
                  toastr.error(questionsToCreate.length + " questions n'ont pas pu être créés.", "ERREUR");
                }
              } else {
                success = true;
                msg += msg != "" ? "<br>" : "";
                if (questionsToCreate.length == 1) {
                  msg += "1 question a été crée.";
                } else {
                  msg += questionsToCreate.length + " questions ont été crées.";
                }
              }
            }

            parent.$root.$emit('progressBar', false);
            parent.reinit();

            if (success) {
              toastr.options.closeButton = true;
              toastr.options.timeOut = 7000;
              toastr.success(msg);
              parent.getQuestions(parent.quiz.slug);
            }

            if (exit) {
              parent.$router.push({ name: "quizzes_list" });
            } else {
              parent.show.share = true;
            }
          }
        };

        this.$root.$emit('progressBar', true, 0, maxStep, 0, "Etape 0 sur " + maxStep);
        // MAJ des QUESTIONS EXISTANTES
        for (var u = 0; u < questionsToUpdate.length; u++) {
          __WEBPACK_IMPORTED_MODULE_1__requests_questions_js___default.a.updateById(this, questionsToUpdate[u].id, questionsToUpdate[u], function (question, err) {
            if (!question || err) {
              errorsToUpdate.push(err);
            }
            end();
          });
        }

        // CREATION DES QUESTIONS
        if (questionsToCreate.length > 0) {
          __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.createQuestions(this, this.quiz.slug, questionsToCreate, function (questions, err) {
            if (!questions || err) {
              errorToCreate = true;
            }
            end();
          });
        }

        // SUPPRESSION DES QUESTIONS qui ont été supprimées.
        for (var q = 0; q < this.questionsToDelete.length; q++) {
          __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.removeQuestionById(this, this.quiz.slug, this.questionsToDelete[q], function (err) {
            if (err) {
              errorsToDelete.push(err);
            }
            end();
          });
        }
      }
    },
    removeQuestion: function removeQuestion(index) {
      console.log(index
      // Si ID alors on sauvegarde l'id de la question à supprimer.
      );if (this.questions[index].id) {
        this.questionsToDelete.push(this.questions[index].id);
      }
      // this.switchs.splice(index,1);
      this.questions.splice(index, 1);
    },
    addQuestion: function addQuestion(index) {
      index = index == undefined ? this.questions.length : index;
      this.questions.splice(index, 0, {
        title: "",
        description: "",
        type: "",
        data: [{
          name: "",
          question: null,
          color: ""
        }],
        min: null,
        max: null,
        colors: [],
        color_no_response: '#00b0f0'
      });
      // this.switchs.push(false);
      this.$nextTick(function () {
        $(".make-switch").bootstrapSwitch();
        $('[data-toggle="tooltip"]').tooltip();
        this.listenerSwitch();
      });
    },
    getQuestions: function getQuestions(quizSlug) {
      // Récupérer les questions du questionnaire pour MAJ le quiz.questions correctement.
      var parent = this;
      var slug = quizSlug ? quizSlug : parent.$route.params.slug;
      __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getQuestions(parent, quizSlug, function (questions, err) {
        if (questions) {
          parent.quiz.questions = questions;
          parent.$parent.forceUpdate();
        } else {
          toastr.error("Impossible de récupérer les questions du questionnaire.", "ERREUR");
        }
        parent.$forceUpdate();
      });
    },
    moveQuestion: function moveQuestion(index, new_index) {
      var questionToMove = this.questions[index];
      this.questions.splice(new_index, 0, questionToMove);
      var old_index = new_index <= index ? index + 1 : index;
      this.questions.splice(old_index, 1);
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.

    // Réinit le quiz si on est sur la route quizzes_edit et qu'on click sur quizzes_create.
    this.reinit();
    next();
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_users_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_users_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_users_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["quiz"],
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    this.reinit();
  },
  watch: {
    'quiz.groups': function quizGroups() {
      this.$forceUpdate();
    },
    '$route': function $route() {
      this.reinit(true);
    }
  },
  methods: {
    forceUpdate: function forceUpdate() {
      this.$forceUpdate();
    },
    reinit: function reinit() {
      var forceReload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


      $('.date-picker').datepicker({
        format: 'dd/mm/yyyy',
        language: 'fr'
      });
      if (this.quiz.date_deadline && !forceReload) {
        console.error(this.quiz.date_deadline);
        $("#date_deadline").datepicker("setDate", new Date(this.quiz.date_deadline));
      } else {
        $("#date_deadline").datepicker("setDate", "");
      }
    },
    removeGroup: function removeGroup() {
      this.quiz.groups.pop();
      this.$forceUpdate();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.

    // Réinit le quiz si on est sur la route quizzes_edit et qu'on click sur quizzes_create.
    this.reinit();
    next();
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__others_report_preconization_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__others_report_preconization_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__others_report_preconization_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_quiz_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_quiz_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__store_quiz_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quizzes_export_pdf',
  components: {
    ReportPreconization: __WEBPACK_IMPORTED_MODULE_1__others_report_preconization_vue___default.a
  },
  data: function data() {
    return {
      quizObj: {
        quiz: {}
      },
      number: 1,
      analysis: {
        questions: []
      },
      file_pdf: {
        name: "ExportPDF",
        href: ""
      },
      show: {
        graph: true,
        responses: true,
        participants: true,
        analysis: true,
        report: true
      },
      dataSetRO: [],
      columnsRO: [],
      preconizations: []
    };
  },

  computed: {
    nbQuestionsOpenOutMultiple: function nbQuestionsOpenOutMultiple() {
      return this.quizObj.nbQuestionsOpenOutMultiple ? this.quizObj.nbQuestionsOpenOutMultiple() : 0;
    },
    nbQuestionsOpen: function nbQuestionsOpen() {
      return this.quizObj.nbQuestionsOpen ? this.quizObj.nbQuestionsOpen() : 0;
    },
    nbParticipants: function nbParticipants() {
      return this.quizObj.nbParticipants ? this.quizObj.nbParticipants() : 0;
    },
    dateNow: function dateNow() {
      return new Date().toLocaleDateString();
    }
  },
  mounted: function mounted() {
    this.getQuiz();
  },
  methods: {
    haveText: function haveText(question) {
      if (question.type == "checkbox_multiple" || question.type == "radio_multiple") {
        for (var d = 0; d < question.data.length; d++) {
          if (question.data[d].question && question.data[d].question.type == "text") return true;
        }
      }
      return false;
    },
    filterParticipants: function filterParticipants(groupId) {
      var groupName = this.getGroup(groupId);
      for (var f = 0; f < this.quizObj.filters.length; f++) {
        if (this.quizObj.filters[f].name == groupName) {
          return true;
        }
      }
      return false;
    },
    refresh: function refresh() {
      this.quizObj.statsResponses();
      this.getListResponsesOpen();
    },
    changeAllGraphType: function changeAllGraphType(type) {
      for (var q = 0; q < this.quizObj.quiz.questions.length; q++) {
        this.$set(this.quizObj.quiz.questions[q], 'graphType', type);
        for (var d = 0; d < this.quizObj.quiz.questions[q].data.length; d++) {
          if (this.quizObj.quiz.questions[q].data[d].question) {
            this.$set(this.quizObj.quiz.questions[q].data[d].question, 'graphType', type);
          }
        }
      }
      this.quizObj.statsResponses();
    },
    changeGraphType: function changeGraphType(question, questionParent) {
      if (!question.graphType || question.graphType == "simple") {
        this.$set(question, 'graphType', "détaillé");
      } else {
        this.$set(question, 'graphType', "simple");
      }
      // this.$forceUpdate();   // $set permet d'éviter le $forceUpdate !
      questionParent = questionParent ? questionParent : question;
      this.quizObj.statsResponses(questionParent);
    },
    changeLegendeType: function changeLegendeType(question, questionParent) {
      if (!question.legendeType || question.legendeType == "below") {
        this.$set(question, 'legendeType', "above");
      } else {
        this.$set(question, 'legendeType', "below");
      }
      // this.$forceUpdate();   // $set permet d'éviter le $forceUpdate !
      questionParent = questionParent ? questionParent : question;
      this.quizObj.statsResponses(questionParent);
    },
    changeAllLegendesType: function changeAllLegendesType(type) {
      for (var q = 0; q < this.quizObj.quiz.questions.length; q++) {
        this.$set(this.quizObj.quiz.questions[q], 'legendeType', type);
        for (var d = 0; d < this.quizObj.quiz.questions[q].data.length; d++) {
          if (this.quizObj.quiz.questions[q].data[d].question) {
            this.$set(this.quizObj.quiz.questions[q].data[d].question, 'legendeType', type);
          }
        }
      }
      this.quizObj.statsResponses();
    },
    getClass: function getClass(data) {
      var classes = "";
      data.forEach(function (col) {
        if (col.toString().indexOf('tr-green') >= 0) {
          classes += " tr-green ";
        }
        if (col.toString().indexOf('tr-green-light') >= 0) {
          classes += ' tr-green-light ';
        }
      });
      return classes;
    },
    getDate: function getDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getGroup: function getGroup(groupId) {
      for (var g = 0; g < this.quizObj.quiz.groups.length; g++) {
        if (this.quizObj.quiz.groups[g].id.toString() == groupId.toString()) {
          return this.quizObj.quiz.groups[g].name;
        }
      }
    },
    getQuiz: function getQuiz() {
      var parent = this;
      var slugQuiz = this.$route.params.slug;

      new __WEBPACK_IMPORTED_MODULE_2__store_quiz_js___default.a(this, slugQuiz, this.number, function (err, quizObj) {
        if (quizObj) {
          parent.quizObj = quizObj;
          parent.getPreconizations();
          parent.getListResponsesOpen();

          if (quizObj.quiz) {
            __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getAnalysis(parent, parent.$route.params.slug, function (analysis, err) {
              if (analysis) {
                // parent.quizObj.quiz["analysis"] = analysis;
                parent.analysis = analysis;
              }

              parent.$nextTick(function () {
                // parent.statsGroups();
                parent.quizObj.statsResponses();
              });
            });
          }
        }
      });
    },
    getPreconizations: function getPreconizations() {
      var parent = this;
      this.quizObj.getPreconizations(this, this.$route.params.slug, function (preconizations, err) {
        if (preconizations) {
          parent.$forceUpdate();
        }
      });
    },
    getListResponsesOpen: function getListResponsesOpen() {
      var res = this.quizObj.prepareList();
      this.dataSetRO = res.dataSet;
      this.columnsRO = res.columns;
    },
    exportPDF: function exportPDF() {
      var parent = this;
      $("<style type='text/css'>" + this.exportCSS() + "</style>").appendTo("head");
      $(".page").each(function (index) {
        // console.log("height0",$(this).height(),$(this).attr("id"));
        if ($(this).height() > 762 && $(this).attr("id") != 'graphiques') {
          var q = Math.ceil($(this).height() / 761.5);
          $(this).css('height', q * 761.5);
          $(this).height(q * 761.5);
          // console.log("height:",$(this).height(),this);
        }
      });

      var doc_svg = document.getElementsByClassName("highcharts-container");
      for (var d = 0; d < doc_svg.length; d++) {
        var svg = doc_svg[d].children[0];
        if (svg) {
          var classItems = svg.getElementsByClassName("highcharts-legend-item");
          for (var i = 0; i < classItems.length; i++) {
            if (classItems[i].children[0]) {
              classItems[i].children[0].style.fontSize = "10px";
            }
          }
        }
      }

      var html = $("#exportPdf").html();
      // var html = document.documentElement.innerHTML;
      // console.log("CSS",parent.extractCSS());
      __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.exportPDF(this, this.$route.params.slug, html, function (buffer, err) {
        if (buffer) {
          parent.file_pdf.href = "data:application/pdf;base64," + buffer.$data;
          parent.$nextTick(function () {
            $("#btPDF")[0].click();
          });
        } else {
          toastr.error("", "Erreur");
        }
      });
    },
    getPages: function getPages() {
      return "{{page}} / {{pages}}";
    },
    exportCSS: function exportCSS() {
      var special_css = ".hide-pdf{display:none} .highcharts-button{display:none;}";
      return special_css + '\n      @import url(\'https://fonts.googleapis.com/css?family=Open+Sans\');\n      #bodyPDF .text-center{\n        text-align:center;\n      }\n\n      #bodyPDF h1{\n        font-size:35px;\n        font-weight:300;\n        font-family:\'Open Sans\',\'sans-serif\';\n        padding-top:10px;\n        padding-bottom:10px;\n        line-height:1.1;\n        margin-top:0px;\n        margin-bottom:0px;\n      }\n\n      #bodyPDF h2{\n        font-size:28px !important;\n        font-weight:300;\n        font-family:\'Open Sans\',\'sans-serif\';\n        padding-top:10px;\n        padding-bottom:10px;\n        line-height:1.1;\n        margin-top:0px;\n        margin-bottom:0px;\n      }\n\n      #bodyPDF h3{\n        font-size:22px;\n        font-weight:300;\n        font-family:\'Open Sans\',\'sans-serif\';\n        padding-top:10px;\n        padding-bottom:10px;\n        line-height:1.1;\n        margin-top:0px;\n        margin-bottom:0px;\n      }\n\n      #bodyPDF h4{\n        font-size:17px;\n        font-weight:300;\n        font-family:\'Open Sans\',\'sans-serif\';\n        padding-top:10px;\n        padding-bottom:10px;\n        line-height:1.1;\n        margin-top:0px;\n        margin-bottom:0px;\n      }\n\n      #bodyPDF h5{\n        font-size:15px;\n        font-weight:300;\n        font-family:\'Open Sans\',\'sans-serif\';\n        padding-top:10px;\n        padding-bottom:10px;\n        line-height:1.1;\n        margin-top:0px;\n        margin-bottom:0px;\n      }\n\n      #bodyPDF p{\n        margin:0px!important\n      }\n\n      #bodyPDF em{\n        margin:0px !important;\n      }\n\n      .logo-transferh-full {\n        width:250px;;\n        background-position: center;\n        background-repeat: no-repeat;\n        margin:auto;\n        height: 100px;\n        background-size:100%;\n      \tbackground-image: url(data:image/png;base64,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);\n      }\n\n      #cover{\n        /*height: 47em;*/\n        height: 754px;\n        background-color:#ececec;\n      }\n\n      #exportPdf body{\n        background-color: transparent;\n        width:40em;\n        border:1px dashed black;\n        padding-top: 0.5em !important;\n        padding-right: 0.5em !important;\n        padding-bottom: 0.5em !important;\n        padding-left: 0.5em !important;\n      }\n\n      #pageFooter-first{\n        height: 52px;\n        background-color: #818181;\n        color:white;\n        font-style: italic;\n        margin-top:0px;\n        padding-top:10px;\n      }\n\n      #pageHeader-first{\n        height: 52px;\n        background-color: #818181;\n        color:white;\n        padding-top:10px;\n        font-style: italic;\n      }\n\n      #pageHeader{\n        background-color: #818181;\n        color:white;\n        font-style: italic;\n        padding-top:10px;\n        padding-left:10px;\n        padding-right:10px;\n        height:52px;\n        font-size: 13px;\n        font-family: Arial;\n      }\n\n      #pageFooter{\n        background-color: #818181;\n        color:white;\n        font-style: italic;\n        height: 52px;\n        margin-top:0px;\n        padding-top:10px;\n        padding-left:5px;\n        padding-right:5px;\n        font-size: 13px;\n        font-family: Arial;\n      }\n\n      #bodyPDF .page{\n        min-height: 761.5px;\n        margin:0px!important;\n        background-color:white;\n      }\n\n      .bloc_graphique{\n        border:1px solid white;\n        height:378px;\n        padding-left: 0px;\n        padding-right: 0px;\n        margin:0px!important;\n        overflow:hidden;\n      }\n\n      .tr-green-light{\n        background-color: #e3efd8;\n      }\n\n      .mt-0{  margin-top:0px;}\n      .mt-10{  margin-top:10px;}\n      .mt-20{  margin-top:20px;}\n      .mt-30{  margin-top:30px;}\n      .mt-50{  margin-top:50px;}\n\n      .ml-5 {margin-left: 5px;}\n      .ml-10 {margin-left: 10px;}\n      .ml-20 {margin-left: 20px;}\n      .ml-30 {margin-left: 30px;}\n      .ml-50 {margin-left: 50px;}\n      .ml-55 {margin-left: 55px;}\n      .ml-60 {margin-left: 60px;}\n\n      .mr-10 {margin-right: 10px;}\n      .mr-20 {margin-right: 20px;}\n      .mr-30 {margin-right: 30px;}\n\n      .mb-50{  margin-bottom: 50px;}\n      .mb-30{  margin-bottom: 30px;}\n      .mb-20{  margin-bottom: 20px;}\n      .mb-10{  margin-bottom: 10px;}\n\n      .m-30 {margin:30px;}\n\n      .pl-30 {padding-left: 30px!important;}\n      .pb-50 {padding-bottom: 50px!important;}\n      .pb-100 {padding-bottom: 100px!important;}\n\n      .pt-30 {padding-top: 30px!important;}\n      .pt-40 {padding-top: 40px!important;}\n\n      .pr-30 {padding-right: 30px;}\n\n      .p-0 {padding: 0px !important;}\n      .m-0 {margin:0px !important;}\n\n      #bodyPDF table{\n        width: 100%;\n        margin: auto;\n      }\n\n      #bodyPDF table{\n        font-size: 14px;\n      }\n\n      #bodyPDF table td{\n        padding: 7px;\n      }\n\n      #bodyPDF table th{\n        padding: 7px;\n        background-color: #8fd24f;\n      }\n\n      #bodyPDF{\n        font-family: sans-serif;\n      }\n      ';
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage_data_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage_data_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__storage_data_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__others_list_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__others_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__others_list_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quizzes_list',
  components: {
    List: __WEBPACK_IMPORTED_MODULE_2__others_list_vue___default.a
  },
  data: function data() {
    return {
      dataSet: [],
      columns: [],
      showPopup: {
        remove: false,
        duplicate: false
      },
      quizToRemove: null,
      quizToDuplicate: null,
      newTitle: ""
    };
  },

  mounted: function mounted() {
    this.getData();
  },
  methods: {
    showData: function showData(quizzes, error) {
      var parent = this;
      if (!error) {
        parent.dataSet = [];
        // console.log("show data",quizzes.length);
        for (var a = 0; a < quizzes.length; a++) {
          var tr = [];
          tr.push(quizzes[a].title);
          tr.push(quizzes[a].date_created ? new Date(quizzes[a].date_created).toLocaleDateString() : "");
          tr.push(quizzes[a].date_deadline ? new Date(quizzes[a].date_deadline).toLocaleDateString() : "");
          tr.push(quizzes[a].groups.length);
          tr.push(quizzes[a].company ? quizzes[a].company.name : "");
          var state = "";
          switch (quizzes[a].state) {
            case "draft":
              state = '<span class="label label-sm label-warning"> Brouillon </span>';
              break;
            case "published":
              state = '<span class="label label-sm label-success"> Publié </span>';
              break;
          }
          tr.push(state);
          var actions = quizzes[a].state == "published" ? '<a data-route-name="quizzes_responses" data-slug="' + quizzes[a].slug + '" class="btn btn-default text-right btn-circle btn_table btn_perso"><i class="icon-eye"></i></a>' : "";
          actions += quizzes[a].state == 'draft' ? '<a data-route-name="quizzes_edit" data-slug="' + quizzes[a].slug + '" class="btn btn-default btn-circle text-right ml-5 btn_table btn_perso"><i class="icon-note"></i></a>' : "";
          actions += quizzes[a].state == 'published' ? '<a data-route-name="quizzes_edit" data-slug="' + quizzes[a].slug + '" class="btn btn-default btn-circle text-right ml-5 btn_table btn_perso"><i class="icon-share"></i></a>' : "";
          actions += '<a class="btn btn-default text-right ml-5 btn_table btn-circle btn_duplicate" data-index="' + a + '"><i class="icon-docs"></i></a>';
          actions += '<a class="btn btn-default text-right ml-5 btn_table btn-circle btn_remove" data-index="' + a + '"><i class="icon-trash"></i></a>';
          tr.push(actions);

          parent.dataSet.push(tr);
        }

        $(document).off('click', '.btn_perso');
        $(document).on('click', '.btn_perso', function () {
          parent.$router.push({ name: this.getAttribute("data-route-name"), params: { slug: this.getAttribute("data-slug") } });
        });

        $(document).off('click', '.btn_remove');
        $(document).on('click', '.btn_remove', function () {
          parent.showPopup.remove = true;
          parent.quizToRemove = quizzes[this.getAttribute("data-index")];
        });

        $(document).off('click', '.btn_duplicate');
        $(document).on('click', '.btn_duplicate', function () {
          parent.showPopup.duplicate = true;
          parent.quizToDuplicate = quizzes[this.getAttribute("data-index")];
        });

        parent.columns = [];
        parent.columns.push({ title: "Titre" });
        parent.columns.push({ title: "Date de création" });
        parent.columns.push({ title: "Date limite" });
        parent.columns.push({ title: "Nombre de groupe" });
        parent.columns.push({ title: "Entreprise" });
        parent.columns.push({ title: "Etat" });
        parent.columns.push({ title: "Actions", "searchable": false, "orderable": false, class: "text-right" });
      } else {
        toastr.error("ERREUR dans la récupération des questionnaires.");
      }
    },
    getData: function getData() {
      var parent = this;

      if (__WEBPACK_IMPORTED_MODULE_1__storage_data_js___default.a.data.user.role == "dev") {
        __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getAll(this, function (quizzes, error) {
          parent.showData(quizzes, error);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getAllMyQuizzes(this, function (quizzes, error) {
          parent.showData(quizzes, error);
        });
      }
    },
    removeQuiz: function removeQuiz() {
      var parent = this;
      __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.removeBySlug(this, this.quizToRemove.slug, function (count, err) {
        if (err) {
          toastr.error(err, "ERREUR");
        } else {
          toastr.success("Le questionnaire " + parent.quizToRemove.title + " a été supprimé.");
        }
        parent.getData();
        parent.showPopup.remove = false;
        parent.quizToRemove = null;
      });
    },
    duplicateQuiz: function duplicateQuiz() {
      $("#formDuplicate").parsley().validate();
      if ($("#formDuplicate").parsley().isValid()) {
        var parent = this;
        __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.duplicateBySlug(this, this.quizToDuplicate.slug, this.newTitle, function (count, err) {
          if (err) {
            toastr.error(err, "ERREUR");
          } else {
            toastr.success("Le questionnaire " + parent.quizToDuplicate.title + " a été dupliqué en " + parent.newTitle);
            parent.newTitle = "";
            parent.getData();
            parent.showPopup.duplicate = false;
            parent.quizToDuplicate = null;
          }
        });
      }
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preconizations_analysis__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preconizations_analysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__preconizations_analysis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preconizations_list__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preconizations_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__preconizations_list__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// var config = require('../../config/settings.json');



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Analysis: __WEBPACK_IMPORTED_MODULE_1__preconizations_analysis___default.a,
    ListActions: __WEBPACK_IMPORTED_MODULE_2__preconizations_list___default.a
  },
  data: function data() {
    return {
      show: {
        analysis: false,
        list_actions: true
      },
      quiz: {}
    };
  },

  watch: {
    'show.analysis': function showAnalysis() {
      if (this.show.analysis) {
        this.show.list_actions = false;
      }
    },
    'show.list_actions': function showList_actions() {
      if (this.show.list_actions) {
        this.show.analysis = false;
      }
    }
  },
  mounted: function mounted() {
    var parent = this;
    __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getBySlug(this, this.$route.params.slug, function (quiz, err) {
      if (quiz) {
        parent.quiz = quiz;
      } else {
        parent.quiz = null;
        toastr.error("Impossible de récupérer le questionnaire.", "ERREUR");
      }
    });
  },
  methods: {}
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},
  data: function data() {
    return {
      quiz: {},
      analysis: {
        questions: []
      },
      error: ""
    };
  },

  mounted: function mounted() {
    var parent = this;
    if (this.$route.params && this.$route.params.slug) {
      __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getBySlug(this, this.$route.params.slug, function (quiz, err) {
        if (quiz) {
          __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getQuestions(parent, parent.$route.params.slug, function (questions, err_questions) {
            if (questions) {
              quiz["questions"] = questions;
              // Get les ANALYSE.
              __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getAnalysis(parent, parent.$route.params.slug, function (analysis, err) {
                if (analysis) {
                  quiz["analysis"] = analysis;
                  parent.analysis = analysis;
                } else {
                  var noOpenQuestion = true;
                  for (var q = 0; q < quiz.questions.length; q++) {
                    if (quiz.questions[q].type == "text") {
                      noOpenQuestion = false;
                    }
                    var data = [];
                    if (quiz.questions[q].type == "checkbox_multiple" || quiz.questions[q].type == "radio_multiple") {
                      for (var d = 0; d < quiz.questions[q].data.length; d++) {
                        if (quiz.questions[q].data[d].question && quiz.questions[q].data[d].question.type == "text") {
                          noOpenQuestion = false;
                        }
                        data.push({ text: "", parent: quiz.questions[q].data[d].name, questionId: quiz.questions[q].id });
                      }
                    }

                    parent.analysis.questions.push({
                      text: "",
                      questionId: quiz.questions[q].id,
                      data: data
                    });
                  }
                  if (noOpenQuestion) {
                    parent.analysis.questions = [];
                  }
                }
                parent.quiz = quiz;
              });
            } else {
              parent.error = "Impossible de récupérer les questions du questionnaire.";
              toastr.error("Impossible de récupérer les questions du questionnaire.", "ERREUR");
            }
          });
        } else {
          parent.quiz = null;
          toastr.error("Impossible de récupérer le questionnaire.", "ERREUR");
        }
      });
    } else {
      this.quiz = null;
    }
  },
  methods: {
    haveText: function haveText(question) {
      if (question.type == "checkbox_multiple" || question.type == "radio_multiple") {
        for (var d = 0; d < question.data.length; d++) {
          if (question.data[d].question && question.data[d].question.type == "text") return true;
        }
      }
      return false;
    },
    saveAnalysis: function saveAnalysis() {
      var parent = this;
      if (this.quiz.analysis) {
        __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.updateAnalysis(this, this.quiz.slug, this.analysis, function (analysis, err) {
          if (analysis) {
            toastr.success("L'analyse a bien été mise à jour.");
          } else {
            toastr.error("Impossible de mettre à jour l'analyse.", "ERREUR");
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.createAnalysis(this, this.quiz.slug, this.analysis, function (analysis, err) {
          if (analysis) {
            parent.quiz.analysis = analysis;
            toastr.success("L'analyse a bien été créée.");
          } else {
            toastr.error("Impossible de créer l'analyse.", "ERREUR");
          }
        });
      }
    }
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__others_list_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__others_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__others_list_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},

  components: {
    List: __WEBPACK_IMPORTED_MODULE_0__others_list_vue___default.a
  },
  props: ["quiz"],
  data: function data() {
    return {
      dataSet: [],
      columns: [],
      showPopup: {
        remove: false,
        actions: false
      },
      preconizationToRemove: null,
      preconizationToShow: null
    };
  },

  mounted: function mounted() {
    this.getData();
  },
  methods: {
    removePreconizationAction: function removePreconizationAction(id) {
      var parent = this;
      __WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js___default.a.removePreconizationById(this, this.$route.params.slug, id, function (err) {
        if (err) {
          toastr.error("Impossible de supprimer la préconisation.", "ERREUR");
        } else {
          parent.getData();
          toastr.success("La préconisation a bien été supprimée.");
        }
        parent.showPopup.remove = false;
        parent.preconizationToRemove = null;
      });
    },
    showData: function showData(preconizations) {
      var parent = this;
      parent.dataSet = [];
      for (var a = 0; a < preconizations.length; a++) {
        var tr = [];
        tr.push(preconizations[a].number);
        tr.push(preconizations[a].title);
        tr.push(preconizations[a].description);
        tr.push(preconizations[a].actions.length);
        // tr.push(preconizations[a].deadline);
        // var actions = '<a data-index="'+a+'" class="btn btn-default btn-circle text-right ml-5 btn_table btn_show_actions"><i class="icon-eye"></i></a>';
        var actions = '<a data-route-name="quizzes_preconizations_edit_action" data-slug="' + parent.$route.params.slug + '" data-id="' + preconizations[a].id + '" class="btn btn-default btn-circle text-right ml-5 btn_table btn_perso"><i class="icon-note"></i></a>';
        actions += '<a class="btn btn-default text-right ml-5 btn_table btn-circle btn_remove" data-index="' + a + '"><i class="icon-trash"></i></a>';
        tr.push(actions);

        parent.dataSet.push(tr);
      }

      $(document).off('click', '.btn_perso');
      $(document).on('click', '.btn_perso', function () {
        parent.$router.push({ name: this.getAttribute("data-route-name"), params: { slug: this.getAttribute("data-slug"), id: this.getAttribute("data-id") } });
      });

      $(document).off('click', '.btn_remove');
      $(document).on('click', '.btn_remove', function () {
        parent.showPopup.remove = true;
        parent.preconizationToRemove = preconizations[this.getAttribute("data-index")];
      });

      parent.columns = [];
      parent.columns.push({ title: "N°" });
      parent.columns.push({ title: "Titre" });
      parent.columns.push({ title: "Description" });
      parent.columns.push({ title: "Nombre d'actions" });
      // parent.columns.push({title:"Délai de réalisation"});
      parent.columns.push({ title: "Actions", "searchable": false, "orderable": false, class: "text-right" });
    },
    getData: function getData() {
      var parent = this;
      __WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js___default.a.getPreconizations(this, this.$route.params.slug, function (preconizations, err) {
        if (preconizations) {
          parent.showData(preconizations);
        } else {
          toastr.error("Impossible de récupérer les préconisations du questionnaire.", "ERREUR");
        }
      });
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},

  props: [""],
  data: function data() {
    return {
      preconization: {
        number: 1,
        title: "",
        description: "",
        actions: [{
          number: 1.1,
          title: "",
          description: "",
          deadline: ""
        }]
      }
    };
  },

  mounted: function mounted() {
    var parent = this;
    if (this.$route.params.id) {
      // Edition préco.
      __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getPreconizationById(this, this.$route.params.slug, this.$route.params.id, function (preconization, err) {
        if (preconization) {
          parent.preconization = preconization;
        } else {
          parent.preconization = null;
          toastr.error("Impossible de récupérer cette préconisation.", "ERREUR");
        }
      });
    } else {
      // Creation nouvelle préco.
      __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getPreconizations(this, this.$route.params.slug, function (preconizations, err) {
        if (preconizations) {
          // Déterminer automatiquement le n° de la préconisation.
          // Attention si le number est modifiable. Alors l'automatisation risque de merder si le mec ne saisie pas dans l'ordre.
          if (preconizations.length > 0) {
            parent.preconization.number = preconizations[preconizations.length - 1].number + 1;
            parent.preconization.actions[0].number = parent.preconization.number + ".1";
          }
        } else {
          toastr.warning("Impossible de calculer le numéro de cette nouvelle préconisation.", "Attention");
        }
      });
    }
  },
  methods: {
    addAction: function addAction() {
      var num = this.preconization.number;
      num += "." + (this.preconization.actions.length + 1);
      num = parseFloat(num);
      this.preconization.actions.push({
        number: num,
        title: "",
        description: "",
        deadline: ""
      });
    },
    removeAction: function removeAction(index) {
      this.preconization.actions.splice(index, 1);
      // MAJ tous les n° des actions.
      for (var a = 0; a < this.preconization.actions.length; a++) {
        var num = this.preconization.number;
        num += "." + (a + 1);
        num = parseFloat(num);
        this.preconization.actions[a].number = num;
      }
    },
    savePreconization: function savePreconization() {
      $('#newAction').parsley().validate();
      if ($("#newAction").parsley().isValid()) {
        if (this.$route.params.id) {
          this.updatePreconization();
        } else {
          this.createPreconization();
        }
      }
    },
    createPreconization: function createPreconization() {
      var parent = this;
      __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.createPreconization(this, this.$route.params.slug, this.preconization, function (preconization, err) {
        if (preconization) {
          toastr.success("La nouvelle préconisation a bien été créée.");
          parent.$router.push({ name: 'quizzes_preconizations' });
        } else {
          toastr.error(err, "ERREUR");
        }
      });
    },
    updatePreconization: function updatePreconization() {
      var parent = this;
      __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.updatePreconizationById(this, this.$route.params.slug, this.$route.params.id, this.preconization, function (preconization, err) {
        if (preconization) {
          toastr.success("La préconisation a bien été enregistrée.");
          parent.$router.push({ name: 'quizzes_preconizations' });
        } else {
          toastr.error(err, "ERREUR");
        }
      });
    }
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__others_list_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__others_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__others_list_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__others_report_preconization_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__others_report_preconization_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__others_report_preconization_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},

  components: {
    List: __WEBPACK_IMPORTED_MODULE_0__others_list_vue___default.a,
    ReportPreconization: __WEBPACK_IMPORTED_MODULE_2__others_report_preconization_vue___default.a
  },
  props: [],
  data: function data() {
    return {
      dataSet: [],
      columns: [],
      show: {
        table: true,
        report: false
      },
      quiz: {},
      preconizations: []
    };
  },

  watch: {
    'show.table': function showTable() {
      if (this.show.table) {
        this.show.report = false;
      }
    },
    'show.report': function showReport() {
      if (this.show.report) {
        this.show.table = false;
      }
    }
  },
  mounted: function mounted() {
    var parent = this;
    __WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js___default.a.getBySlug(this, this.$route.params.slug, function (quiz, err) {
      if (quiz) {
        parent.quiz = quiz;
        parent.getData();
      } else {
        parent.quiz = null;
        toastr.error("Impossible de récupérer le questionnaire.", "ERREUR");
      }
    });
  },
  methods: {
    showData: function showData(preconizations) {
      var parent = this;
      parent.dataSet = [];
      // console.log("show data",quizzes.length);
      for (var a = 0; a < preconizations.length; a++) {
        var tr = [];
        tr.push("<span class='preconisation_line'>" + preconizations[a].number + "</span>");
        tr.push("<span class='preconisation_line'>" + preconizations[a].title + "</span>");
        tr.push("<span class='preconisation_line'>" + preconizations[a].description + "</span>");
        tr.push("<span class='preconisation_line'></span>");
        parent.dataSet.push(tr);

        for (var i = 0; i < preconizations[a].actions.length; i++) {
          tr = [];
          tr.push(preconizations[a].actions[i].number);
          tr.push(preconizations[a].actions[i].title);
          tr.push(preconizations[a].actions[i].description);
          tr.push(preconizations[a].actions[i].deadline);
          parent.dataSet.push(tr);
        }
      }

      parent.columns = [];
      parent.columns.push({ title: "N°" });
      parent.columns.push({ title: "Titre" });
      parent.columns.push({ title: "Description" });
      parent.columns.push({ title: "Délai de réalisation" });
    },
    getData: function getData() {
      var parent = this;
      __WEBPACK_IMPORTED_MODULE_1__requests_quizzes_js___default.a.getPreconizations(this, this.$route.params.slug, function (preconizations, err) {
        if (preconizations) {
          parent.preconizations = preconizations;
          parent.showData(preconizations);
        } else {
          toastr.error("Impossible de récupérer les préconisations du questionnaire.", "ERREUR");
        }
      });
    }
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quizzes',
  data: function data() {
    return {};
  },

  mounted: function mounted() {},
  activated: function activated() {},
  methods: {}
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__others_list_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__others_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__others_list_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_quiz_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_quiz_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__store_quiz_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// var config = require('../../config/settings.json');




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["number", "quizSlug"],
  components: {
    List: __WEBPACK_IMPORTED_MODULE_1__others_list_vue___default.a
  },
  data: function data() {
    return {
      quizObj: {
        quiz: {}
      },
      filters: [],
      show: {
        graph: true,
        tab: false,
        participants: false
      },
      columns: [],
      dataSet: [],
      columnsParticipants: [],
      dataSetParticipants: [],
      file_responses: {
        name: "",
        href: ""
      },
      file_participants: {
        name: "",
        href: ""
      }
    };
  },

  watch: {
    'show.graph': function showGraph() {
      if (this.show.graph) {
        this.show.tab = false;
        this.show.participants = false;
      }
    },
    'show.tab': function showTab() {
      if (this.show.tab) {
        this.show.graph = false;
        this.show.participants = false;
      }
    },
    'show.participants': function showParticipants() {
      if (this.show.participants) {
        this.show.graph = false;
        this.show.tab = false;
      }
    },
    'quizSlug': function quizSlug() {
      this.reinit();
      this.init();
    }
  },
  computed: {
    nbQuestionsOpenOutMultiple: function nbQuestionsOpenOutMultiple() {
      return this.quizObj.nbQuestionsOpenOutMultiple ? this.quizObj.nbQuestionsOpenOutMultiple() : 0;
    },
    nbQuestionsOpen: function nbQuestionsOpen() {
      return this.quizObj.nbQuestionsOpen ? this.quizObj.nbQuestionsOpen() : 0;
    },
    nbParticipants: function nbParticipants() {
      return this.quizObj.nbParticipants ? this.quizObj.nbParticipants() : 0;
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    reinit: function reinit() {
      this.quizObj = {
        quiz: {}
      };
      this.columns = [], this.dataSet = [], this.columnsParticipants = [];
      this.dataSetParticipants = [];
      this.file_responses = {
        name: "",
        href: ""
      }, file_participants = {
        name: "",
        href: ""
      };
    },
    init: function init() {
      var parent = this;
      var slugQuiz = this.quizSlug ? this.quizSlug : this.$route.params.slug;
      new __WEBPACK_IMPORTED_MODULE_2__store_quiz_js___default.a(this, slugQuiz, this.number, function (err, quizObj) {
        if (quizObj) {
          parent.quizObj = quizObj;
          parent.createChart();
        }
      });
    },
    refresh: function refresh() {
      this.quizObj.statsResponses();
      this.statsGroups();
      this.prepareList();
      this.prepareListParticipants();
    },
    createCSV: function createCSV(columns, dataSet, file) {
      var csvContent = "";
      for (var i = 0; i < columns.length; i++) {
        csvContent += columns[i].title + ";";
      }
      csvContent += "\n";
      for (var a = 0; a < dataSet.length; a++) {
        var dataString = "";
        for (var c = 0; c < columns.length; c++) {
          // Vérifier qu'il n'y est pas de , ou ; dans la valeur sinon le formattage d'excel va buguer.
          var val = dataSet[a][c].toString();
          if (dataSet[a][c].toString().indexOf("<span") >= 0) {
            // On enleve la balise qu'on a rajouté précédemment.
            var index_first = val.indexOf(">");
            var index_last = val.lastIndexOf("<");
            val = val.substring(index_first + 1, index_last);
          }

          if (val.indexOf(",") <= 0 || val.indexOf(";") <= 0) {
            dataString += '"' + val + '"' + ";";
          } else {
            dataString += val + ";";
          }
        }
        dataString += "\n";
        csvContent += dataString;
      }

      file.href = "data:text/csv;charset=UTF-8,%ef%bb%bf" + encodeURI(csvContent);
      if (!file.name) {
        file.name = this.quizObj.quiz.slug;
      }
    },
    statsGroups: function statsGroups() {
      var dataProvider = this.quizObj.statsGroups();
      var chart = AmCharts.makeChart("chartdiv" + this.number, {
        "type": "pie",
        "theme": "light",
        "dataProvider": dataProvider,
        "valueField": "participants",
        "titleField": "groupe",
        "balloon": {
          "fixedPosition": true
        },
        "export": {
          "enabled": false
        }
      });
    },
    changeAllGraphType: function changeAllGraphType(type) {
      for (var q = 0; q < this.quizObj.quiz.questions.length; q++) {
        this.$set(this.quizObj.quiz.questions[q], 'graphType', type);
        for (var d = 0; d < this.quizObj.quiz.questions[q].data.length; d++) {
          if (this.quizObj.quiz.questions[q].data[d].question) {
            this.$set(this.quizObj.quiz.questions[q].data[d].question, 'graphType', type);
          }
        }
      }
      this.quizObj.statsResponses();
    },
    changeAllLegendesType: function changeAllLegendesType(type) {
      for (var q = 0; q < this.quizObj.quiz.questions.length; q++) {
        this.$set(this.quizObj.quiz.questions[q], 'legendeType', type);
        for (var d = 0; d < this.quizObj.quiz.questions[q].data.length; d++) {
          if (this.quizObj.quiz.questions[q].data[d].question) {
            this.$set(this.quizObj.quiz.questions[q].data[d].question, 'legendeType', type);
          }
        }
      }
      this.quizObj.statsResponses();
    },
    changeGraphType: function changeGraphType(question, questionParent) {
      if (question.graphType == "simple") {
        this.$set(question, 'graphType', "détaillé");
      } else {
        this.$set(question, 'graphType', "simple");
      }
      // this.$forceUpdate();   // $set permet d'éviter le $forceUpdate !
      questionParent = questionParent ? questionParent : question;
      this.quizObj.statsResponses(questionParent);
    },
    changeLegendeType: function changeLegendeType(question, questionParent) {
      if (!question.legendeType || question.legendeType == "below") {
        this.$set(question, 'legendeType', "above");
      } else {
        this.$set(question, 'legendeType', "below");
      }
      // this.$forceUpdate();   // $set permet d'éviter le $forceUpdate !
      questionParent = questionParent ? questionParent : question;
      this.quizObj.statsResponses(questionParent);
    },
    createChart: function createChart() {
      var parent = this;
      this.$nextTick(function () {
        parent.statsGroups();
        parent.quizObj.statsResponses();
        parent.prepareList();
        parent.prepareListParticipants();
      });
    },
    prepareList: function prepareList() {
      var res = this.quizObj.prepareList();
      this.dataSet = res.dataSet;
      this.columns = res.columns;

      this.file_responses.name = this.quizObj.quiz.slug + "_QO.csv";
      this.createCSV(this.columns, this.dataSet, this.file_responses);
    },
    prepareListParticipants: function prepareListParticipants() {
      var res = this.quizObj.prepareListParticipants();
      this.dataSetParticipants = res.dataSetParticipants;
      this.columnsParticipants = res.columnsParticipants;

      this.file_participants.name = this.quizObj.quiz.slug + "_participants.csv";
      this.createCSV(this.columnsParticipants, this.dataSetParticipants, this.file_participants);
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var config = __webpack_require__(5);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["quiz"],
  data: function data() {
    return {
      config: config
    };
  },

  watch: {
    'quiz.groups': function quizGroups() {
      // console.log("QUIZ GROUPS EDIT",this.quiz.groups)
    }
  },
  mounted: function mounted() {
    // console.log("QUI GROUPZ",this.quiz.groups);
    this.$forceUpdate();
  },
  methods: {}
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests_responses_js__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests_responses_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__requests_responses_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quizzes_show',
  data: function data() {
    return {
      quiz: {},
      response: {
        firstname: "",
        lastname: "",
        birthday: "",
        groupId: "",
        questions: []
      },
      question_index: -1,
      isFinish: false,
      error: ""
    };
  },

  mounted: function mounted() {
    var parent = this;
    parent.$nextTick(function () {
      $('.date-picker').datepicker({
        format: 'dd/mm/yyyy',
        startView: "decade",
        minViewMode: "day",
        language: 'fr'
      });
    });
    if (this.$route.params.slug && this.$route.query && this.$route.query.group) {
      // récupérer les groupes.
      parent.$root.$emit('loading', true, true);
      __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getBySlug(parent, parent.$route.params.slug, function (quiz, err) {
        if (err) {
          parent.$root.$emit('loading', false, false);
          parent.quiz = null;
          toastr.error("Impossible de récupérer le questionnaire " + parent.$route.params.slug + ".", "ERREUR");
        } else {
          if (quiz.groups) {
            for (var g = 0; g < quiz.groups.length; g++) {
              if (quiz.groups[g].slug == parent.$route.query.group) {
                parent.response.groupId = quiz.groups[g].id;
              }
            }
            if (quiz.groups.length > 0 && parent.response.groupId == "") {
              parent.$root.$emit('loading', false, false);
              parent.error = "Votre numéro de groupe est invalide.";
              toastr.error("Votre numéro de groupe est invalide.", "ERREUR");
              return;
            }
          }

          if (quiz && quiz.state == 'published') {
            var date_isValid = true;
            if (quiz.date_deadline) {
              var date_now = new Date();
              date_now.setMinutes(0);
              date_now.setHours(0);
              date_now.setSeconds(0);
              date_now.setMilliseconds(0);
              var date_deadline = new Date(quiz.date_deadline);
              if (date_deadline.getTime() < date_now.getTime()) {
                date_isValid = false;
              }
            }
            if (date_isValid) {
              __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.getQuestions(parent, parent.$route.params.slug, function (questions, err) {
                if (questions) {
                  parent.quiz = quiz;
                  parent.quiz['questions'] = questions;
                  for (var c = 0; c < questions.length; c++) {
                    if (questions[c].type == "checkbox_multiple" || questions[c].type == "radio_multiple") {
                      if (parent.quiz.questions[c].type == "checkbox_multiple") {
                        parent.response.questions[c] = { value: [], noResponse: false, data: [] };
                      } else {
                        parent.response.questions[c] = { value: "", noResponse: false, data: [] };
                      }

                      for (var p = 0; p < questions[c].data.length; p++) {
                        if (questions[c].data[p].question && questions[c].data[p].question.type == 'scale') {
                          var min = questions[c].data[p].question.min && questions[c].data[p].question.min != '' ? questions[c].data[p].question.min : 0;
                          var max = questions[c].data[p].question.max && questions[c].data[p].question.max != '' ? questions[c].data[p].question.max : 10;
                          var i = min < max ? min : max;
                          var scaleRange = [];
                          while (i <= max) {
                            scaleRange.push(i);
                            i++;
                          }
                          parent.response.questions[c].data.push({ value: "", parentValue: questions[c].data[p].name, noResponse: false, scaleRange: scaleRange });
                        } else if (questions[c].data[p].question && questions[c].data[p].question.type == 'checkbox') {
                          parent.response.questions[c].data.push({ value: [], parentValue: questions[c].data[p].name, noResponse: false });
                        } else {
                          parent.response.questions[c].data.push({ value: "", parentValue: questions[c].data[p].name, noResponse: false });
                        }
                      }
                    } else if (questions[c].type == "checkbox") {
                      parent.response.questions[c] = { value: [], noResponse: false };
                    } else if (questions[c].type == "scale") {
                      parent.response.questions[c] = { value: "", noResponse: false, scaleRange: [] };
                      var min = questions[c].min && questions[c].min != '' ? questions[c].min : 0;
                      var max = questions[c].max && questions[c].max != '' ? questions[c].max : 10;
                      var i = min < max ? min : max;
                      while (i <= max) {
                        parent.response.questions[c].scaleRange.push(i);
                        i++;
                      }
                    } else {
                      parent.response.questions[c] = { value: "", noResponse: false };
                    }
                  }

                  parent.$root.$emit('loading', false, false);
                } else {
                  parent.$root.$emit('loading', false, false);
                  parent.error = "Impossible de récupérer les questions du formulaire.";
                  toastr.error("Impossible de récupérer les questions du formulaire.", "ERREUR");
                }
              });
            } else {
              parent.$root.$emit('loading', false, false);
              parent.error = "La date limite des réponses à ce questionnaire a été dépassée.";
              toastr.error("La date limite des réponses est dépassée. Vous ne pouvez plus répondre à ce questionnaire.", "ERREUR");
            }
          } else {
            parent.$root.$emit('loading', false, false);
            parent.error = "Ce questionnaire n'est pas publié.";
            toastr.error("Ce questionnaire n'est pas publié.", "ERREUR");
          }
        }
      });
    } else if (!this.$route.params.slug) {
      parent.quiz = null;
    }

    if (!this.$route.query || !this.$route.query.group) {
      parent.error = "Impossible de récupérer votre numéro de groupe.";
      toastr.error("Impossible de récupérer votre numéro de groupe.", "ERREUR");
    }
  },
  methods: {
    inputChange: function inputChange(question_index, data_index) {
      if (data_index != null && question_index != null) {
        this.response.questions[question_index].data[data_index].noResponse = false;
      } else if (question_index != null) {
        this.response.questions[question_index].noResponse = false;
      }
      this.$forceUpdate();
    },
    reValidateInput: function reValidateInput(id, index, data_index) {
      this.$forceUpdate();
      this.$nextTick(function () {
        $("#" + id).parsley().validate();
        // Check si la case a été cochée. Alors réinit les inputs.
        if (index != null) {
          if (this.response.questions[index].noResponse) {
            if (this.quiz.questions[index].type == "checkbox_multiple" || "checkbox") {
              this.response.questions[index].value = [];
            } else {
              this.response.questions[index].value = "";
            }
            if (this.response.questions[index].data) {
              for (var d = 0; d < this.response.questions[index].data.length; d++) {
                if (this.quiz.questions[index].data[d].question.type == "checkbox") {
                  this.response.questions[index].data[d].value = [];
                } else {
                  this.response.questions[index].data[d].value = "";
                }
              }
            }
            this.$forceUpdate();
          } else if (data_index != null) {
            if (this.quiz.questions[index].data[data_index].question.type == "checkbox") {
              this.response.questions[index].data[data_index].value = [];
            } else {
              this.response.questions[index].data[data_index].value = "";
            }
            this.$forceUpdate();
          }
        }
      });
    },
    startQuiz: function startQuiz() {
      $("#startQuiz").parsley().validate();
      if ($("#startQuiz").parsley().isValid()) {
        var parent = this;
        var birthday = $("#date_birthday").datepicker("getDate");
        __WEBPACK_IMPORTED_MODULE_1__requests_responses_js___default.a.isAuthorized(this, this.quiz.slug, this.response.groupId, this.response.firstname, this.response.lastname, birthday, function (err) {
          if (err) {
            toastr.error(err, "ERREUR");
          } else {
            parent.question_index++;
          }
        });
      }
    },
    sendQuiz: function sendQuiz() {
      $("#question" + this.question_index).parsley().validate();
      if ($("#question" + this.question_index).parsley().isValid()) {
        // this.question_index++;
        this.$forceUpdate();
        var parent = this;
        this.response.birthday = $("#date_birthday").datepicker("getDate");
        __WEBPACK_IMPORTED_MODULE_0__requests_quizzes_js___default.a.createResponses(this, this.quiz.slug, this.response, function (rep, err) {
          if (rep) {
            parent.question_index++;
            parent.isFinish = true;
          } else {
            toastr.error(err, "ERREUR");
          }
        });
      }
    },
    validateQuestion: function validateQuestion() {
      $("#question" + this.question_index).parsley().validate();
      if ($("#question" + this.question_index).parsley().isValid()) {
        this.question_index++;
      }
    },
    removeError: function removeError() {
      $("#question" + this.question_index).parsley().reset();
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__storage_data_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests_users_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requests_users_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__requests_users_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'settings',
  data: function data() {
    return {
      user: __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a.data.user,
      showPopup: {
        confirm: false,
        password: false,
        success: false
      },
      password: "",
      newPassword: ""
    };
  },

  mounted: function mounted() {
    // $('#formEditPassword').parsley().subscribe('parsley:field:validate', function () {});
  },
  methods: {
    reValidateInput: function reValidateInput(id) {
      setTimeout(function () {
        $("#" + id).parsley().validate();
      }, 50);
    },
    updateUser: function updateUser() {
      $('#formSettings').parsley().validate();
      if ($("#formSettings").parsley().isValid()) {
        this.showPopup.confirm = true;
      }
    },
    validateUpdate: function validateUpdate() {
      $('#formPassword').parsley().validate();
      if ($("#formPassword").parsley().isValid()) {

        var credentials = {
          username: this.user.username,
          password: this.password
        };
        var parent = this;
        __WEBPACK_IMPORTED_MODULE_1__requests_users_js___default.a.verifyPassword(this, credentials, function (isOk) {
          if (isOk) {
            parent.showPopup.confirm = false;
            parent.password = "";
            // On MAJ l'USER !!!
            __WEBPACK_IMPORTED_MODULE_1__requests_users_js___default.a.updateById(parent, parent.user.id, parent.user, function (user, err) {
              if (user) {
                parent.showPopup.success = true;
              } else {
                toastr.error(err, "ERREUR");
              }
            });
          } else {
            toastr.error("Mot de passe incorrect.", "ERREUR");
          }
        });
      }
    },
    editPassword: function editPassword() {
      $('#formEditPassword').parsley().validate();
      if ($("#formEditPassword").parsley().isValid()) {
        var credentials = {
          oldPassword: this.password,
          newPassword: this.newPassword
        };
        var parent = this;
        __WEBPACK_IMPORTED_MODULE_1__requests_users_js___default.a.changePassword(this, credentials, function (err) {
          if (!err) {
            parent.showPopup.password = false;
            parent.password = "";
            parent.newPassword = "";
            parent.showPopup.success = true;
          } else {
            toastr.error(err, "ERREUR");
          }
        });
      }
    },
    logout: function logout() {
      if (__WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a) {
        __WEBPACK_IMPORTED_MODULE_0__storage_data_js___default.a.logout();
      }
      this.$router.push({ name: 'login' });
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_users_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_users_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_users_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var user = {
  email: "",
  username: "",
  firstname: "",
  lastname: "",
  role: ""
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'users_create',
  data: function data() {
    return {
      user: user
    };
  },

  mounted: function mounted() {
    var parent = this;
    if (this.$route.params && this.$route.params.id) {
      //Récupérer le produit à éditer.
      __WEBPACK_IMPORTED_MODULE_0__requests_users_js___default.a.getById(this, this.$route.params.id, function (user, err) {
        if (err) {
          toastr.error("Impossible de récupérer l'utilisateur " + parent.$route.params.id + ".", "ERREUR");
          parent.user = null;
        } else {
          parent.user = user;
        }
      });
    }
  },
  methods: {
    createUser: function createUser() {
      $('#form_user_create').parsley().validate();
      if ($("#form_user_create").parsley().isValid()) {
        var parent = this;
        __WEBPACK_IMPORTED_MODULE_0__requests_users_js___default.a.create(this, this.user, function (user, err) {
          if (user) {
            toastr.success("L'utilisateur " + user.email + " a été ajouté.");
            parent.$router.push({ name: 'users_list' });
          } else {
            toastr.error(err, "ERREUR");
          }
        });
      }
    },
    updateUser: function updateUser() {
      $('#form_user_create').parsley().validate();
      if ($("#form_user_create").parsley().isValid()) {
        var parent = this;
        __WEBPACK_IMPORTED_MODULE_0__requests_users_js___default.a.updateById(this, this.user.id, this.user, function (user, err) {
          if (user) {
            toastr.options.closeButton = true;
            toastr.success("L'utilisateur " + user.email + " a été mise à jour.");
            parent.$router.push({ name: 'users_list' });
          } else {
            toastr.error(err, "ERREUR");
          }
        });
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.

    // Réinit le user si on est sur la route users_edit et qu'on click sur users_create.
    this.user = user;
    next();
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_users_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requests_users_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__requests_users_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__others_list_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__others_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__others_list_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'users_list',
  components: {
    List: __WEBPACK_IMPORTED_MODULE_1__others_list_vue___default.a
  },
  data: function data() {
    return {
      dataSet: [],
      columns: []
    };
  },

  mounted: function mounted() {
    this.getData();
  },
  methods: {
    getData: function getData() {
      var parent = this;
      __WEBPACK_IMPORTED_MODULE_0__requests_users_js___default.a.getAll(this, function (users, error) {
        if (!error) {
          parent.dataSet = [];
          for (var a = 0; a < users.length; a++) {
            var tr = [];
            tr.push(users[a].email);
            tr.push(users[a].username);
            tr.push(users[a].firstname);
            tr.push(users[a].lastname);
            tr.push(users[a].role == 'dev' ? '<span class="label label-sm label-success">Développeur</span>' : users[a].role);
            tr.push('<a data-route-name="users_edit" data-id="' + users[a].id + '" class="btn btn-default btn-circle text-right ml-5 btn_table"><i class="icon-note"></i></a>');

            parent.dataSet.push(tr);
          }

          $(document).off('click', '.btn_table');
          $(document).on('click', '.btn_table', function () {
            parent.$router.push({ name: this.getAttribute("data-route-name"), params: { id: this.getAttribute("data-id") } });
          });

          parent.columns = [];
          parent.columns.push({ title: "Email" });
          parent.columns.push({ title: "Username" });
          parent.columns.push({ title: "Prénom" });
          parent.columns.push({ title: "Nom" });
          parent.columns.push({ title: "Role" });
          parent.columns.push({ title: "Actions", "searchable": false, "orderable": false, class: "text-right" });
        } else {
          toastr.error("ERREUR dans la récupération des utilisateurs.");
        }
      });
    }
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'users_show',
  data: function data() {
    return {};
  },

  mounted: function mounted() {},
  activated: function activated() {},
  methods: {}
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'users',
  data: function data() {
    return {};
  },

  mounted: function mounted() {},
  activated: function activated() {},
  methods: {}
});

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__(13);

var _router2 = _interopRequireDefault(_router);

var _vueResource = __webpack_require__(14);

var _vueResource2 = _interopRequireDefault(_vueResource);

var _data = __webpack_require__(2);

var _data2 = _interopRequireDefault(_data);

var _App = __webpack_require__(8);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueResource2.default); // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


_vue2.default.config.productionTip = false;

_vue2.default.http.headers.common['Authorization'] = _data2.default.data.session.id;

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  created: function created() {
    var self = this;
    _vue2.default.http.interceptors.push(function (request, next) {
      // Bloquer les requêtes si on est sur une route qui nécessite une authentification et qu'on est déco.

      if (self.$route.meta.requiresAuth && _data2.default.data.session.authenticated) {
        next(function (response) {
          // Si token invalid alors la session a expirée. On se déco.
          if (response && response.data && response.data.error && response.data.error.code == "INVALID_TOKEN") {
            _data2.default.logout();
            // console.log("SELF ROUTE",self.$route)
            toastr.clear();
            toastr.error("Votre session a expirée.", "ERREUR");
            self.$router.push({ name: "login", query: { redirect: self.$route.fullPath } });
          }
          if (response.status <= 304 && _data2.default.data && _data2.default.data.session && _data2.default.data.session.userId) {
            // Refresh du token +1h.
            _data2.default.refreshToken(self);
          }
        });
      } else if (!self.$route.meta.requiresAuth) {
        next();
      }
    });
  },
  mounted: function mounted() {
    // console.log("THIS ROOT",this)

    this.$on("loading", function (value, text, forceValue) {
      this.$children[0].$emit('loading', value, text, forceValue);
    });

    this.$on("progressBar", function (enabled, min, max, val, text) {
      this.$children[0].$emit('progressBar', enabled, min, max, val, text);
    });
  },
  components: { App: _App2.default }
});

_router2.default.beforeEach(function (to, from, next) {
  // window.scrollTo(0, 0)  > Remplacer par la fonction scrollBehavior dans router. 
  // Si utilisateur déco, rediriger vers le login.
  // console.log("ROUTER BEFORE EARCH",to,from);

  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (_data2.default && _data2.default.data && _data2.default.data.session && _data2.default.data.session.authenticated === true) {
      next();
    } else {
      next({ name: "login", query: { redirect: to.fullPath } });
      // next({
      //   path: '/login',
      //   query: { redirect: to.fullPath }
      // })
    }
  } else {
    next // make sure to always call next()!
    ();
  }
});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _tools = __webpack_require__(7);

var _tools2 = _interopRequireDefault(_tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = __webpack_require__(5);

exports.default = {
    updateById: function updateById(context, id, question, callback) {
        context.$root.$emit('loading', true);
        context.$http.patch(config.api_url + "questions/" + id, question).then(function (response) {
            callback(response.data, null);
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(null, _tools2.default.translate(response.data));
        });
    }
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _tools = __webpack_require__(7);

var _tools2 = _interopRequireDefault(_tools);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = __webpack_require__(5);

exports.default = {
    isAuthorized: function isAuthorized(context, slugQuiz, groupId, firstname, lastname, birthday, callback) {
        var data = {
            firstname: firstname,
            lastname: lastname,
            birthday: birthday
        };
        context.$root.$emit('loading', true);
        context.$http.post(config.api_url + "responses/" + slugQuiz + "/" + groupId + "/isAuthorized/", data).then(function (response) {
            callback(null); // response.data = null;
            context.$root.$emit('loading', false);
        }, function (response) {
            context.$root.$emit('loading', false);
            callback(_tools2.default.translate(response.data));
        });
        // /:quizSlug/isAuthorized
    }
};

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_transferh.8310650.png";

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(61)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(114),
  /* scopeId */
  "data-v-5a1bbcf1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(58)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(111),
  /* scopeId */
  "data-v-42206899",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(52)
__webpack_require__(51)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  "data-v-1fd1911f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(69)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(121),
  /* scopeId */
  "data-v-a9e89170",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(65)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  "data-v-7504849a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(68)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(120),
  /* scopeId */
  "data-v-935ef1dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(50)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(105),
  /* scopeId */
  "data-v-1e474940",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(73)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(124),
  /* scopeId */
  "data-v-c01088dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(72)
__webpack_require__(71)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(123),
  /* scopeId */
  "data-v-be2af906",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(56)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(109),
  /* scopeId */
  "data-v-255b3d34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(75)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(126),
  /* scopeId */
  "data-v-d9b01eb8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(55)
__webpack_require__(54)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(108),
  /* scopeId */
  "data-v-22a3ced2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(49)
__webpack_require__(48)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  "data-v-1933eed9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(59)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(112),
  /* scopeId */
  "data-v-588e5ba0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(70)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(122),
  /* scopeId */
  "data-v-a9fcdb14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(62)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(115),
  /* scopeId */
  "data-v-6782d0e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(57)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(110),
  /* scopeId */
  "data-v-2cbf114b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(67)
__webpack_require__(66)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  "data-v-7e17bfda",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(45)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(102),
  /* scopeId */
  "data-v-087bccdd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(64)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  "data-v-6a1caa9d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(77)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(128),
  /* scopeId */
  "data-v-f73e7102",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(53)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(107),
  /* scopeId */
  "data-v-1ff9aa5e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(63)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(116),
  /* scopeId */
  "data-v-68968277",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('ul', {
    staticClass: "page-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Accueil")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-circle"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_vm._v("Paramètre du compte")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "portlet light portlet-fit portlet-form bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "id": "formSettings"
    }
  }, [_c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstname),
      expression: "user.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "",
      "data-parsley-trigger": "change"
    },
    domProps: {
      "value": (_vm.user.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.firstname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastname),
      expression: "user.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "",
      "data-parsley-trigger": "change"
    },
    domProps: {
      "value": (_vm.user.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.lastname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "",
      "data-parsley-type": "email",
      "data-parsley-trigger": "change"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-3 col-md-9"
  }, [_c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.updateUser()
      }
    }
  }, [_vm._v("Valider les modifications")]), _vm._v(" "), _c('a', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }, [_vm._v("Annuler")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "mt-element-ribbon bg-grey-steel"
  }, [_vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "ribbon-content"
  }), _c('div', {
    staticClass: "mt-element-list",
    staticStyle: {
      "margin-top": "-25px"
    }
  }, [_c('div', {
    staticClass: "mt-list-container list-simple"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "note note-info"
  }, [_c('h4', {
    staticClass: "block"
  }, [_vm._v(" Changement de mot de passe ?")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.showPopup.password = true
      }
    }
  }, [_vm._v("Changer mon mot de passe")])])])])]), _vm._v(" "), _c('p')])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup.confirm),
      expression: "showPopup.confirm"
    }],
    staticClass: "sweet-alert showSweetAlert visible",
    staticStyle: {
      "border": "1px dashed gray",
      "display": "block"
    },
    attrs: {
      "data-allow-outside-click": "false",
      "data-animation": "pop"
    }
  }, [_vm._m(6), _vm._v(" "), _c('h2', [_vm._v("Sécurité ")]), _vm._v(" "), _vm._m(7), _c('form', {
    attrs: {
      "id": "formPassword"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Mot de passe actuel",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "sa-button-container"
  }, [_c('button', {
    staticClass: "cancel btn btn-lg btn-default btn-danger",
    on: {
      "click": function($event) {
        _vm.showPopup.confirm = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "sa-confirm-button-container"
  }, [_c('button', {
    staticClass: "confirm btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.validateUpdate()
      }
    }
  }, [_vm._v("Valider")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup.success),
      expression: "showPopup.success"
    }],
    staticClass: "sweet-alert showSweetAlert visible",
    staticStyle: {
      "border": "1px dashed gray",
      "display": "block"
    },
    attrs: {
      "data-allow-outside-click": "false",
      "data-animation": "pop"
    }
  }, [_vm._m(8), _vm._v(" "), _c('h2', [_vm._v("Félicitation ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "sa-button-container"
  }, [_c('div', {
    staticClass: "sa-confirm-button-container"
  }, [_c('button', {
    staticClass: "confirm btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.showPopup.success = false;
        _vm.logout()
      }
    }
  }, [_vm._v("Ok")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup.password),
      expression: "showPopup.password"
    }],
    staticClass: "sweet-alert showSweetAlert visible",
    staticStyle: {
      "border": "1px dashed gray",
      "display": "block"
    },
    attrs: {
      "data-allow-outside-click": "false",
      "data-animation": "pop"
    }
  }, [_c('div', {
    staticClass: "sa-icon sa-info",
    staticStyle: {
      "display": "block"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Changement de mot de passe ")]), _vm._v(" "), _c('p', {
    staticClass: "lead text-muted text-left"
  }), _c('form', {
    attrs: {
      "id": "formEditPassword"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Mot de passe actuel",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control mt-10",
    attrs: {
      "type": "password",
      "placeholder": "Nouveau mot de passe",
      "autocomplete": "off",
      "required": "",
      "id": "newPassword",
      "data-parsley-equalto": "#confirmNewPassword",
      "data-parsley-error-message": "Les mots de passe ne correspondent pas."
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "change": function($event) {
        _vm.reValidateInput('confirmNewPassword')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control mt-10",
    attrs: {
      "type": "password",
      "placeholder": "Confirmation du nouveau mot de passe",
      "id": "confirmNewPassword",
      "data-parsley-equalto": "#newPassword",
      "data-parsley-error-message": "Les mots de passe ne correspondent pas.",
      "autocomplete": "off",
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.reValidateInput('newPassword')
      }
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "sa-button-container"
  }, [_c('button', {
    staticClass: "cancel btn btn-lg btn-default btn-danger",
    on: {
      "click": function($event) {
        _vm.showPopup.password = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "sa-confirm-button-container"
  }, [_c('button', {
    staticClass: "confirm btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.editPassword()
      }
    }
  }, [_vm._v("Valider")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: " icon-settings font-green"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject font-green sbold uppercase"
  }, [_vm._v("Mon compte")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Prénom\n                                "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Nom\n                                "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("Email\n                              "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ribbon  ribbon-clip ribbon-color-info uppercase"
  }, [_c('div', {
    staticClass: "ribbon-sub ribbon-clip"
  }), _vm._v(" Informations\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-warning"
  }, [_c('h4', {
    staticClass: "block"
  }, [_vm._v(" Avertissement")]), _vm._v(" "), _c('p', [_vm._v(" Pour valider toutes modifications votre mot de passe actuel vous sera demandé.")]), _vm._v(" "), _c('p', [_vm._v(" La modification de votre adresse email ou votre mot de passe entraînera le changement de vos identifiants de connexion ! ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sa-icon pulseWarning"
  }, [_c('i', {
    staticClass: "icon-lock text-warning",
    staticStyle: {
      "font-size": "50px",
      "position": "relative",
      "top": "30px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead text-muted text-left"
  }, [_vm._v("\n      Merci de saisir votre mot de passe pour valider les modifications que vous avez effectuées."), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sa-icon sa-success animate",
    staticStyle: {
      "display": "block"
    }
  }, [_c('span', {
    staticClass: "sa-line sa-tip animateSuccessTip"
  }), _vm._v(" "), _c('span', {
    staticClass: "sa-line sa-long animateSuccessLong"
  }), _vm._v(" "), _c('div', {
    staticClass: "sa-placeholder"
  }), _vm._v(" "), _c('div', {
    staticClass: "sa-fix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead text-muted text-left"
  }, [_vm._v("\n      Les changements ont été effectués. "), _c('br'), _vm._v(" Veuillez vous déconnecter pour que ces changements prennent effet.\n    ")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.quizObj && _vm.quizObj.quiz) ? _c('div', {
    staticClass: "row",
    class: {
      'mt-30': _vm.quizSlug
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.quizSlug),
      expression: "!quizSlug"
    }],
    staticClass: "col-xs-12 mb-10"
  }, [_c('h1', [_vm._v(_vm._s(_vm.quizObj.quiz.title))])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-2 col-md-3 col-sm-5 col-xs-5': !_vm.quizSlug, 'col-xs-4': _vm.quizSlug
    }
  }, [_c('div', {
    staticClass: "col-xs-12 p-0"
  }, [_c('span', {
    staticClass: "dashboard-stat dashboard-stat-v2 green nb_participants"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [(_vm.quizObj.quiz && _vm.quizObj.quiz.responses) ? _c('div', {
    staticClass: "number"
  }, [_c('span', {
    attrs: {
      "data-counter": "counterup",
      "data-value": _vm.quizObj.nbResponses()
    }
  }, [_vm._v(_vm._s(_vm.quizObj.nbResponses()))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v(" Réponses ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 p-0 mt-10"
  }, [_c('span', {
    staticClass: "dashboard-stat dashboard-stat-v2 yellow nb_participants"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [(!Number.isNaN(_vm.nbParticipants)) ? _c('div', {
    staticClass: "number"
  }, [_c('span', {
    attrs: {
      "data-counter": "counterup",
      "data-value": _vm.nbParticipants
    }
  }), _vm._v(_vm._s(_vm.nbParticipants) + "\n                  ")]) : _c('div', {
    staticClass: "number"
  }, [_c('img', {
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "src": "/static/img/infinite.svg",
      "alt": "symbole infini"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v(" Participants")])])])])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-4 col-md-9 col-sm-12 col-xs-12': !_vm.quizSlug, 'col-xs-8': _vm.quizSlug
    }
  }, [_c('div', {
    staticClass: "widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_filter"
  }, [_c('h4', {
    staticClass: "widget-thumb-heading text-uppercase "
  }, [_vm._v("Statistique par groupe")]), _vm._v(" "), _c('div', {
    staticClass: "widget-thumb-wrap"
  }, [_c('div', {
    staticClass: "graph_stat_group",
    attrs: {
      "id": 'chartdiv' + _vm.number
    }
  })])])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-3': !_vm.quizSlug, 'col-xs-6': _vm.quizSlug
    }
  }, [_c('div', {
    staticClass: "widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_filter"
  }, [_c('h4', {
    staticClass: "widget-thumb-heading text-uppercase"
  }, [_vm._v("Filtre")]), _vm._v(" "), _c('div', {
    staticClass: "widget-thumb-wrap"
  }, [_c('div', {
    staticClass: "mt-checkbox-list"
  }, _vm._l((_vm.quizObj.quiz.groups), function(group) {
    return _c('label', {
      staticClass: "mt-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.quizObj.filters),
        expression: "quizObj.filters"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": group,
        "checked": Array.isArray(_vm.quizObj.filters) ? _vm._i(_vm.quizObj.filters, group) > -1 : (_vm.quizObj.filters)
      },
      on: {
        "change": function($event) {
          _vm.refresh()
        },
        "__c": function($event) {
          var $$a = _vm.quizObj.filters,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = group,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.quizObj.filters = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.quizObj.filters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.quizObj.filters = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(group.name) + "\n                      "), _c('span')])
  }))])])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-3': !_vm.quizSlug, 'col-xs-6': _vm.quizSlug
    }
  }, [_c('div', {
    staticClass: "widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_actions"
  }, [_c('h4', {
    staticClass: "widget-thumb-heading  text-uppercase"
  }, [_vm._v("Actions")]), _vm._v(" "), _c('div', {
    staticClass: "row p-0"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-6 col-xs-6 mb-10"
  }, [_c('router-link', {
    staticClass: "btn btn-circle white",
    attrs: {
      "to": {
        name: 'quizzes_edit',
        params: {
          slug: _vm.quizObj.quiz.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v("\n                Partager le formulaire\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-6 col-xs-6 mb-10"
  }, [_c('router-link', {
    staticClass: "btn btn-circle green",
    attrs: {
      "to": {
        name: 'quizzes_preconizations',
        params: {
          slug: _vm.quizObj.quiz.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v("\n                Préconisations et analyses\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-6 col-xs-6 mb-10"
  }, [_c('a', {
    staticClass: "btn btn-circle yellow",
    attrs: {
      "href": _vm.file_responses.href,
      "download": _vm.file_responses.name,
      "title": "Télécharger les questions ouvertes"
    }
  }, [_c('i', {
    staticClass: "fa fa-download fs-20",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Télécharger QO\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-6 col-xs-6 mb-10"
  }, [_c('a', {
    staticClass: "btn btn-circle yellow",
    attrs: {
      "href": _vm.file_participants.href,
      "download": _vm.file_participants.name,
      "title": "Télécharger la liste des participants"
    }
  }, [_c('i', {
    staticClass: "fa fa-download fs-20",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Télécharger liste des participants\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-6 col-xs-6"
  }, [_c('router-link', {
    staticClass: "btn btn-circle yellow",
    attrs: {
      "to": {
        name: 'quizzes_export_pdf',
        params: {
          slug: _vm.quizObj.quiz.slug
        }
      },
      "title": "Rapport PDF"
    }
  }, [_c('i', {
    staticClass: "fa fa-print fs-20",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Export PDF ")])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.quizObj && _vm.quizObj.quiz) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "portlet light portlet-fit portlet-form bordered col-xs-12 p-0 ",
    attrs: {
      "id": "testExportPdf"
    }
  }, [_c('div', {
    staticClass: "portlet-title col-xs-12 "
  }, [_c('div', {
    staticClass: "caption tabbable-line p-0"
  }, [_c('ul', {
    staticClass: "nav nav-tabs "
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.graph = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Synthèse")])])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.show.tab = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-list"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Tableau QO")])])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.show.participants = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Participants ")])])])])])]), _vm._v(" "), (_vm.quizObj.quiz.questions) ? _c('div', {
    staticClass: "portlet-body col-xs-12 mb-30"
  }, [(_vm.show.graph && _vm.quizObj.quiz.responses.length > 0 && _vm.nbQuestionsOpenOutMultiple < _vm.quizObj.quiz.questions.length) ? _c('div', {
    staticClass: "col-xs-12 text-right mt-10"
  }, [_c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllGraphType('simple');
      }
    }
  }, [_vm._v("Graphiques simples")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllGraphType('détaillé');
      }
    }
  }, [_vm._v("Graphiques détaillés")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllLegendesType('below');
      }
    }
  }, [_vm._v("Légendes en dessous")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllLegendesType('above');
      }
    }
  }, [_vm._v("Légendes superposées")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.quizObj.quiz.questions), function(question, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.show.graph),
        expression: "show.graph"
      }]
    }, [(question.type != 'text') ? _c('div', [_c('div', {
      staticClass: "mt-element-ribbon col-xs-12 p-0"
    }, [_c('div', {
      staticClass: "ribbon ribbon-border-hor ribbon-clip ribbon-color-info uppercase"
    }, [_c('div', {
      staticClass: "ribbon-sub ribbon-clip"
    }), _vm._v(" Question n°" + _vm._s(index + 1) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 p-0 ml-10",
      staticStyle: {
        "margin-top": "-20px"
      }
    }, [_c('a', {
      staticClass: "btn btn-xs default",
      on: {
        "click": function($event) {
          _vm.changeGraphType(question);
        }
      }
    }, [_vm._v("Graphique " + _vm._s(question.graphType) + " "), (!question.graphType) ? _c('span', [_vm._v("détaillé")]) : _vm._e()]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs default",
      on: {
        "click": function($event) {
          _vm.changeLegendeType(question);
        }
      }
    }, [_vm._v("Légende "), (!question.legendeType || question.legendeType == 'below') ? _c('span', [_vm._v("superposée")]) : _c('span', [_vm._v("en dessous")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 p-0 text-center"
    }, [_c('h3', [_vm._v(_vm._s(question.title))]), _vm._v(" "), _c('div', {
      staticClass: "graph",
      staticStyle: {
        "margin-top": "30px"
      },
      attrs: {
        "id": 'container' + question.id + '-' + _vm.number
      }
    }, [_vm._v("Aucune réponse")])]), _vm._v(" "), _vm._l((question.data), function(data) {
      return (data.question && data.question.title && data.question.type != 'text') ? _c('div', {
        staticClass: "col-xs-12 p-0 text-center mt-30"
      }, [_c('h4', [_vm._v(_vm._s(data.name) + " - " + _vm._s(data.question.title))]), _vm._v(" "), _c('div', {
        staticClass: "text-left ml-10"
      }, [_c('a', {
        staticClass: "btn btn-xs default",
        on: {
          "click": function($event) {
            _vm.changeGraphType(data.question, question);
          }
        }
      }, [_vm._v("Graphique " + _vm._s(data.question.graphType) + " "), (!data.question.graphType) ? _c('span', [_vm._v("détaillé")]) : _vm._e()]), _vm._v(" "), _c('a', {
        staticClass: "btn btn-xs default",
        on: {
          "click": function($event) {
            _vm.changeLegendeType(data.question, question);
          }
        }
      }, [_vm._v("Légende "), (!data.question.legendeType || data.question.legendeType == 'below') ? _c('span', [_vm._v("superposée")]) : _c('span', [_vm._v("en dessous")])])]), _vm._v(" "), _c('div', {
        staticClass: "graph",
        staticStyle: {
          "margin-top": "30px"
        },
        attrs: {
          "id": 'container_child' + data.id + '-' + _vm.number
        }
      }, [_vm._v("Aucune réponse")])]) : _vm._e()
    })], 2) : _vm._e()])
  }), _vm._v(" "), (_vm.show.graph && _vm.nbQuestionsOpenOutMultiple >= _vm.quizObj.quiz.questions.length) ? _c('div', {
    staticClass: "col-xs-12 m-30"
  }, [_vm._v("\n                Ce questionnaire ne contient que des questions ouvertes !\n              ")]) : _vm._e(), _vm._v(" "), (_vm.show.graph && _vm.quizObj.quiz.responses.length > 0 && _vm.nbQuestionsOpenOutMultiple < _vm.quizObj.quiz.questions.length) ? _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllGraphType('simple');
      }
    }
  }, [_vm._v("Graphiques simples")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllGraphType('détaillé');
      }
    }
  }, [_vm._v("Graphiques détaillés")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllLegendesType('below');
      }
    }
  }, [_vm._v("Légendes en dessous")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllLegendesType('above');
      }
    }
  }, [_vm._v("Légendes superposées")])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.tab),
      expression: "show.tab"
    }]
  }, [(_vm.nbQuestionsOpen > 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('list', {
    attrs: {
      "columns": _vm.columns,
      "dataSet": _vm.dataSet,
      "id": 'qo' + _vm.number
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nbQuestionsOpen <= 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n                    Ce questionnaire ne contient pas de questions ouvertes !\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.participants),
      expression: "show.participants"
    }]
  }, [(_vm.quizObj.quiz.responses.length > 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('list', {
    attrs: {
      "columns": _vm.columnsParticipants,
      "dataSet": _vm.dataSetParticipants,
      "id": 'participants' + _vm.number
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.quizObj.quiz.responses.length <= 0) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n                    Ce questionnaire ne contient aucune réponse.\n                ")]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), (!_vm.quizObj.quiz.questions || (_vm.quizObj.quiz.questions && _vm.quizObj.quiz.questions.length <= 0)) ? _c('div', {
    staticClass: "col-xs-12 p-0 text-center"
  }, [_c('h3', [_vm._v("Aucune questions à ce questionnaire !")])]) : _vm._e()])]) : _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-md-12 page-404 mt-50"
  }, [_c('div', {
    staticClass: "number font-green"
  }, [_vm._v(" 404 ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Questionnaire non trouvé.")]), _vm._v(" "), _c('p', [_vm._v(" Nous n'avons pas réussi à trouver ce questionnaire.\n                  "), _c('br'), _vm._v("\n                  Vérifiez l'url et tentez de recharger la page.\n              ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual"
  }, [_c('i', {
    staticClass: "fa fa-group"
  })])
}]}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup.remove),
      expression: "showPopup.remove"
    }],
    staticClass: "sweet-alert showSweetAlert visible",
    staticStyle: {
      "border": "1px dashed gray",
      "display": "block"
    },
    attrs: {
      "data-allow-outside-click": "false",
      "data-animation": "pop"
    }
  }, [_c('div', {
    staticClass: "sa-icon sa-info",
    staticStyle: {
      "display": "block"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Confirmation")]), _vm._v(" "), (_vm.preconizationToRemove) ? _c('p', {
    staticClass: "lead text-muted text-left"
  }, [_vm._v("\n      Etes-vous sûr de vouloir supprimer la préconisation d'action « " + _vm._s(_vm.preconizationToRemove.name) + " » ?\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sa-button-container"
  }, [_c('button', {
    staticClass: "cancel btn btn-lg btn-default btn-danger",
    on: {
      "click": function($event) {
        _vm.showPopup.remove = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "sa-confirm-button-container"
  }, [_c('button', {
    staticClass: "confirm btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.removePreconizationAction(_vm.preconizationToRemove.id)
      }
    }
  }, [_vm._v("Oui")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup.actions),
      expression: "showPopup.actions"
    }],
    staticClass: "sweet-alert showSweetAlert visible popup_actions",
    staticStyle: {
      "border": "1px dashed gray",
      "display": "block"
    },
    attrs: {
      "data-allow-outside-click": "false",
      "data-animation": "pop"
    }
  }, [_c('h2', [_vm._v("Détail des actions de la préconisation "), (_vm.preconizationToShow) ? _c('span', [_vm._v(_vm._s(_vm.preconizationToShow.title))]) : _vm._e()]), _vm._v(" "), (_vm.preconizationToShow) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 mt-30 mb-30"
  }, [_vm._v("\n        " + _vm._s(_vm.preconizationToShow.columns.length) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sa-button-container"
  }, [_c('div', {
    staticClass: "sa-confirm-button-container"
  }, [_c('button', {
    staticClass: "confirm btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.showPopup.actions = false;
        _vm.preconizationToShow = null
      }
    }
  }, [_vm._v("Ok")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mt-30 mb-30"
  }, [_c('list', {
    attrs: {
      "columns": _vm.columns,
      "dataSet": _vm.dataSet
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-circle green mt-20",
    attrs: {
      "to": {
        name: 'quizzes_preconizations_create_action'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n       Nouvelle préconisation\n    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-circle yellow mt-20",
    attrs: {
      "to": {
        name: 'quizzes_preconizations_show_actions',
        params: {
          slug: _vm.$route.params.slug
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v("\n       Voir en détail\n    ")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal col-xs-12 absolute-parlsey-errors",
    attrs: {
      "id": "form_questions_create"
    }
  }, [_c('div', {
    staticClass: "form-body col-xs-12"
  }, [_vm._l((_vm.questions), function(question, index) {
    return _c('div', {
      staticClass: "mt-element-ribbon col-xs-12"
    }, [_c('div', {
      staticClass: "ribbon ribbon-border-hor ribbon-clip ribbon-color-info uppercase"
    }, [_c('div', {
      staticClass: "ribbon-sub ribbon-clip"
    }), _vm._v(" Question n°" + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('a', {
      staticClass: "bt-actions",
      staticStyle: {
        "white-space": "nowrap"
      },
      on: {
        "click": function($event) {
          _vm.addQuestion(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Ajouter")]), _vm._v(" "), _c('a', {
      staticClass: "text-danger bt-actions",
      staticStyle: {
        "white-space": "nowrap"
      },
      on: {
        "click": function($event) {
          _vm.removeQuestion(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-close",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Supprimer\n          ")]), _vm._v(" "), (index < _vm.questions.length - 1) ? _c('a', {
      staticClass: "text-info bt-actions",
      staticStyle: {
        "white-space": "nowrap"
      },
      on: {
        "click": function($event) {
          _vm.moveQuestion(index, index + 2)
        }
      }
    }, [_c('span', {
      staticClass: "icon-arrow-down",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Descendre")]) : _vm._e(), _vm._v(" "), (index != 0) ? _c('a', {
      staticClass: "text-info bt-actions",
      staticStyle: {
        "white-space": "nowrap"
      },
      on: {
        "click": function($event) {
          _vm.moveQuestion(index, index - 1)
        }
      }
    }, [_c('span', {
      staticClass: "icon-arrow-up",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Monter")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (question.title),
        expression: "question.title"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "",
        "required": ""
      },
      domProps: {
        "value": (question.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          question.title = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_c('label', {
      staticClass: "col-md-3 control-label"
    }, [_vm._v("Description\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (question.description),
        expression: "question.description"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (question.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          question.description = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    }), _vm._v(" "), _c('span', {
      staticClass: "help-block"
    }, [_vm._v("La description apparaîtra en dessous du titre pour expliquer votre question si besoin.")])])]), _vm._v(" "), _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (question.type),
        expression: "question.type"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          question.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "text"
      }
    }, [_vm._v("Réponse ouverte")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "radio"
      }
    }, [_vm._v("Choix unique simple")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "checkbox"
      }
    }, [_vm._v("Choix multiples simple")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "checkbox_multiple"
      }
    }, [_vm._v("Choix multiples avec système d'imbrication à deux niveaux")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "radio_multiple"
      }
    }, [_vm._v("Choix unique avec système d'imbrication à deux niveaux")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "scale"
      }
    }, [_vm._v("Echelle de notation")])])])]), _vm._v(" "), (question.type == 'scale' || question.type == 'radio' || question.type == 'checkbox' || question.type == 'checkbox_multiple' || question.type == 'radio_multiple') ? _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_c('label', {
      staticClass: "col-md-5 control-label"
    }, [_vm._v("Couleur pour le choix 'ne se prononce pas'\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "box-color",
      style: ({
        'background-color': question.color_no_response
      }),
      on: {
        "click": function($event) {
          _vm.showColorPicker(index)
        }
      }
    }, [_c('input', {
      staticClass: "form-control input-color hide",
      attrs: {
        "type": "text",
        "id": 'colorPicker' + index,
        "data-index-question": index,
        "data-swatches": _vm.dataSwatches,
        "value": ""
      }
    })])])]) : _vm._e(), _vm._v(" "), (question.type == 'number' || question.type == 'scale') ? _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (question.min),
        expression: "question.min"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0",
        "max": question.max ? question.max : '',
        "required": ""
      },
      domProps: {
        "value": (question.min)
      },
      on: {
        "change": function($event) {
          _vm.addColors(question)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          question.min = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })])]) : _vm._e(), _vm._v(" "), (question.type == 'number' || question.type == 'scale') ? _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (question.max),
        expression: "question.max"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": question.min ? question.min : 1,
        "required": ""
      },
      domProps: {
        "value": (question.max)
      },
      on: {
        "change": function($event) {
          _vm.addColors(question)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          question.max = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })])]) : _vm._e(), _vm._v(" "), _vm._l((question.data), function(data, index_data) {
      return (question.type == 'select' || question.type == 'radio' || question.type == 'checkbox' || question.type == 'checkbox_multiple' || question.type == 'radio_multiple') ? _c('div', [_c('div', {
        staticClass: "form-group form-md-line-input"
      }, [_c('label', {
        staticClass: "col-md-3 col-sm-2 col-xs-11 col-xs-offset-1 control-label"
      }, [_vm._v("Choix n°" + _vm._s(index_data + 1) + "\n                    "), _c('span', {
        staticClass: "required",
        attrs: {
          "aria-required": "true"
        }
      }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
        staticClass: "col-lg-3 col-md-5 col-sm-5 col-xs-6 col-xs-offset-1 col-sm-offset-0"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (data.name),
          expression: "data.name"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "required": ""
        },
        domProps: {
          "value": (data.name)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            data.name = $event.target.value
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "form-control-focus"
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-lg-1 col-md-1 col-sm-2 col-xs-2"
      }, [_c('div', {
        staticClass: "box-color",
        style: ({
          'background-color': data.color
        }),
        attrs: {
          "data-toggle": "tooltip",
          "title": "Couleur associé pour le graphique."
        },
        on: {
          "click": function($event) {
            _vm.showColorPicker(index, null, index_data)
          }
        }
      }, [_c('input', {
        staticClass: "form-control input-color hide",
        attrs: {
          "type": "text",
          "id": 'colorPicker' + index + '-data-' + index_data,
          "data-index-question": index,
          "data-index-data": index_data,
          "data-swatches": _vm.dataSwatches,
          "value": ""
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-2 mt-10"
      }, [_c('a', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (question.data.length > 1),
          expression: "question.data.length > 1"
        }],
        staticClass: "text-danger",
        staticStyle: {
          "white-space": "nowrap"
        },
        on: {
          "click": function($event) {
            question.data.splice(index_data, 1)
          }
        }
      }, [_c('span', {
        staticClass: "icon-close",
        attrs: {
          "aria-hidden": "true"
        }
      })])]), _vm._v(" "), (index_data == question.data.length - 1) ? _c('div', {
        staticClass: "col-xs-11 col-md-7 text-right mt-20"
      }, [_c('a', {
        staticStyle: {
          "white-space": "nowrap"
        },
        on: {
          "click": function($event) {
            question.data.push({
              name: ''
            })
          }
        }
      }, [_c('span', {
        staticClass: "icon-plus",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Ajouter")])]) : _vm._e()])]) : _vm._e()
    }), _vm._v(" "), _vm._l((question.data), function(choice, i) {
      return (question.type == 'checkbox_multiple' || question.type == 'radio_multiple') ? _c('div', {
        staticClass: "form-group form-md-line-input"
      }, [_c('div', {
        staticClass: "col-xs-12 form-group form-md-line-input p-0 m-0"
      }, [_c('label', {
        staticClass: "col-md-3 control-label"
      }, [_vm._v("\n                  Question imbriquée choix: " + _vm._s(choice.name) + "\n              ")]), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [(!choice.question) ? _c('a', {
        staticClass: "btn",
        on: {
          "click": function($event) {
            choice.question = {
              title: '',
              type: '',
              data: [],
              min: null,
              max: null,
              color_no_response: '#00b0f0',
              colors: []
            };
            _vm.$forceUpdate()
          }
        }
      }, [_c('span', {
        staticClass: "icon-plus",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Ajouter")]) : _vm._e()])]), _vm._v(" "), (choice.question) ? _c('div', {
        staticClass: "col-xs-12 mt-10"
      }, [_c('div', {
        staticClass: "col-xs-12 form-group form-md-line-input"
      }, [_vm._m(4, true), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (choice.question.title),
          expression: "choice.question.title"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "required": ""
        },
        domProps: {
          "value": (choice.question.title)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            choice.question.title = $event.target.value
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "form-control-focus"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 form-group form-md-line-input"
      }, [_c('label', {
        staticClass: "col-md-3 control-label"
      }, [_vm._v("\n                    Description:\n                    ")]), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (choice.question.description),
          expression: "choice.question.description"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (choice.question.description)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            choice.question.description = $event.target.value
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "form-control-focus"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12 form-group form-md-line-input"
      }, [_vm._m(5, true), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (choice.question.type),
          expression: "choice.question.type"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "required": ""
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            choice.question.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }, function($event) {
            _vm.addData(choice)
          }]
        }
      }, [_c('option', {
        attrs: {
          "value": "text"
        }
      }, [_vm._v("Réponse ouverte")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "radio"
        }
      }, [_vm._v("Choix unique simple")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "checkbox"
        }
      }, [_vm._v("Choix multiples simple")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "scale"
        }
      }, [_vm._v("Echelle de notation")])])])]), _vm._v(" "), (choice.question.type == 'scale' || choice.question.type == 'radio' || choice.question.type == 'checkbox' || choice.question.type == 'checkbox_multiple' || choice.question.type == 'radio_multiple') ? _c('div', {
        staticClass: "col-xs-12 form-group form-md-line-input"
      }, [_c('label', {
        staticClass: "col-md-5 control-label"
      }, [_vm._v("Couleur pour le choix 'ne se prononce pas'\n                      ")]), _vm._v(" "), _c('div', {
        staticClass: "col-md-3"
      }, [_c('div', {
        staticClass: "box-color",
        style: ({
          'background-color': choice.question.color_no_response
        }),
        on: {
          "click": function($event) {
            _vm.showColorPicker(index, null, null, null, i)
          }
        }
      }, [_c('input', {
        staticClass: "form-control input-color hide",
        attrs: {
          "type": "text",
          "id": 'colorPicker' + index + '-question-' + i,
          "data-index-question": index,
          "data-index-question-two": i,
          "data-swatches": _vm.dataSwatches,
          "value": ""
        }
      })])])]) : _vm._e(), _vm._v(" "), _vm._l((choice.question.data), function(choice_data, di) {
        return (choice.question.type == 'checkbox' || choice.question.type == 'radio') ? _c('div', {
          staticClass: "col-xs-12 form-group form-md-line-input"
        }, [_c('div', {
          staticClass: "form-group form-md-line-input p-0 m-0"
        }, [_c('label', {
          staticClass: "col-md-3 col-sm-2 col-xs-11 col-xs-offset-1 control-label"
        }, [_vm._v("Choix n°" + _vm._s(di + 1) + "\n                      "), _c('span', {
          staticClass: "required",
          attrs: {
            "aria-required": "true"
          }
        }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
          staticClass: "col-lg-3 col-md-5 col-sm-5 col-xs-6 col-xs-offset-1 col-sm-offset-0"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (choice_data.name),
            expression: "choice_data.name"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "required": ""
          },
          domProps: {
            "value": (choice_data.name)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              choice_data.name = $event.target.value
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "form-control-focus"
        })]), _vm._v(" "), _c('div', {
          staticClass: "col-lg-1 col-md-1 col-sm-2 col-xs-2"
        }, [_c('div', {
          staticClass: "box-color",
          style: ({
            'background-color': choice_data.color
          }),
          attrs: {
            "data-toggle": "tooltip",
            "title": "Couleur associé pour le graphique."
          },
          on: {
            "click": function($event) {
              _vm.showColorPicker(index, null, i, di)
            }
          }
        }, [_c('input', {
          staticClass: "form-control input-color hide",
          attrs: {
            "type": "text",
            "id": 'colorPicker' + index + '-data-' + i + '-data2-' + di,
            "data-index-question": index,
            "data-index-data": i,
            "data-index-data-two": di,
            "data-swatches": _vm.dataSwatches,
            "value": ""
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-2 mt-10"
        }, [_c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (choice.question.data.length > 1),
            expression: "choice.question.data.length > 1"
          }],
          staticClass: "text-danger",
          staticStyle: {
            "white-space": "nowrap"
          },
          on: {
            "click": function($event) {
              choice.question.data.splice(di, 1)
            }
          }
        }, [_c('span', {
          staticClass: "icon-close",
          attrs: {
            "aria-hidden": "true"
          }
        })])]), _vm._v(" "), (di == choice.question.data.length - 1) ? _c('div', {
          staticClass: "col-xs-11 col-md-7 text-right mt-20"
        }, [_c('a', {
          staticStyle: {
            "white-space": "nowrap"
          },
          on: {
            "click": function($event) {
              choice.question.data.push({
                name: ''
              });
              _vm.forceUpdate()
            }
          }
        }, [_c('span', {
          staticClass: "icon-plus",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Ajouter")])]) : _vm._e()])]) : _vm._e()
      }), _vm._v(" "), (choice.question.type == 'scale') ? _c('div', {
        staticClass: "col-xs-12 form-group form-md-line-input"
      }, [_c('div', {
        staticClass: "form-group form-md-line-input"
      }, [_vm._m(6, true), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (choice.question.min),
          expression: "choice.question.min"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "min": "0",
          "max": choice.question.max ? choice.question.max : '',
          "required": ""
        },
        domProps: {
          "value": (choice.question.min)
        },
        on: {
          "change": function($event) {
            _vm.addColors(choice.question)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            choice.question.min = $event.target.value
          },
          "blur": function($event) {
            _vm.$forceUpdate()
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "form-control-focus"
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group form-md-line-input"
      }, [_vm._m(7, true), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (choice.question.max),
          expression: "choice.question.max"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "min": choice.question.min ? choice.question.min : 1,
          "required": ""
        },
        domProps: {
          "value": (choice.question.max)
        },
        on: {
          "change": function($event) {
            _vm.addColors(choice.question)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            choice.question.max = $event.target.value
          },
          "blur": function($event) {
            _vm.$forceUpdate()
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "form-control-focus"
      })])]), _vm._v(" "), (choice.question.type == 'scale') ? _c('div', {
        staticClass: "form-group form-md-line-input"
      }, [_c('label', {
        staticClass: "col-md-3 control-label"
      }, [_vm._v("Couleurs associées\n                        ")]), _vm._v(" "), (choice.question.max && choice.question.min) ? _c('div', {
        staticClass: "col-lg-6 col-md-9"
      }, [(parseInt(choice.question.max) - parseInt(choice.question.min) + 1 > 0) ? _c('div', _vm._l((choice.question.colors), function(color, index_data_color) {
        return _c('div', {
          staticClass: "box-color",
          style: ({
            'background-color': color
          }),
          on: {
            "click": function($event) {
              _vm.showColorPicker(index, index_data_color, i)
            }
          }
        }, [_vm._v("\n                          " + _vm._s(index_data_color + parseInt(choice.question.min)) + "\n                          "), _c('input', {
          staticClass: "form-control input-color hide",
          attrs: {
            "type": "text",
            "id": 'colorPicker' + index + '-data-' + i + '-' + index_data_color,
            "data-index-question": index,
            "data-index-data": i,
            "data-index-color": index_data_color,
            "data-swatches": _vm.dataSwatches,
            "value": ""
          }
        })])
      })) : _c('div', {
        staticClass: "text-danger",
        staticStyle: {
          "margin-top": "5px"
        }
      }, [_vm._v("\n                        Valeur invalide. La valeur maximum doit être supérieure à la valeur minimum.\n                      ")])]) : _c('div', {
        staticClass: "col-lg-6 col-md-9",
        staticStyle: {
          "margin-top": "5px",
          "color": "gray"
        }
      }, [_vm._v("\n                      Vous devez saisir les valeurs minimum et maximum.\n                    ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-xs-12"
      }, [_c('div', {
        staticClass: "col-md-3"
      }), _vm._v(" "), _c('div', {
        staticClass: "col-lg-6 col-md-9 p-0"
      }, [_c('a', {
        staticClass: "p-0 btn text-danger",
        on: {
          "click": function($event) {
            choice.question = null;
            _vm.forceUpdate()
          }
        }
      }, [_c('span', {
        staticClass: "icon-close",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Retirer")])])])], 2) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), (question.type == 'scale') ? _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_c('label', {
      staticClass: "col-md-3 control-label"
    }, [_vm._v("Couleurs associées\n                  ")]), _vm._v(" "), (question.max && question.min) ? _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [(parseInt(question.max) - parseInt(question.min) + 1 > 0) ? _c('div', _vm._l((question.colors), function(color, index_color) {
      return _c('div', {
        staticClass: "box-color",
        style: ({
          'background-color': color
        }),
        on: {
          "click": function($event) {
            _vm.showColorPicker(index, index_color)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(index_color + parseInt(question.min)) + "\n                    "), _c('input', {
        staticClass: "form-control input-color hide",
        attrs: {
          "type": "text",
          "id": 'colorPicker' + index + '-' + index_color,
          "data-index-question": index,
          "data-index-color": index_color,
          "data-swatches": _vm.dataSwatches,
          "value": ""
        }
      })])
    })) : _c('div', {
      staticClass: "text-danger",
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_vm._v("\n                  Valeur invalide. La valeur maximum doit être supérieure à la valeur minimum.\n                ")])]) : _c('div', {
      staticClass: "col-lg-6 col-md-9",
      staticStyle: {
        "margin-top": "5px",
        "color": "gray"
      }
    }, [_vm._v("\n                Vous devez saisir les valeurs minimum et maximum.\n              ")])]) : _vm._e(), _vm._v(" "), (index != _vm.questions.length - 1) ? _c('hr', {
      staticStyle: {
        "width": "80%",
        "margin": "auto",
        "border-style": "dashed",
        "position": "relative",
        "top": "60px",
        "border-color": "gray"
      }
    }) : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [(_vm.questions.length == 0) ? _c('div', {
    staticClass: "note note-danger"
  }, [_c('h4', {
    staticClass: "block"
  }, [_vm._v(" Avertissement")]), _vm._v(" "), _c('p', [_vm._v(" Votre questionnaire doit comporter au moins une question ! "), _c('br'), _vm._v("\n                Cliquez sur le bouton en bas à droite "), _c('a', {
    on: {
      "click": function($event) {
        _vm.addQuestion()
      }
    }
  }, [_vm._v("Ajouter une question")]), _vm._v(".\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('a', {
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.addQuestion()
      }
    }
  }, [_c('span', {
    staticClass: "icon-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ajouter une question")])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Titre\n                  "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Type\n                  "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Valeur minimum\n                  "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Valeur maximum\n                  "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("\n                    Titre:\n                    "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("\n                    Type:\n                    "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Valeur minimum\n                        "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Valeur maximum\n                        "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.login),
      expression: "show.login"
    }],
    staticClass: "login-form",
    attrs: {
      "id": "formLogin"
    }
  }, [_c('h3', {
    staticClass: "form-title font-green"
  }, [_vm._v("Connexion")]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-error"
  }, [_c('label', {
    staticClass: "control-label visible-ie8 visible-ie9"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailOrUsername),
      expression: "emailOrUsername"
    }],
    staticClass: "form-control form-control-solid placeholder-no-fix",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "data-parsley-trigger": "change",
      "placeholder": "Email ou Username",
      "required": ""
    },
    domProps: {
      "value": (_vm.emailOrUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailOrUsername = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-error"
  }, [_c('label', {
    staticClass: "control-label visible-ie8 visible-ie9"
  }, [_vm._v("Mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control form-control-solid placeholder-no-fix",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "data-parsley-trigger": "change",
      "placeholder": "Mot de passe",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('a', {
    staticClass: "btn green uppercase",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Se connecter")]), _vm._v(" "), _c('a', {
    staticClass: "forget-password",
    on: {
      "click": function($event) {
        _vm.show.forgetPassword = true
      }
    }
  }, [_vm._v("Mot de passe oublié ?")])])]), _vm._v(" "), _c('forget-password', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.forgetPassword),
      expression: "show.forgetPassword"
    }],
    attrs: {
      "show": _vm.show
    },
    on: {
      "update:show": function($event) {
        _vm.show = $event
      }
    }
  }), _vm._v(" "), _c('reset-password', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.resetPassword),
      expression: "show.resetPassword"
    }],
    attrs: {
      "show": _vm.show
    },
    on: {
      "update:show": function($event) {
        _vm.show = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v(" 2017 © Le Web Français. Transferh. ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "src": __webpack_require__(10),
      "alt": "Logo TransfeRH"
    }
  })])])
}]}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Détail utilisateur\n")])
},staticRenderFns: []}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.quiz && _vm.error == '') ? _c('div', {
    staticClass: "row"
  }, [(_vm.analysis && _vm.analysis.questions.length > 0) ? _c('div', [_c('div', {
    staticClass: "text-right mr-20"
  }, [_c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.saveAnalysis()
      }
    }
  }, [_vm._v("Enregistrer")])]), _vm._v(" "), _vm._l((_vm.quiz.questions), function(question, question_index) {
    return (question.type == 'text' || (question.type == 'checkbox_multiple' && _vm.haveText(question)) || (question.type == 'radio_multiple' && _vm.haveText(question))) ? _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "mt-element-ribbon col-xs-12 p-0 mb-10"
    }, [_c('div', {
      staticClass: "ribbon ribbon-border-hor ribbon-clip ribbon-color-info uppercase"
    }, [_c('div', {
      staticClass: "ribbon-sub ribbon-clip"
    }), _vm._v(" Question n°" + _vm._s(question_index + 1) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 p-0 mb-30"
    }, [_c('div', {
      staticClass: "form-group form-md-line-input"
    }, [(question.type == 'text') ? _c('label', {
      staticClass: "col-sm-10 col-sm-offset-1 p-0 control-label"
    }, [_c('h4', {
      staticClass: "p-0"
    }, [_vm._v(_vm._s(question.title))])]) : _vm._e(), _vm._v(" "), (question.type == 'checkbox_multiple' || question.type == 'radio_multiple') ? _c('label', {
      staticClass: "col-sm-10 col-sm-offset-1 p-0 control-label"
    }, [_c('h4', {
      staticClass: "p-0"
    }, [_vm._v(_vm._s(question.title))])]) : _vm._e(), _vm._v(" "), (question.type == 'text') ? _c('div', {
      staticClass: "col-sm-10 col-sm-offset-1 p-0",
      staticStyle: {
        "background-color": "#f1f1f1"
      }
    }, [(_vm.analysis.questions[question_index]) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.analysis.questions[question_index].text),
        expression: "analysis.questions[question_index].text"
      }],
      staticClass: "form-control",
      staticStyle: {
        "padding": "10px"
      },
      attrs: {
        "type": "text",
        "placeholder": "",
        "rows": "6"
      },
      domProps: {
        "value": (_vm.analysis.questions[question_index].text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.analysis.questions[question_index].text = $event.target.value
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })]) : _vm._e(), _vm._v(" "), _vm._l((question.data), function(data, data_index) {
      return ((question.type == 'checkbox_multiple' || question.type == 'radio_multiple') && data.question && data.question.type == 'text') ? _c('div', {
        staticClass: "col-xs-12"
      }, [_c('label', {
        staticClass: "col-sm-10 col-sm-offset-1 p-0 control-label"
      }, [_c('h5', {
        staticClass: "p-0"
      }, [_vm._v(_vm._s(data.name) + " : " + _vm._s(data.question.title))])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-10 col-sm-offset-1 p-0",
        staticStyle: {
          "background-color": "#f1f1f1"
        }
      }, [(_vm.analysis.questions[question_index] && _vm.analysis.questions[question_index].data[data_index]) ? _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.analysis.questions[question_index].data[data_index].text),
          expression: "analysis.questions[question_index].data[data_index].text"
        }],
        staticClass: "form-control",
        staticStyle: {
          "padding": "10px"
        },
        attrs: {
          "type": "text",
          "placeholder": "",
          "rows": "6"
        },
        domProps: {
          "value": (_vm.analysis.questions[question_index].data[data_index].text)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.analysis.questions[question_index].data[data_index].text = $event.target.value
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "form-control-focus"
      })])]) : _vm._e()
    })], 2)])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-actions col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('a', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }, [_vm._v("Annuler")])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.saveAnalysis()
      }
    }
  }, [_vm._v("Enregistrer")])])])])])], 2) : _c('div', {
    staticClass: "col-xs-12 m-30"
  }, [_vm._v("\n      Aucune question ouverte pour ce formulaire.\n    ")])]) : _vm._e(), _vm._v(" "), (!_vm.quiz) ? _c('div', {
    staticClass: "row m-0"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.error != '') ? _c('div', {
    staticClass: "row m-0 page-404-full-page"
  }, [_c('div', {
    staticClass: "col-md-12 page-404 pb-100"
  }, [_c('div', {
    staticClass: "number error font-green"
  }, [_vm._v(" Erreur ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Une erreur est survenue")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.error) + "\n                "), _c('br'), _vm._v("\n                Vérifiez l'url et tentez de recharger la page.\n            ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 page-404 mt-50 pb-50"
  }, [_c('div', {
    staticClass: "number font-green"
  }, [_vm._v(" 404 ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Analyse du questionnaire non trouvée.")]), _vm._v(" "), _c('p', [_vm._v(" Nous n'avons pas réussi à trouver cette analyse.\n                "), _c('br'), _vm._v("\n                Vérifiez'url et tentez de recharger la page.\n            ")])])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup.remove),
      expression: "showPopup.remove"
    }],
    staticClass: "sweet-alert showSweetAlert visible",
    staticStyle: {
      "border": "1px dashed gray",
      "display": "block"
    },
    attrs: {
      "data-allow-outside-click": "false",
      "data-animation": "pop"
    }
  }, [_c('div', {
    staticClass: "sa-icon sa-info",
    staticStyle: {
      "display": "block"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Confirmation")]), _vm._v(" "), (_vm.quizToRemove) ? _c('p', {
    staticClass: "lead text-muted text-left"
  }, [_vm._v("\n      Etes-vous sûr de vouloir supprimer le questionnaire « " + _vm._s(_vm.quizToRemove.title) + " » ?\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sa-button-container"
  }, [_c('button', {
    staticClass: "cancel btn btn-lg btn-default btn-danger",
    on: {
      "click": function($event) {
        _vm.showPopup.remove = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "sa-confirm-button-container"
  }, [_c('button', {
    staticClass: "confirm btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.removeQuiz()
      }
    }
  }, [_vm._v("Oui")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup.duplicate),
      expression: "showPopup.duplicate"
    }],
    staticClass: "sweet-alert showSweetAlert visible",
    staticStyle: {
      "border": "1px dashed gray",
      "display": "block"
    },
    attrs: {
      "data-allow-outside-click": "false",
      "data-animation": "pop"
    }
  }, [_c('div', {
    staticClass: "sa-icon sa-info",
    staticStyle: {
      "display": "block"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Formulaire de duplication")]), _vm._v(" "), (_vm.quizToDuplicate) ? _c('p', {
    staticClass: "lead text-muted text-left"
  }, [_vm._v("\n      Vous êtes sur le point de dupliquer le questionnaire « " + _vm._s(_vm.quizToDuplicate.title) + " »."), _c('br'), _c('br'), _vm._v("\n      Veuillez choisir le titre de la copie de ce questionnaire, "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("attention le titre ne pourra pas être changé après la duplication")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input",
    staticStyle: {
      "display": "block"
    }
  }, [_c('form', {
    staticClass: "absolute-parlsey-errors",
    attrs: {
      "id": "formDuplicate"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTitle),
      expression: "newTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nouveau titre",
      "required": ""
    },
    domProps: {
      "value": (_vm.newTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "sa-button-container"
  }, [_c('button', {
    staticClass: "cancel btn btn-lg btn-default btn-danger",
    on: {
      "click": function($event) {
        _vm.showPopup.duplicate = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('div', {
    staticClass: "sa-confirm-button-container"
  }, [_c('button', {
    staticClass: "confirm btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.duplicateQuiz()
      }
    }
  }, [_vm._v("Valider")])])])]), _vm._v(" "), _c('section', {
    staticClass: "tile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile-body mb-50"
  }, [_c('list', {
    attrs: {
      "columns": _vm.columns,
      "dataSet": _vm.dataSet,
      "order": [1, 'asc']
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-circle green mt-20",
    attrs: {
      "to": {
        name: 'quizzes_create'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n             Nouveau questionnaire\n          ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile-header dvd dvd-btm tabbable-line"
  }, [_c('h1', [_vm._v("Liste des questionnaires")]), _c('br'), _vm._v(" "), _c('br'), _c('br')])
}]}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [(_vm.quiz.state != 'published') ? _c('div', {
    staticClass: "note note-danger"
  }, [_c('h4', {
    staticClass: "block"
  }, [_vm._v(" Avertissement")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.quiz.state == 'published') ? _c('div', {
    staticClass: "note note-info"
  }, [_c('h4', {
    staticClass: "block"
  }, [_vm._v(" Félicitation")]), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _vm._l((_vm.quiz.groups), function(group) {
    return _c('a', {
      staticClass: "link_share",
      attrs: {
        "href": _vm.config.front_url + 'questionnaire/' + _vm.quiz.slug + '?group=' + group.slug,
        "target": "_blank"
      }
    }, [_c('h5', [_vm._v(_vm._s(_vm.config.front_url) + "questionnaire/" + _vm._s(_vm.quiz.slug) + "?group=" + _vm._s(group.slug))])])
  })], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v(" Vous devez publier votre questionnarie pour obtenir le lien de partage de ce dernier. "), _c('br'), _vm._v("\n        Cliquer sur le bouton \"Publier\" situé en bas à droite.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v(" Votre questionnaire a bien été publié et est accessible à l'addresse suivante  : "), _c('br')])
}]}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Page d'accueil !\n")])
},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.preconization) ? _c('div', {
    staticClass: "row mt-20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('form', {
    staticClass: "form-horizontal col-xs-12 absolute-parlsey-errors",
    attrs: {
      "id": "newAction"
    }
  }, [_c('div', {
    staticClass: "portlet light portlet-fit portlet-form bordered col-xs-12 p-0 "
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body col-xs-12 text-right"
  }, [_c('div', {
    staticClass: "col-xs-12 form-group form-md-line-input"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("N°\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preconization.number),
      expression: "preconization.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.preconization.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preconization.number = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 form-group form-md-line-input"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preconization.title),
      expression: "preconization.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.preconization.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preconization.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 form-group form-md-line-input"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Description\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preconization.description),
      expression: "preconization.description"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.preconization.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.preconization.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])]), _vm._v(" "), _vm._l((_vm.preconization.actions), function(action, action_index) {
    return _c('div', {
      staticClass: "mt-element-ribbon col-xs-12"
    }, [_c('hr', {
      staticStyle: {
        "width": "80%",
        "margin": "auto",
        "border-style": "dashed",
        "position": "relative",
        "top": "30px",
        "border-color": "gray"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ribbon ribbon-border-hor ribbon-clip ribbon-color-info uppercase"
    }, [_c('div', {
      staticClass: "ribbon-sub ribbon-clip"
    }), _vm._v(" Action n°" + _vm._s(action.number) + "\n                ")]), _vm._v(" "), _c('a', {
      staticClass: "text-danger bt-remove",
      staticStyle: {
        "white-space": "nowrap"
      },
      on: {
        "click": function($event) {
          _vm.removeAction(action_index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-close",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Supprimer\n                ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 form-group form-md-line-input"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (action.title),
        expression: "action.title"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "",
        "required": ""
      },
      domProps: {
        "value": (action.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          action.title = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 form-group form-md-line-input"
    }, [_c('label', {
      staticClass: "col-md-3 control-label"
    }, [_vm._v("Description\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (action.description),
        expression: "action.description"
      }],
      staticClass: "form-control",
      staticStyle: {
        "padding": "10px"
      },
      attrs: {
        "type": "text",
        "placeholder": "",
        "rows": "3"
      },
      domProps: {
        "value": (action.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          action.description = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 form-group form-md-line-input"
    }, [_c('label', {
      staticClass: "col-md-3 control-label"
    }, [_vm._v("Délai de réalisation\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 col-md-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (action.deadline),
        expression: "action.deadline"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (action.deadline)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          action.deadline = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('a', {
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.addAction()
      }
    }
  }, [_c('span', {
    staticClass: "icon-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ajouter une action")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mt-10"
  }, [_c('div', {
    staticClass: "form-actions col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('a', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }, [_vm._v("Annuler")])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.savePreconization()
      }
    }
  }, [_vm._v("Enregistrer")])])])])])], 2)])])])]) : _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-md-12 page-404 mt-50 pb-50"
  }, [_c('div', {
    staticClass: "number font-green"
  }, [_vm._v(" 404 ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Préconisation non trouvée.")]), _vm._v(" "), _c('p', [_vm._v(" Nous n'avons pas réussi à trouver cette préconisation.\n                "), _c('br'), _vm._v("\n                Vérifiez'url et tentez de recharger la page.\n            ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title col-xs-12 "
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: " icon-plus font-green"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase font-green"
  }, [_vm._v("Nouvelle préconisation ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Titre\n                      "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Titre\n                        "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "table-responsive mt20"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataSet.length > 0),
      expression: "dataSet.length > 0"
    }],
    attrs: {
      "id": _vm.getId
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataSet.length == 0),
      expression: "dataSet.length == 0"
    }],
    staticClass: "alert alert-info"
  }, [_c('i', {
    staticClass: "icon-info"
  }), _vm._v(" Aucun résultat.\n      ")])])])
},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('ul', {
    staticClass: "page-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'compare'
      }
    }
  }, [_vm._v("Comparaison")])], 1)])]), _vm._v(" "), (_vm.quizzes && _vm.quizzesPublished > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5 mb-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quiz1),
      expression: "quiz1"
    }],
    staticClass: "form-control input-lg",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.quiz1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.quizzes), function(quiz) {
    return (quiz.state == 'published') ? _c('option', {
      domProps: {
        "value": quiz.slug
      }
    }, [_vm._v(_vm._s(quiz.title))]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 text-center"
  }, [(_vm.quiz1) ? _c('router-link', {
    staticClass: "btn btn-default text-right btn-circle btn_table btn_perso float-left mt-10",
    attrs: {
      "to": {
        name: 'quizzes_responses',
        params: {
          slug: _vm.quiz1
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon-eye"
  })]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "m-0",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Vs")]), _vm._v(" "), (_vm.quiz2) ? _c('router-link', {
    staticClass: "btn btn-default text-right btn-circle btn_table btn_perso float-right mt-10",
    attrs: {
      "to": {
        name: 'quizzes_responses',
        params: {
          slug: _vm.quiz2
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon-eye"
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 mb-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quiz2),
      expression: "quiz2"
    }],
    staticClass: "form-control input-lg",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.quiz2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.quizzes), function(quiz) {
    return (quiz.state == 'published') ? _c('option', {
      domProps: {
        "value": quiz.slug
      }
    }, [_vm._v(_vm._s(quiz.title))]) : _vm._e()
  }))]), _vm._v(" "), (_vm.quiz1) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('responses', {
    attrs: {
      "quizSlug": _vm.quiz1,
      "number": 1
    }
  })], 1) : _c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('h3', [_vm._v("Choisissez un questionnaire.")])]), _vm._v(" "), (_vm.quiz2) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('responses', {
    attrs: {
      "quizSlug": _vm.quiz2,
      "number": 2
    }
  })], 1) : _c('div', {
    staticClass: "col-md-6 text-center"
  }, [_c('h3', [_vm._v("Choisissez un questionnaire.")])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "note note-warning mt-30"
  }, [_c('h4', {
    staticClass: "block"
  }, [_vm._v(" Avertissement")]), _vm._v(" "), _c('p', [_vm._v(" Vous devez créer au moins un questionnaire pour pouvoir effectuer une comparaison.")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-circle yellow",
    attrs: {
      "to": {
        name: 'quizzes_create'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n           Créer un questionnaire\n      ")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name != 'quizzes_show'),
      expression: "$route.name != 'quizzes_show'"
    }],
    staticClass: "page-bar",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('ul', {
    staticClass: "page-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'quizzes_list'
      }
    }
  }, [_vm._v("Questionnaires")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.params.slug),
      expression: "$route.params.slug"
    }]
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'quizzes_responses',
        params: {
          slug: _vm.$route.params.slug
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$route.params.slug))])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'quizzes_edit'),
      expression: "$route.name=='quizzes_edit'"
    }]
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'quizzes_edit'
      }
    }
  }, [_vm._v("Edition")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'quizzes_create'),
      expression: "$route.name=='quizzes_create'"
    }]
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'quizzes_create'
      }
    }
  }, [_vm._v("Création")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'quizzes_responses'),
      expression: "$route.name=='quizzes_responses'"
    }]
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'quizzes_responses',
        params: {
          slug: _vm.$route.params.slug
        }
      }
    }
  }, [_vm._v("Liste des réponses")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'quizzes_preconizations' || _vm.$route.name == 'quizzes_preconizations_create_action' || _vm.$route.name == 'quizzes_preconizations_edit_action'),
      expression: "$route.name=='quizzes_preconizations' || $route.name == 'quizzes_preconizations_create_action' || $route.name == 'quizzes_preconizations_edit_action' "
    }]
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'quizzes_preconizations'
      }
    }
  }, [_vm._v("Préconisations")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'quizzes_preconizations_create_action'),
      expression: "$route.name=='quizzes_preconizations_create_action'"
    }]
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'quizzes_preconizations_create_action'
      }
    }
  }, [_vm._v("Nouvelle")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'quizzes_preconizations_edit_action'),
      expression: "$route.name=='quizzes_preconizations_edit_action'"
    }]
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'quizzes_preconizations_edit_action',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v(" Action n°" + _vm._s(_vm.$route.params.id))])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'quizzes_export_pdf'),
      expression: "$route.name=='quizzes_export_pdf'"
    }]
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'quizzes_export_pdf',
        params: {
          slug: _vm.$route.params.slug
        }
      }
    }
  }, [_vm._v(" Export PDF")])], 1)])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('ul', {
    staticClass: "page-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Accueil")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-circle"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'users_list'
      }
    }
  }, [_vm._v("Utilisateurs")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.params.id),
      expression: "$route.params.id"
    }]
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'users_edit',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$route.params.id))])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'users_edit'),
      expression: "$route.name=='users_edit'"
    }]
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'users_edit'
      }
    }
  }, [_vm._v("Edition")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'users_create'),
      expression: "$route.name=='users_create'"
    }]
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'users_create'
      }
    }
  }, [_vm._v("Création")])], 1)])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.user) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "portlet light portlet-fit portlet-form bordered col-xs-12 p-0 "
  }, [_c('div', {
    staticClass: "portlet-title col-xs-12"
  }, [_c('div', {
    staticClass: "caption"
  }, [(_vm.$route.name == 'users_edit') ? _c('i', {
    staticClass: " icon-note font-green"
  }) : _c('i', {
    staticClass: " icon-plus font-green"
  }), _vm._v(" "), (_vm.$route.name == 'users_edit') ? _c('span', {
    staticClass: "caption-subject font-green sbold uppercase"
  }, [_vm._v("Modification de l'utilisateur")]) : _c('span', {
    staticClass: "caption-subject font-green sbold uppercase"
  }, [_vm._v("Créer un nouvel utilisateur")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body col-xs-12"
  }, [_c('form', {
    staticClass: "form-horizontal col-xs-12 absolute-parlsey-errors",
    attrs: {
      "id": "form_user_create"
    }
  }, [_c('div', {
    staticClass: "form-body col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "data-parsley-type": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstname),
      expression: "user.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.firstname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastname),
      expression: "user.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.lastname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Mot de passe\n                                "), (_vm.$route.name == 'users_create') ? _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "",
      "required": _vm.$route.name == 'users_create'
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.role = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Aucun")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dev"
    }
  }, [_vm._v("Dev")])]), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center"
  }, [(_vm.$route.name == 'users_edit') ? _c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.updateUser()
      }
    }
  }, [_vm._v("Valider les modifications")]) : _c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.createUser()
      }
    }
  }, [_vm._v("Créer le nouveau utilisateur")]), _vm._v(" "), _c('a', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }, [_vm._v("Annuler")])])])])])])])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 page-404"
  }, [_c('div', {
    staticClass: "number font-green"
  }, [_vm._v(" 404 ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Utilisateur non trouvé.")]), _vm._v(" "), _c('p', [_vm._v(" Nous n'avons pas réussi à trouver cet utilisateur.\n                "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'users_list'
      }
    }
  }, [_vm._v(" Retourner à la liste des utilisateurs ")]), _vm._v(" ou essayer de recharger la page.\n            ")], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Email\n                                "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Prénom\n                                "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Nom\n                                "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "forget-form",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "formResetPassword"
    }
  }, [_c('h3', {
    staticClass: "font-green"
  }, [_vm._v("Réinitialisation de votre mot de passe")]), _vm._v(" "), _c('p', [_vm._v(" Entrer votre nouveau mot de passe. ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control mt-10",
    attrs: {
      "type": "password",
      "placeholder": "Nouveau mot de passe",
      "autocomplete": "off",
      "required": "",
      "id": "newPassword2",
      "data-parsley-equalto": "#confirmNewPassword2",
      "data-parsley-error-message": "Les mots de passe ne correspondent pas."
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "change": function($event) {
        _vm.reValidateInput('confirmNewPassword2')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control mt-10",
    attrs: {
      "type": "password",
      "placeholder": "Confirmation du nouveau mot de passe",
      "id": "confirmNewPassword2",
      "data-parsley-equalto": "#newPassword2",
      "data-parsley-error-message": "Les mots de passe ne correspondent pas.",
      "autocomplete": "off",
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.reValidateInput('newPassword2')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('a', {
    staticClass: "btn btn-success uppercase pull-right",
    on: {
      "click": function($event) {
        _vm.resetPassword()
      }
    }
  }, [_vm._v("Réinitialiser")])])])])
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-header navbar navbar-fixed-top"
  }, [_c('div', {
    staticClass: "page-header-inner"
  }, [_c('div', {
    staticClass: "page-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "quiz-title text-center"
  }, [(_vm.quiz && _vm.quiz.title) ? _c('h2', [_vm._v(_vm._s(_vm.quiz.title))]) : _c('h2', [_vm._v("Erreur")])])])]), _vm._v(" "), (_vm.quiz && _vm.error == '') ? _c('div', {
    staticClass: "row m-0 page-404-full-page"
  }, [_c('div', {
    staticClass: "page-404 pb-100 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.question_index < 0),
      expression: "question_index < 0"
    }],
    staticClass: "col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "uppercase mt-50"
  }, [_vm._v("Merci de répondre à nos questions")]), _c('br'), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "absolute-parlsey-errors",
    attrs: {
      "id": "startQuiz"
    }
  }, [_c('div', {
    staticClass: "form-group form-md-line-input",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.response.firstname),
      expression: "response.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.response.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.response.firstname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.response.lastname),
      expression: "response.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.response.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.response.lastname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('a', {
    staticClass: "btn green mt-50",
    on: {
      "click": function($event) {
        _vm.startQuiz()
      }
    }
  }, [_vm._v("Répondre aux questions")])]), _vm._v(" "), (_vm.quiz.instructions != '') ? _c('div', {
    staticClass: "text-left note note-info mt-30"
  }, [_c('h4', {
    staticClass: "block"
  }, [_vm._v(" Bienvenue, ")]), _vm._v(" "), _c('h5', [_vm._v("Merci de lire ces instructions avant de répondre aux questions : ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#4f4f4f"
    }
  }, [_vm._v(_vm._s(_vm.quiz.instructions))])]) : _vm._e()])]), _vm._v(" "), (_vm.question_index >= 0 && _vm.question_index < _vm.quiz.questions.length) ? _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
  }, [_c('h1', [_vm._v("Question n°" + _vm._s(_vm.question_index + 1))]), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "question_title"
  }, [_vm._v(_vm._s(_vm.quiz.questions[_vm.question_index].title))]), _c('br'), _c('br'), _vm._v(" "), (_vm.quiz.questions[_vm.question_index].description) ? _c('div', {
    staticClass: "mb-20"
  }, [_c('em', [_vm._v(_vm._s(_vm.quiz.questions[_vm.question_index].description))])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "absolute-parlsey-errors",
    attrs: {
      "id": 'question' + _vm.question_index
    }
  }, [_c('div', {
    staticClass: "form-group form-md-line-input col-xs-12",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "40px"
    }
  }, [_vm._m(5), _vm._v(" "), (_vm.quiz.questions[_vm.question_index].type == 'checkbox' || _vm.quiz.questions[_vm.question_index].type == 'checkbox_multiple') ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "mt-checkbox-list text-left"
  }, _vm._l((_vm.quiz.questions[_vm.question_index].data), function(data, d_index) {
    return _c('label', {
      staticClass: "mt-checkbox"
    }, [_vm._v(" " + _vm._s(data.name) + "\n                          "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.response.questions[_vm.question_index].value),
        expression: "response.questions[question_index].value"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'question' + _vm.quiz.questions[_vm.question_index].id,
        "name": "check[]",
        "required": _vm.response.questions[_vm.question_index].noResponse != true
      },
      domProps: {
        "value": data.name,
        "checked": Array.isArray(_vm.response.questions[_vm.question_index].value) ? _vm._i(_vm.response.questions[_vm.question_index].value, data.name) > -1 : (_vm.response.questions[_vm.question_index].value)
      },
      on: {
        "change": function($event) {
          _vm.inputChange(_vm.question_index)
        },
        "__c": function($event) {
          var $$a = _vm.response.questions[_vm.question_index].value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.name,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.response.questions[_vm.question_index].value = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.response.questions[_vm.question_index].value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.response.questions[_vm.question_index].value = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span')])
  }))]) : _vm._e(), _vm._v(" "), (_vm.quiz.questions[_vm.question_index].type == 'radio' || _vm.quiz.questions[_vm.question_index].type == 'radio_multiple') ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "mt-radio-list text-left"
  }, _vm._l((_vm.quiz.questions[_vm.question_index].data), function(data, d_index) {
    return _c('label', {
      staticClass: "mt-radio"
    }, [_vm._v(" " + _vm._s(data.name) + "\n                          "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.response.questions[_vm.question_index].value),
        expression: "response.questions[question_index].value"
      }],
      attrs: {
        "type": "radio",
        "id": 'question' + _vm.quiz.questions[_vm.question_index].id,
        "name": "radio[]",
        "required": _vm.response.questions[_vm.question_index].noResponse != true
      },
      domProps: {
        "value": data.name,
        "checked": _vm._q(_vm.response.questions[_vm.question_index].value, data.name)
      },
      on: {
        "change": function($event) {
          _vm.inputChange(_vm.question_index)
        },
        "__c": function($event) {
          _vm.response.questions[_vm.question_index].value = data.name
        }
      }
    }), _vm._v(" "), _c('span')])
  }))]) : _vm._e(), _vm._v(" "), (_vm.quiz.questions[_vm.question_index].type == 'scale') ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "mt-radio-inline"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.response.questions[_vm.question_index].scaleRange))]), _vm._v(" "), _vm._l((_vm.response.questions[_vm.question_index].scaleRange), function(scale, scale_index) {
    return _c('label', {
      staticClass: "mt-radio",
      staticStyle: {
        "padding": "5px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.response.questions[_vm.question_index].value),
        expression: "response.questions[question_index].value"
      }],
      attrs: {
        "type": "radio",
        "name": "optionsRadios[]",
        "id": 'question' + _vm.quiz.questions[_vm.question_index].id,
        "required": _vm.response.questions[_vm.question_index].noResponse != true
      },
      domProps: {
        "value": scale,
        "checked": _vm._q(_vm.response.questions[_vm.question_index].value, scale)
      },
      on: {
        "change": function($event) {
          _vm.inputChange(_vm.question_index)
        },
        "__c": function($event) {
          _vm.response.questions[_vm.question_index].value = scale
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "num_scale"
    }, [_vm._v(_vm._s(scale))]), _vm._v(" "), _c('span')])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.quiz.questions[_vm.question_index].type == 'text') ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.response.questions[_vm.question_index].value),
      expression: "response.questions[question_index].value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "5",
      "placeholder": "",
      "id": 'question' + _vm.quiz.questions[_vm.question_index].id,
      "required": _vm.response.questions[_vm.question_index].noResponse != true
    },
    domProps: {
      "value": (_vm.response.questions[_vm.question_index].value)
    },
    on: {
      "change": function($event) {
        _vm.inputChange(_vm.question_index)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.response.questions[_vm.question_index].value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mt-checkbox-inline text-right"
  }, [_c('label', {
    staticClass: "mt-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.response.questions[_vm.question_index].noResponse),
      expression: "response.questions[question_index].noResponse"
    }],
    attrs: {
      "type": "checkbox",
      "value": "option1"
    },
    domProps: {
      "checked": Array.isArray(_vm.response.questions[_vm.question_index].noResponse) ? _vm._i(_vm.response.questions[_vm.question_index].noResponse, "option1") > -1 : (_vm.response.questions[_vm.question_index].noResponse)
    },
    on: {
      "change": function($event) {
        _vm.reValidateInput('question' + _vm.quiz.questions[_vm.question_index].id, _vm.question_index)
      },
      "__c": function($event) {
        var $$a = _vm.response.questions[_vm.question_index].noResponse,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "option1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.response.questions[_vm.question_index].noResponse = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.response.questions[_vm.question_index].noResponse = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.response.questions[_vm.question_index].noResponse = $$c
        }
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "no-response"
  }, [_vm._v("« Ne se prononce pas »")]), _vm._v(" "), _c('span')])]), _vm._v(" "), (_vm.quiz.questions[_vm.question_index].type == 'checkbox_multiple' || _vm.quiz.questions[_vm.question_index].type == 'radio_multiple') ? _c('div', _vm._l((_vm.quiz.questions[_vm.question_index].data), function(data2, d) {
    return (_vm.response.questions[_vm.question_index].value && _vm.response.questions[_vm.question_index].value.toString().indexOf(data2.name) >= 0 && data2.question && data2.question.title) ? _c('div', [_c('em', {
      staticClass: "question_title"
    }, [_vm._v(_vm._s(data2.question.title))]), _c('br'), _c('br'), _vm._v(" "), (data2.question.description) ? _c('div', {
      staticClass: "mb-20"
    }, [_c('em', [_vm._v(_vm._s(data2.question.description))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group form-md-line-input col-xs-12",
      staticStyle: {
        "margin-top": "0px",
        "margin-bottom": "40px"
      }
    }, [_vm._m(6, true), _vm._v(" "), (data2.question.type == 'text') ? _c('div', {
      staticClass: "col-md-10"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.response.questions[_vm.question_index].data[d].value),
        expression: "response.questions[question_index].data[d].value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "rows": "5",
        "placeholder": "",
        "id": 'question' + d + _vm.quiz.questions[_vm.question_index].id,
        "required": _vm.response.questions[_vm.question_index].data[d].noResponse != true
      },
      domProps: {
        "value": (_vm.response.questions[_vm.question_index].data[d].value)
      },
      on: {
        "change": function($event) {
          _vm.inputChange(_vm.question_index, d)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.response.questions[_vm.question_index].data[d].value = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })]) : _vm._e(), _vm._v(" "), (data2.question.type == 'scale') ? _c('div', {
      staticClass: "col-md-10"
    }, [_c('div', {
      staticClass: "mt-radio-inline"
    }, _vm._l((_vm.response.questions[_vm.question_index].data[d].scaleRange), function(scale) {
      return _c('label', {
        staticClass: "mt-radio",
        staticStyle: {
          "padding": "5px"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.response.questions[_vm.question_index].data[d].value),
          expression: "response.questions[question_index].data[d].value"
        }],
        attrs: {
          "type": "radio",
          "id": 'question' + d + _vm.quiz.questions[_vm.question_index].id,
          "name": "optionsRadios3[]",
          "required": _vm.response.questions[_vm.question_index].data[d].noResponse != true
        },
        domProps: {
          "value": scale,
          "checked": _vm._q(_vm.response.questions[_vm.question_index].data[d].value, scale)
        },
        on: {
          "change": function($event) {
            _vm.inputChange(_vm.question_index, d)
          },
          "__c": function($event) {
            _vm.response.questions[_vm.question_index].data[d].value = scale
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "num_scale"
      }, [_vm._v(_vm._s(scale))]), _vm._v(" "), _c('span')])
    }))]) : _vm._e(), _vm._v(" "), (data2.question.type == 'checkbox') ? _c('div', {
      staticClass: "col-md-10"
    }, [_c('div', {
      staticClass: "mt-checkbox-list text-left"
    }, _vm._l((data2.question.data), function(data3, d3_index) {
      return _c('label', {
        staticClass: "mt-checkbox"
      }, [_vm._v(" " + _vm._s(data3.name) + "\n                          "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.response.questions[_vm.question_index].data[d].value),
          expression: "response.questions[question_index].data[d].value"
        }],
        attrs: {
          "type": "checkbox",
          "id": 'question' + d + _vm.quiz.questions[_vm.question_index].id,
          "name": "check3[]",
          "required": _vm.response.questions[_vm.question_index].data[d].noResponse != true
        },
        domProps: {
          "value": data3.name,
          "checked": Array.isArray(_vm.response.questions[_vm.question_index].data[d].value) ? _vm._i(_vm.response.questions[_vm.question_index].data[d].value, data3.name) > -1 : (_vm.response.questions[_vm.question_index].data[d].value)
        },
        on: {
          "change": function($event) {
            _vm.inputChange(_vm.question_index, d)
          },
          "__c": function($event) {
            var $$a = _vm.response.questions[_vm.question_index].data[d].value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = data3.name,
                $$i = _vm._i($$a, $$v);
              if ($$c) {
                $$i < 0 && (_vm.response.questions[_vm.question_index].data[d].value = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.response.questions[_vm.question_index].data[d].value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.response.questions[_vm.question_index].data[d].value = $$c
            }
          }
        }
      }), _vm._v(" "), _c('span')])
    }))]) : _vm._e(), _vm._v(" "), (data2.question.type == 'radio') ? _c('div', {
      staticClass: "col-md-10"
    }, [_c('div', {
      staticClass: "mt-radio-list text-left"
    }, _vm._l((data2.question.data), function(data3, d3_index) {
      return _c('label', {
        staticClass: "mt-radio"
      }, [_vm._v(" " + _vm._s(data3.name) + "\n                          "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.response.questions[_vm.question_index].data[d].value),
          expression: "response.questions[question_index].data[d].value"
        }],
        attrs: {
          "type": "radio",
          "id": 'question' + d + _vm.quiz.questions[_vm.question_index].id,
          "name": "radio3[]",
          "required": _vm.response.questions[_vm.question_index].data[d].noResponse != true
        },
        domProps: {
          "value": data3.name,
          "checked": _vm._q(_vm.response.questions[_vm.question_index].data[d].value, data3.name)
        },
        on: {
          "change": function($event) {
            _vm.inputChange(_vm.question_index, d)
          },
          "__c": function($event) {
            _vm.response.questions[_vm.question_index].data[d].value = data3.name
          }
        }
      }), _vm._v(" "), _c('span')])
    }))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "mt-checkbox-inline text-right"
    }, [_c('label', {
      staticClass: "mt-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.response.questions[_vm.question_index].data[d].noResponse),
        expression: "response.questions[question_index].data[d].noResponse"
      }],
      attrs: {
        "type": "checkbox",
        "value": "option1"
      },
      domProps: {
        "checked": Array.isArray(_vm.response.questions[_vm.question_index].data[d].noResponse) ? _vm._i(_vm.response.questions[_vm.question_index].data[d].noResponse, "option1") > -1 : (_vm.response.questions[_vm.question_index].data[d].noResponse)
      },
      on: {
        "change": function($event) {
          _vm.reValidateInput('question' + d + _vm.quiz.questions[_vm.question_index].id, _vm.question_index, d)
        },
        "__c": function($event) {
          var $$a = _vm.response.questions[_vm.question_index].data[d].noResponse,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "option1",
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.response.questions[_vm.question_index].data[d].noResponse = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.response.questions[_vm.question_index].data[d].noResponse = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.response.questions[_vm.question_index].data[d].noResponse = $$c
          }
        }
      }
    }), _vm._v(" "), _c('em', {
      staticClass: "no-response"
    }, [_vm._v("« Ne se prononce pas »")]), _vm._v(" "), _c('span')])])]) : _vm._e()
  })) : _vm._e(), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-left mt-50"
  }, [_c('a', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        _vm.removeError();
        _vm.question_index--
      }
    }
  }, [_vm._v("Précédent")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-center mt-50"
  }, [_vm._v("\n            " + _vm._s(((_vm.question_index + 1) / _vm.quiz.questions.length * 100).toFixed()) + "% des questions complétées.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-right mt-50"
  }, [(_vm.question_index == _vm.quiz.questions.length - 1) ? _c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.sendQuiz()
      }
    }
  }, [_vm._v("Valider et envoyer le questionnaire")]) : _c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.validateQuestion()
      }
    }
  }, [_vm._v("Suivant")])])])]) : _vm._e(), _vm._v(" "), (_vm.isFinish) ? _c('div', {
    staticClass: "col-xs-12 col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "text-left note note-success mt-30"
  }, [_c('h4', {
    staticClass: "block"
  }, [_vm._v(" Le questionnaire a été validé. ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.quiz.conclusion))])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.quiz) ? _c('div', {
    staticClass: "row m-0 page-404-full-page"
  }, [_vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.error != '') ? _c('div', {
    staticClass: "row m-0 page-404-full-page"
  }, [_c('div', {
    staticClass: "col-md-12 page-404 pb-100"
  }, [_c('div', {
    staticClass: "number error font-green"
  }, [_vm._v(" Erreur ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Une erreur est survenue")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.error) + "\n                "), _c('br')])])])]) : _vm._e(), _vm._v(" "), _vm._m(9)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    staticClass: "logo-default",
    attrs: {
      "src": __webpack_require__(10),
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Prénom\n                "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Nom\n                "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group form-md-line-input",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Date de naissance\n                "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control form-control-inline date-picker",
    attrs: {
      "id": "date_birthday",
      "type": "text",
      "value": "",
      "required": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Cette information est demandée pour éviter les doublons dans les réponses.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 mt-50"
  }, [_c('span', {
    staticClass: "required",
    staticStyle: {
      "color": "#6b500f"
    },
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("**")]), _vm._v(" "), _c('em', [_vm._v(" Ces informations ne seront pas utilisées à des fins commerciales.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Réponse\n              "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Réponse\n                  "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 mt-50"
  }, [_c('span', {
    staticClass: "required text-danger",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('em', [_vm._v("Tous les champs sont obligatoires et doivent être remplis pour pouvoir valider le questionnaire.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 page-404 pb-100"
  }, [_c('div', {
    staticClass: "number font-green"
  }, [_vm._v(" 404 ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Questionnaire non trouvé.")]), _vm._v(" "), _c('p', [_vm._v(" Nous n'avons pas réussi à trouver ce questionnaire.\n                "), _c('br'), _vm._v("\n                Vérifiez l'url et tentez de recharger la page.\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer"
  }, [_c('div', {
    staticClass: "page-footer-inner mt-10"
  }, [_vm._v(" 2017 © TransfeRH  | \n          Site réalisé par "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://lewebfrancais.fr"
    }
  }, [_vm._v("Le Web Français")])]), _vm._v(" "), _c('div', {
    staticClass: "scroll-to-top"
  }, [_c('i', {
    staticClass: "icon-arrow-up"
  })])])
}]}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.quiz) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "mt-element-step"
  }, [_c('div', {
    staticClass: "row step-background-thin"
  }, [_c('div', {
    staticClass: "col-md-4 bg-grey-steel mt-step-col pointer",
    class: {
      'active': _vm.show.quiz, 'disabled': _vm.quiz.state == 'published'
    },
    on: {
      "click": function($event) {
        _vm.goStep('quiz')
      }
    }
  }, [_c('div', {
    staticClass: "mt-step-number"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "mt-step-title uppercase font-grey-cascade"
  }, [_vm._v("Questionnaire")]), _vm._v(" "), _c('div', {
    staticClass: "mt-step-content font-grey-cascade"
  }, [_vm._v("Configuration des paramètres du questionnaire")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 bg-grey-steel mt-step-col pointer",
    class: {
      'active': _vm.show.questions, 'disabled': !_vm.quiz.slug || _vm.quiz.state == 'published'
    },
    on: {
      "click": function($event) {
        _vm.goStep('questions')
      }
    }
  }, [_c('div', {
    staticClass: "mt-step-number"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "mt-step-title uppercase font-grey-cascade"
  }, [_vm._v("Questions")]), _vm._v(" "), _c('div', {
    staticClass: "mt-step-content font-grey-cascade"
  }, [_vm._v("Configuration des questions")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 bg-grey-steel mt-step-col pointer",
    class: {
      'active': _vm.show.share, 'disabled': !_vm.quiz.slug || _vm.quiz.questions.length <= 0 || _vm.quiz.state == 'published'
    },
    on: {
      "click": function($event) {
        _vm.goStep('share')
      }
    }
  }, [_c('div', {
    staticClass: "mt-step-number"
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "mt-step-title uppercase font-grey-cascade"
  }, [_vm._v("Partage")]), _vm._v(" "), _c('div', {
    staticClass: "mt-step-content font-grey-cascade"
  }, [_vm._v("Envoyer votre formulaire aux participants")])])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet light portlet-fit portlet-form bordered col-xs-12 p-0"
  }, [_c('div', {
    staticClass: "portlet-body col-xs-12 mt-30"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', [_vm._v("Etat : "), _c('div', {
    staticStyle: {
      "display": "inline"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.getState)
    }
  })])]), _vm._v(" "), (_vm.show.quiz) ? _c('create-quiz', {
    ref: "create",
    attrs: {
      "quiz": _vm.quiz
    },
    on: {
      "update:quiz": function($event) {
        _vm.quiz = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show.questions) ? _c('create-questions', {
    ref: "questions",
    attrs: {
      "quiz": _vm.quiz,
      "show": _vm.show
    },
    on: {
      "update:quiz": function($event) {
        _vm.quiz = $event
      },
      "update:show": function($event) {
        _vm.show = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show.share) ? _c('share-quiz', {
    attrs: {
      "quiz": _vm.quiz
    },
    on: {
      "update:quiz": function($event) {
        _vm.quiz = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-actions col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('a', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), (!_vm.show.quiz && _vm.quiz.state != 'published') ? _c('a', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        _vm.show.share ? _vm.goStep('questions') : _vm.goStep('quiz')
      }
    }
  }, [_vm._v("Précédent")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.quiz.questions && _vm.quiz.questions.length > 0 && _vm.quiz.state != 'published') ? _c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.saveQuiz(false, 'published')
      }
    }
  }, [_vm._v("Publier")]) : _vm._e(), _vm._v(" "), (!_vm.show.share) ? _c('a', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        _vm.saveQuiz(true)
      }
    }
  }, [_vm._v("Enregistrer & Quitter")]) : _vm._e(), _vm._v(" "), (!_vm.show.share) ? _c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.saveQuiz(false)
      }
    }
  }, [_vm._v("Enregistrer")]) : _vm._e(), _vm._v(" "), (_vm.show.share) ? _c('router-link', {
    staticClass: "btn btn default",
    attrs: {
      "to": {
        name: 'quizzes_list'
      }
    }
  }, [_vm._v("Quitter")]) : _vm._e()], 1)])])])], 1)])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 page-404"
  }, [_c('div', {
    staticClass: "number font-green"
  }, [_vm._v(" 404 ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Questionnaire non trouvé.")]), _vm._v(" "), _c('p', [_vm._v(" Nous n'avons pas réussi à trouver ce questionnaire.\n                "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'quizzes_list'
      }
    }
  }, [_vm._v(" Retourner à la liste des questionnaires ")]), _vm._v(" ou essayer de recharger la page.\n            ")], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "forget-form",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "formForgetPassword"
    }
  }, [_c('h3', {
    staticClass: "font-green"
  }, [_vm._v("Mot de passe oublié ?")]), _vm._v(" "), _c('p', [_vm._v(" Entrer l'email de votre compte pour réinitialiser votre mot de passe. ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control placeholder-no-fix",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Email",
      "required": "",
      "data-parsley-type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('a', {
    staticClass: "btn yellow btn-outline",
    attrs: {
      "type": "button",
      "id": "back-btn"
    },
    on: {
      "click": function($event) {
        _vm.show.login = true
      }
    }
  }, [_vm._v("Retour")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success uppercase pull-right",
    on: {
      "click": function($event) {
        _vm.sendEmail()
      }
    }
  }, [_vm._v("Envoyer")])])])])
},staticRenderFns: []}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), (_vm.quiz) ? _c('div', {
    staticClass: "col-xs-12 mt-30 mb-30"
  }, [_c('div', {
    staticClass: "portlet light portlet-fit portlet-form bordered col-xs-12 p-0 "
  }, [_c('div', {
    staticClass: "portlet-title col-xs-12 "
  }, [_c('div', {
    staticClass: "caption tabbable-line p-0"
  }, [_c('ul', {
    staticClass: "nav nav-tabs "
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.show.table = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-layers"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Tableau ")])])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.report = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-note"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Rapport")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body col-xs-12 mb-30"
  }, [_c('list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.table),
      expression: "show.table"
    }],
    staticClass: "mt-30",
    attrs: {
      "columns": _vm.columns,
      "dataSet": _vm.dataSet
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.report),
      expression: "show.report"
    }],
    staticClass: "col-xs-12"
  }, [_c('report-preconization', {
    attrs: {
      "preconizations": _vm.preconizations
    },
    on: {
      "update:preconizations": function($event) {
        _vm.preconizations = $event
      }
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "btn btn-circle default mt-20 ml-10",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("\n             Retour\n          ")])], 1)])]) : _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-md-12 page-404 mt-50 pb-50"
  }, [_c('div', {
    staticClass: "number font-green"
  }, [_vm._v(" 404 ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Questionnaire non trouvé.")]), _vm._v(" "), _c('p', [_vm._v(" Nous n'avons pas réussi à trouver ce questionnaire.\n                "), _c('br'), _vm._v("\n                Vérifiez'url et tentez de recharger la page.\n            ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_vm._v("Etude du Web Français Bdx : Synthèse des préconisations ")])])
}]}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.quizObj && _vm.quizObj.quiz) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 mb-10"
  }, [_c('h1', [_vm._v(_vm._s(_vm.quizObj.quiz.title) + " : Configuration de l'export PDF")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_actions"
  }, [_c('h4', {
    staticClass: "widget-thumb-heading text-uppercase",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Contenu")]), _vm._v(" "), _c('div', {
    staticClass: "widget-thumb-wrap"
  }, [_c('div', {
    staticClass: "mt-checkbox-list",
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('label', {
    staticClass: "mt-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show.report),
      expression: "show.report"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show.report) ? _vm._i(_vm.show.report, null) > -1 : (_vm.show.report)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.show.report,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.show.report = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.show.report = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show.report = $$c
        }
      }
    }
  }), _vm._v(" Rapport de préconisation\n                      "), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show.analysis),
      expression: "show.analysis"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show.analysis) ? _vm._i(_vm.show.analysis, null) > -1 : (_vm.show.analysis)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.show.analysis,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.show.analysis = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.show.analysis = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show.analysis = $$c
        }
      }
    }
  }), _vm._v(" Analyse du questionnaire\n                      "), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show.participants),
      expression: "show.participants"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show.participants) ? _vm._i(_vm.show.participants, null) > -1 : (_vm.show.participants)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.show.participants,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.show.participants = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.show.participants = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show.participants = $$c
        }
      }
    }
  }), _vm._v(" Tableau des participants\n                      "), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show.responses),
      expression: "show.responses"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show.responses) ? _vm._i(_vm.show.responses, null) > -1 : (_vm.show.responses)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.show.responses,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.show.responses = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.show.responses = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show.responses = $$c
        }
      }
    }
  }), _vm._v(" Réponses ouvertes\n                      "), _c('span')]), _vm._v(" "), _c('label', {
    staticClass: "mt-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show.graph),
      expression: "show.graph"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.show.graph) ? _vm._i(_vm.show.graph, null) > -1 : (_vm.show.graph)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.show.graph,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.show.graph = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.show.graph = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show.graph = $$c
        }
      }
    }
  }), _vm._v(" Graphiques\n                      "), _c('span')]), _vm._v(" "), (_vm.quizObj.quiz.responses.length > 0 && _vm.nbQuestionsOpenOutMultiple < _vm.quizObj.quiz.questions.length && _vm.show.graph == true) ? _c('div', {
    staticClass: "mb-20"
  }, [_c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllGraphType('détaillé');
      }
    }
  }, [_vm._v("Graphiques simples")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllGraphType('simple');
      }
    }
  }, [_vm._v("Graphiques détaillés")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "mt-10 btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllLegendesType('below');
      }
    }
  }, [_vm._v("Légendes en dessous")]), _vm._v(" "), _c('a', {
    staticClass: "mt-10 btn btn-xs default",
    on: {
      "click": function($event) {
        _vm.changeAllLegendesType('above');
      }
    }
  }, [_vm._v("Légendes superposées")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 "
  }, [_c('div', {
    staticClass: "widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_actions"
  }, [_c('h4', {
    staticClass: "widget-thumb-heading text-uppercase"
  }, [_vm._v("Filtre")]), _vm._v(" "), _c('div', {
    staticClass: "widget-thumb-wrap"
  }, [_c('div', {
    staticClass: "mt-checkbox-list"
  }, _vm._l((_vm.quizObj.quiz.groups), function(group) {
    return _c('label', {
      staticClass: "mt-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.quizObj.filters),
        expression: "quizObj.filters"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": group,
        "checked": Array.isArray(_vm.quizObj.filters) ? _vm._i(_vm.quizObj.filters, group) > -1 : (_vm.quizObj.filters)
      },
      on: {
        "change": function($event) {
          _vm.refresh()
        },
        "__c": function($event) {
          var $$a = _vm.quizObj.filters,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = group,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.quizObj.filters = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.quizObj.filters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.quizObj.filters = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(group.name) + "\n                      "), _c('span')])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 "
  }, [_c('div', {
    staticClass: "widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_actions"
  }, [_c('h4', {
    staticClass: "widget-thumb-heading text-uppercase"
  }, [_vm._v("Actions")]), _vm._v(" "), _c('div', {
    staticClass: "widget-thumb-wrap"
  }, [_c('a', {
    staticClass: "btn btn-circle yellow",
    attrs: {
      "title": "Rapport PDF"
    },
    on: {
      "click": function($event) {
        _vm.exportPDF()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download fs-20",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Télécharger le PDF\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "hidden",
    attrs: {
      "id": "btPDF",
      "href": _vm.file_pdf.href,
      "download": _vm.file_pdf.name
    }
  }, [_vm._v("Télécharger le pdf")])])])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.quizObj && _vm.quizObj.quiz) ? _c('div', {
    staticClass: "row"
  }, [_c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Aperçu du PDF")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "width": "40em"
    }
  }, [_c('html', {
    attrs: {
      "id": "exportPdf"
    }
  }, [_c('head'), _vm._v(" "), _c('body', [(_vm.quizObj && _vm.quizObj.quiz) ? _c('div', {
    attrs: {
      "id": "bodyPDF"
    }
  }, [_c('div', {
    attrs: {
      "id": "pageHeader-first"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "cover"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "5em"
    }
  }, [_c('h2', [_vm._v("Export PDF")]), _vm._v(" "), _c('div', {
    staticClass: "mt-50 logo-transferh-full logo"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.quizObj.quiz.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Groupes de participants")]), _vm._v(" "), _vm._l((_vm.quizObj.filters), function(group) {
    return _c('span', [_vm._v("\n                      - " + _vm._s(group.name) + " "), _c('br')])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "hide-previous",
    attrs: {
      "id": "pageFooter"
    }
  }, [_vm._v("TransfeRH - " + _vm._s(_vm.quizObj.quiz.title) + " "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.getPages()))])]), _vm._v(" "), _c('div', {
    staticClass: "hide-previous",
    attrs: {
      "id": "pageHeader"
    }
  }, [_vm._v("TransfeRH - " + _vm._s(_vm.quizObj.quiz.title) + " "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("le " + _vm._s(_vm.dateNow))])]), _vm._v(" "), (_vm.show.report) ? _c('div', {
    staticClass: "page",
    attrs: {
      "id": "report_preconization"
    }
  }, [_c('report-preconization', {
    attrs: {
      "preconizations": _vm.quizObj.preconizations
    },
    on: {
      "update:preconizations": function($event) {
        _vm.quizObj.preconizations = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show.analysis) ? _c('div', {
    staticClass: "page",
    attrs: {
      "id": "analysis"
    }
  }, [_c('h2', [_vm._v("Analyse des questions ouvertes")]), _vm._v(" "), _vm._l((_vm.quizObj.quiz.questions), function(question, question_index) {
    return (question.type == 'text' || (question.type == 'checkbox_multiple' && _vm.haveText(question)) || (question.type == 'radio_multiple' && _vm.haveText(question))) ? _c('div', [_c('div', {
      staticClass: "p-0"
    }, [_c('div', {
      staticClass: "mb-20"
    }, [(question.type == 'text') ? _c('label', {
      staticClass: "p-0 control-label"
    }, [_c('h4', {
      staticClass: "p-0"
    }, [_vm._v(_vm._s(question.title))])]) : _vm._e(), _vm._v(" "), (question.type == 'checkbox_multiple' || question.type == 'radio_multiple') ? _c('label', {
      staticClass: "p-0 control-label"
    }, [_c('h4', {
      staticClass: "p-0"
    }, [_vm._v(_vm._s(question.title))])]) : _vm._e(), _vm._v(" "), (question.type == 'text') ? _c('div', {
      staticClass: "p-0",
      staticStyle: {
        "background-color": "#f1f1f1"
      }
    }, [(_vm.analysis && _vm.analysis.questions[question_index]) ? _c('span', {
      staticStyle: {
        "display": "block",
        "min-height": "30px"
      }
    }, [_vm._v(" " + _vm._s(_vm.analysis.questions[question_index].text))]) : _c('span', {
      staticStyle: {
        "display": "block",
        "height": "30px"
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((question.data), function(data, data_index) {
      return ((question.type == 'checkbox_multiple' || question.type == 'radio_multiple') && data.question && data.question.type == 'text') ? _c('div', [_c('label', {
        staticClass: "p-0 control-label"
      }, [_c('h5', {
        staticClass: "p-0"
      }, [_vm._v(_vm._s(data.name) + " : " + _vm._s(data.question.title))])]), _vm._v(" "), _c('div', {
        staticClass: "p-0",
        staticStyle: {
          "background-color": "#f1f1f1"
        }
      }, [(_vm.analysis && _vm.analysis.questions[question_index] && _vm.analysis.questions[question_index].data[data_index]) ? _c('span', {
        staticStyle: {
          "display": "block",
          "min-height": "30px"
        }
      }, [_vm._v(_vm._s(_vm.analysis.questions[question_index].data[data_index].text))]) : _c('span', {
        staticStyle: {
          "display": "block",
          "height": "30px"
        }
      })])]) : _vm._e()
    })], 2)])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.show.participants) ? _c('div', {
    staticClass: "page",
    attrs: {
      "id": "list_participants"
    }
  }, [_c('h2', [_vm._v("Liste des participants")]), _c('br'), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _vm._l((_vm.quizObj.quiz.responses), function(response) {
    return (_vm.filterParticipants(response.groupId) === true) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.getDate(response.created)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(response.firstname) + " " + _vm._s(response.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getGroup(response.groupId)))])]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.quizObj.nbResponses() <= 0) ? _c('div', {
    staticClass: "mt-20 text-center"
  }, [_vm._v("Aucun participant")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show.responses) ? _c('div', {
    staticClass: "page",
    attrs: {
      "id": "list_responses_open"
    }
  }, [_c('h2', [_vm._v("Liste des réponses ouvertes")]), _c('br'), _vm._v(" "), _c('table', [_c('tr', _vm._l((_vm.columnsRO), function(column) {
    return _c('th', [_vm._v(_vm._s(column.title))])
  })), _vm._v(" "), _vm._l((_vm.dataSetRO), function(data) {
    return _c('tr', {
      class: _vm.getClass(data)
    }, _vm._l((data), function(col, index) {
      return (index == 0 || data[index - 1].toString().indexOf('colspan-') < 0) ? _c('td', {
        class: {
          'tr-green-light': data.toString().indexOf('tr-green') >= 0
        },
        attrs: {
          "colspan": col.toString().indexOf('colspan-') >= 0 ? parseInt(col.toString().substring(col.toString().indexOf('colspan-') + 8)) : 0
        },
        domProps: {
          "innerHTML": _vm._s(col)
        }
      }) : _vm._e()
    }))
  })], 2), _vm._v(" "), (_vm.nbQuestionsOpen <= 0) ? _c('div', {
    staticClass: "mt-20 text-center"
  }, [_vm._v("Aucune question ouverte pour ce questionnaire.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show.graph) ? _c('div', {
    staticClass: "page",
    attrs: {
      "id": "graphiques"
    }
  }, [_vm._l((_vm.quizObj.quiz.questions), function(question, index) {
    return (_vm.quizObj.quiz.questions) ? _c('div', [(question.type != 'text') ? _c('div', [_c('div', {
      staticClass: "p-0 ml-10 hide-pdf",
      staticStyle: {
        "margin-top": "-30px",
        "position": "relative",
        "top": "30px",
        "left": "-270px"
      }
    }, [_c('a', {
      staticClass: "btn btn-xs default",
      on: {
        "click": function($event) {
          _vm.changeGraphType(question);
        }
      }
    }, [_vm._v("Graphique " + _vm._s(question.graphType) + " "), (!question.graphType) ? _c('span', [_vm._v("simple")]) : _vm._e()]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-xs default",
      on: {
        "click": function($event) {
          _vm.changeLegendeType(question);
        }
      }
    }, [_vm._v("Légende "), (!question.legendeType || question.legendeType == 'below') ? _c('span', [_vm._v("superposée")]) : _c('span', [_vm._v("en dessous")])])]), _vm._v(" "), _c('div', {
      staticClass: "text-center bloc_graphique"
    }, [_c('h4', [_vm._v("N°" + _vm._s(question.order + 1) + " - " + _vm._s(question.title))]), _vm._v(" "), _c('em', [_vm._v(_vm._s(question.description))]), _vm._v(" "), _c('div', {
      staticClass: "graph",
      staticStyle: {
        "padding-top": "20px",
        "height": "230px"
      },
      attrs: {
        "id": 'container' + question.id + '-' + _vm.number
      }
    }, [_vm._v("Aucune réponse")])]), _vm._v(" "), _vm._l((question.data), function(data) {
      return (data.question && data.question.title && data.question.type != 'text') ? _c('div', {
        staticClass: "text-center bloc_graphique"
      }, [_c('h5', [_vm._v(_vm._s(data.question.title))]), _vm._v(" "), _c('div', {
        staticClass: "text-left ml-10 hide-pdf",
        staticStyle: {
          "margin-top": "-30px",
          "position": "relative",
          "top": "-30px",
          "left": "-270px",
          "z-index": "9999"
        }
      }, [_c('a', {
        staticClass: "btn btn-xs default",
        on: {
          "click": function($event) {
            _vm.changeGraphType(data.question, question);
          }
        }
      }, [_vm._v("Graphique " + _vm._s(data.question.graphType) + " "), (!data.question.graphType) ? _c('span', [_vm._v("simple")]) : _vm._e()]), _vm._v(" "), _c('a', {
        staticClass: "btn btn-xs default",
        on: {
          "click": function($event) {
            _vm.changeLegendeType(data.question, question);
          }
        }
      }, [_vm._v("Légende "), (!data.question.legendeType || data.question.legendeType == 'below') ? _c('span', [_vm._v("superposée")]) : _c('span', [_vm._v("en dessous")])])]), _vm._v(" "), _c('div', {
        staticClass: "graph",
        staticStyle: {
          "padding-top": "20px",
          "height": "230px"
        },
        attrs: {
          "id": 'container_child' + data.id + '-' + _vm.number
        }
      }, [_vm._v("Aucune réponse")])]) : _vm._e()
    })], 2) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.quizObj.quiz.questions && _vm.nbQuestionsOpenOutMultiple >= _vm.quizObj.quiz.questions.length) ? _c('div', {
    staticClass: "m-30"
  }, [_vm._v("\n                  Ce questionnaire ne contient que des questions ouvertes !\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.quizObj.quiz.questions || (_vm.quizObj.quiz.questions && _vm.quizObj.quiz.questions.length <= 0)) ? _c('div', {
    staticClass: "p-0 text-center"
  }, [_c('h3', [_vm._v("Aucune questions à ce questionnaire !")])]) : _vm._e()], 2) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center mb-30 mt-30 "
  }, [_c('a', {
    staticClass: "btn btn-circle yellow",
    attrs: {
      "title": "Rapport PDF"
    },
    on: {
      "click": function($event) {
        _vm.exportPDF()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download fs-20",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Télécharger le PDF\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "hidden",
    attrs: {
      "id": "btPDF",
      "href": _vm.file_pdf.href,
      "download": _vm.file_pdf.name
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "55px",
      "right": "20px"
    }
  }, [_c('a', {
    staticClass: "btn btn-circle yellow",
    attrs: {
      "title": "Rapport PDF"
    },
    on: {
      "click": function($event) {
        _vm.exportPDF()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download fs-20",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "hidden",
    attrs: {
      "id": "btPDF",
      "href": _vm.file_pdf.href,
      "download": _vm.file_pdf.name
    }
  })])]) : _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-md-12 page-404 mt-50"
  }, [_c('div', {
    staticClass: "number font-green"
  }, [_vm._v(" 404 ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Questionnaire non trouvé.")]), _vm._v(" "), _c('p', [_vm._v(" Nous n'avons pas réussi à trouver ce questionnaire.\n                "), _c('br'), _vm._v("\n                Vérifiez l'url et tentez de recharger la page.\n            ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3 "
  }, [_c('div', {
    staticClass: "widget-thumb widget-bg-color-white margin-bottom-20 bordered bg-gray bloc_actions"
  }, [_c('h4', {
    staticClass: "widget-thumb-heading text-uppercase"
  }, [_vm._v("Informations")]), _vm._v(" "), _c('div', {
    staticClass: "widget-thumb-wrap text-info"
  }, [_c('span', {
    staticClass: "icon-info",
    staticStyle: {
      "font-size": "20px",
      "margin": "10px 10px 10px 0px",
      "float": "left"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              L'en tête et le pied de page du fichier ne sont pas visible lors de l'aperçu du PDF.\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Date de réponse")]), _vm._v(" "), _c('th', [_vm._v("Prénom Nom")]), _vm._v(" "), _c('th', [_vm._v("Groupe")])])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal col-xs-12 absolute-parlsey-errors",
    attrs: {
      "id": "form_quiz_create"
    }
  }, [_c('div', {
    staticClass: "form-body col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quiz.title),
      expression: "quiz.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "required": "",
      "disabled": _vm.quiz.slug
    },
    domProps: {
      "value": (_vm.quiz.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quiz.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Le titre du questionnaire ne pourra pas être modifié après l'enregistrement.")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Instructions\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quiz.instructions),
      expression: "quiz.instructions"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.quiz.instructions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quiz.instructions = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Texte de conclusion\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quiz.conclusion),
      expression: "quiz.conclusion"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.quiz.conclusion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quiz.conclusion = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h5', [_vm._v("Entreprise")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_vm._m(2), _vm._v(" "), (_vm.quiz.company) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quiz.company.name),
      expression: "quiz.company.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.quiz.company.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quiz.company.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })]) : _vm._e()]), _vm._v(" "), _c('h5', [_vm._v("Groupes")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._l((_vm.quiz.groups), function(group, index_groups) {
    return _c('div', {
      staticClass: "form-group form-md-line-input"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.name),
        expression: "group.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": "",
        "data-parsley-errors-messages-disabled": ""
      },
      domProps: {
        "value": (group.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.name = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })])]), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.nb_participants),
        expression: "group.nb_participants"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0",
        "required": "",
        "data-parsley-errors-messages-disabled": ""
      },
      domProps: {
        "value": (group.nb_participants)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.nb_participants = $event.target.value
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-control-focus"
    })])])
  }), _vm._v(" "), _c('a', {
    staticClass: "ml-55",
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.quiz.groups.push({
          name: '',
          nb_participants: 0
        });
        _vm.forceUpdate()
      }
    }
  }, [_c('span', {
    staticClass: "icon-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ajouter un groupe")]), _vm._v(" "), (_vm.quiz.groups) ? _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quiz.groups.length > 1),
      expression: "quiz.groups.length > 1"
    }],
    staticClass: "ml-55 text-danger",
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.removeGroup()
      }
    }
  }, [_c('span', {
    staticClass: "icon-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Retirer le dernier groupe")]) : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Titre\n                  "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group form-md-line-input"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Date limite des réponses\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control form-control-inline date-picker",
    attrs: {
      "id": "date_deadline",
      "type": "text",
      "value": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Les utilisateurs pourront encore répondre le jour de la date limite.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nom\n              "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('em', {
    staticClass: "info col-xs-12"
  }, [_c('span', {
    staticClass: "icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 0 équivaut à un nombre illimité de participants.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-xs-2 control-label"
  }, [_vm._v("Nom\n              "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-xs-3 control-label"
  }, [_vm._v("Participants\n              "), _c('span', {
    staticClass: "required",
    attrs: {
      "aria-required": "true"
    }
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loading || _vm.progressBar.enabled) ? _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "uil-default-css",
    staticStyle: {
      "transform": "scale(0.7)"
    }
  }, [_c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(0deg) translate(0,-60px)",
      "transform": "rotate(0deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(30deg) translate(0,-60px)",
      "transform": "rotate(30deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(60deg) translate(0,-60px)",
      "transform": "rotate(60deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(90deg) translate(0,-60px)",
      "transform": "rotate(90deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(120deg) translate(0,-60px)",
      "transform": "rotate(120deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(150deg) translate(0,-60px)",
      "transform": "rotate(150deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(180deg) translate(0,-60px)",
      "transform": "rotate(180deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(210deg) translate(0,-60px)",
      "transform": "rotate(210deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(240deg) translate(0,-60px)",
      "transform": "rotate(240deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(270deg) translate(0,-60px)",
      "transform": "rotate(270deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(300deg) translate(0,-60px)",
      "transform": "rotate(300deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(330deg) translate(0,-60px)",
      "transform": "rotate(330deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.loadingText))]), _vm._v(" "), (_vm.progressBar.enabled) ? _c('div', {
    staticClass: "progress mt-10"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-striped active",
    style: ({
      width: _vm.progressBar.pourcentage + '%'
    }),
    attrs: {
      "id": "progressBar",
      "role": "progressbar",
      "aria-valuenow": _vm.progressBar.value,
      "aria-valuemin": _vm.progressBar.min,
      "aria-valuemax": _vm.progressBar.max
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "50%",
      "margin": "auto",
      "color": "black"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.progressBar.txt) + "\n        ")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.data || (_vm.data && _vm.data.session && !_vm.data.session.authenticated) || _vm.$route.name == 'login' || _vm.$route.name == 'quizzes_show') ? _c('router-view') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.data && _vm.data.session && _vm.data.session.authenticated) && _vm.$route.name != 'login' && _vm.$route.name != 'quizzes_show'),
      expression: "(data && data.session && data.session.authenticated) && $route.name != 'login' && $route.name != 'quizzes_show'"
    }],
    staticClass: "page-header-fixed page-sidebar-closed-hide-logo page-content-white"
  }, [_c('div', {
    staticClass: "page-header navbar navbar-fixed-top"
  }, [_c('div', {
    staticClass: "page-header-inner "
  }, [_c('div', {
    staticClass: "page-logo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('img', {
    staticClass: "logo-default",
    attrs: {
      "src": __webpack_require__(78),
      "alt": "logo"
    }
  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "top-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.user.role == 'dev'),
      expression: "data.user.role == 'dev'"
    }],
    staticClass: "role_user"
  }, [_c('span', {
    staticClass: "label label-sm label-success"
  }, [_vm._v("Développeur")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown dropdown-user"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown",
      "data-hover": "dropdown",
      "data-close-others": "true"
    }
  }, [_c('span', {
    staticClass: "username username-hide-on-mobile"
  }, [_vm._v(" " + _vm._s(_vm.data.user.firstname) + " " + _vm._s(_vm.data.user.lastname) + " ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-default"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" Mon compte")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.logout(true)
      }
    }
  }, [_c('i', {
    staticClass: "icon-logout"
  }), _vm._v(" Se déconnecter\n                                ")])])])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown dropdown-quick-sidebar-toggler",
    on: {
      "click": function($event) {
        _vm.logout(true)
      }
    }
  }, [_vm._m(2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "page-sidebar-wrapper"
  }, [_c('div', {
    staticClass: "page-sidebar navbar-collapse collapse fixed"
  }, [_c('ul', {
    staticClass: "page-sidebar-menu  page-header-fixed",
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "data-keep-expanded": "false",
      "data-auto-scroll": "true",
      "data-slide-speed": "200"
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', {
    staticClass: "nav-item start",
    class: {
      'active': _vm.$route.matched[0].name == 'quizzes', 'open': _vm.$route.matched[0].name == 'quizzes'
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "icon-note"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Questionnaires")]), _vm._v(" "), _c('span', {
    staticClass: "arrow open"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.matched[0].name == 'quizzes'),
      expression: "$route.matched[0].name == 'quizzes'"
    }],
    staticClass: "selected"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.$route.name == 'quizzes_create', 'open': _vm.$route.name == 'quizzes_create'
    }
  }, [_c('router-link', {
    key: _vm.$route.fullPath,
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'quizzes_create'
      }
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Créer")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.$route.name == 'quizzes_list', 'open': _vm.$route.name == 'quizzes_list'
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'quizzes_list'
      }
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Liste")])])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.$route.matched[0].name == 'compare', 'open': _vm.$route.matched[0].name == 'compare'
    }
  }, [_c('router-link', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "to": {
        name: 'compare'
      }
    }
  }, [_c('i', {
    staticClass: "icon-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Comparaison")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.matched[0].name == 'compare'),
      expression: "$route.matched[0].name == 'compare'"
    }],
    staticClass: "selected"
  })])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.user.role == 'dev'),
      expression: "data.user.role == 'dev'"
    }],
    staticClass: "nav-item",
    class: {
      'active': _vm.$route.matched[0].name == 'users', 'open': _vm.$route.matched[0].name == 'users'
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "icon-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Utilisateurs")]), _vm._v(" "), _c('span', {
    staticClass: "arrow open"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.matched[0].name == 'users'),
      expression: "$route.matched[0].name == 'users'"
    }],
    staticClass: "selected"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.$route.name == 'users_create', 'open': _vm.$route.name == 'users_create'
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'users_create'
      }
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Créer")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.$route.name == 'users_list', 'open': _vm.$route.name == 'users_list'
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'users_list'
      }
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Liste")])])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "heading"
  }, [_c('h3', {}, [_vm._v("Version " + _vm._s(_vm.version))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "page-content"
  }, [(_vm.$route.name != 'quizzes_show' && _vm.$route.name != 'login') ? _c('router-view') : _vm._e()], 1)])]), _vm._v(" "), _vm._m(5)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-toggler sidebar-toggler"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "menu-toggler responsive-toggler",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle"
  }, [_c('i', {
    staticClass: "icon-logout"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "sidebar-toggler-wrapper hide"
  }, [_c('div', {
    staticClass: "sidebar-toggler"
  }, [_c('span')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "heading"
  }, [_c('h3', {
    staticClass: "uppercase"
  }, [_vm._v("Fonctionalités")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer mt-10"
  }, [_c('div', {
    staticClass: "page-footer-inner"
  }, [_vm._v(" 2017 © TransfeRH  | \n            Site réalisé par "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://lewebfrancais.fr"
    }
  }, [_vm._v("Le Web Français")])]), _vm._v(" "), _c('div', {
    staticClass: "scroll-to-top"
  }, [_c('i', {
    staticClass: "icon-arrow-up"
  })])])
}]}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.quiz) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.quiz.title) + " : Préconisations & Analyses")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 mt-20"
  }, [(_vm.quiz) ? _c('div', {
    staticClass: "portlet light portlet-fit portlet-form bordered col-xs-12 p-0"
  }, [_c('div', {
    staticClass: "portlet-title col-xs-12 "
  }, [_c('div', {
    staticClass: "caption tabbable-line p-0"
  }, [_c('ul', {
    staticClass: "nav nav-tabs "
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.show.list_actions = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-layers"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Actions ")])])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.analysis = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-note"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Analyse")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body col-xs-12"
  }, [(_vm.show.analysis) ? _c('analysis') : _vm._e(), _vm._v(" "), (_vm.show.list_actions) ? _c('list-actions', {
    attrs: {
      "quiz": _vm.quiz
    },
    on: {
      "update:quiz": function($event) {
        _vm.quiz = $event
      }
    }
  }) : _vm._e()], 1)]) : _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-md-12 page-404 mt-50 pb-50"
  }, [_c('div', {
    staticClass: "number font-green"
  }, [_vm._v(" 404 ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Questionnaire non trouvé.")]), _vm._v(" "), _c('p', [_vm._v(" Nous n'avons pas réussi à trouver ce questionnaire.\n                      "), _c('br'), _vm._v("\n                      Vérifiez'url et tentez de recharger la page.\n                  ")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Rapport de préconisation ")]), _c('br'), _vm._v(" "), _vm._l((_vm.preconizations), function(preconization, index) {
    return _c('div', [_c('h3', {
      class: {
        'mt-30': index != 0
      }
    }, [_vm._v(_vm._s(preconization.number) + ". " + _vm._s(preconization.title) + " ")]), _vm._v(" "), (preconization.description) ? _c('span', {
      staticClass: "ml-10 mt-10"
    }, [_vm._v(_vm._s(preconization.description)), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((preconization.actions), function(action) {
      return _c('div', [_c('h4', {
        staticClass: "ml-20"
      }, [_vm._v(_vm._s(action.number) + " " + _vm._s(action.title))]), _vm._v(" "), (action.description) ? _c('div', {
        staticClass: "ml-50 mt-10",
        domProps: {
          "innerHTML": _vm._s(_vm.getDescription(action.description))
        }
      }) : _vm._e(), _vm._v(" "), (action.deadline) ? _c('h5', {
        staticClass: "ml-50"
      }, [_vm._v("Délai de réalisation : " + _vm._s(action.deadline) + " ")]) : _vm._e()])
    })], 2)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "tile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile-body"
  }, [_c('list', {
    attrs: {
      "columns": _vm.columns,
      "dataSet": _vm.dataSet
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile-header dvd dvd-btm"
  }, [_c('h1', [_vm._v("Liste des utilisateurs")])])
}]}

/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[42]);


// WEBPACK FOOTER //
// static/js/app.717316d913a0f2deb056.js